const vn = {
	processed: {
		cargoflow: 'đơn vị vận chuyển của đơn hàng tự sáng lập',
		Thesellernote: 'người bán ghi chú',
		Chooselogistics: 'chọn đơn vị vận chuyển',
		bulk: 'thể tích/cm',
		length: 'dài/cm',
		width: 'rộng/cm',
		height: 'cao/cm',
		weight: 'trọng lượng/kg',
		actualfreight: 'cước phí thức tế',
		waybillnumber: 'mã vận đơn',
		cancel: 'huỷ',
		confirm: 'xác nhận',
		Scanningoutbound: 'scan và xuất kho',
		Orderarea: 'số đơn hoặc mã vận đơn  kho scan',
		Dateofpackaging: 'ngày đóng gói',
		outboundorders: 'số lượng đơn hàng xuất kho',
		Themodified: 'đơn hàng sau được người dụng sửa đổi',
		enterheight: 'vui lòng nhập chiều cao',
		enterlength: 'vui lòng nhập chiều dài',
		enterwidth: 'vui lòng nhập chiều rộng',
		selectlogistics: 'xin chọn đơn vị vận chuyển',
		enterweight: 'vui lòng nhập trọng lượng',
		Logisticsdelivery: 'đã nhập thông tin giao hàng của đơn hàng tự sáng lập！',
		redasterisk: 'sao màu hồng là nội dung không thể thiếu，vui lòng nhập！',
		remarkspresent: "không có người bán ghi chú",
		details: 'xin thẩm tra thông tin chi tiết！',
		hint: 'lưu ý',
		Isee: 'tôi đã hiểu rồi',
		Processedorder: 'đơn hàng đã xử lý',
		optiondate: 'chọn ngày',
		startdate: 'ngày bắt đầu',
		dateclosed: 'ngày kết thúc',
		ordernumber: 'số đơn hàng',
		Findnumber: 'tìm kiếm số đơn hàng',
		find: 'tìm kiếm',
		Warehouse: 'kho scan và xuất kho(kho nước ngoài sử dụng)',
		Quantity: 'số lượng đơn hàng xuất kho',
		Numberof: 'số lượng đơn hàng bị huỷ sau xuất kho',
		Expresscollection: 'số lượng đơn hàng thu gom',
		money: 'kim ngạch',
		deliveryfee: 'phí dụng xuất kho',
		operation: 'thao tác',
		ViewOrder: 'kiểm tra đơn hàng',
		Exportorders: 'Export đơn hàng',
		Print: 'in đơn ký xác nhận bên chuyển phát nhanh',
		all: 'toàn bộ',
		Platformtype: 'loại nền tảng:',
		single: 'đơn hàng tự sáng lập',
		Select: 'chọn kho:',
		Typofseller: 'loại người bán:',
		Logisticstype: 'loại đơn vị vận chuyển:',
		Thegetsall: 'người bán thu toàn bộ đơn hàng đã xử lý',
		RecordDetails: 'chi tiết kỷ lục đóng gói',
		Couriername: 'tên chuyển phát nhanh',
		firstheavy: 'trọng lượng đầu tiền kg',
		heavycost: 'phí trọng lượng đầu tiền rmb/kg',
		Continuedheavy: 'trọng lượng tiếp tục rmb/kg',
		chargemode: 'phương thức thu phí',
		volumeweight: 'trọng lượng của thể tích',
		Takeofboth: 'lấy số lớn',
		actualweight: 'trọng lượng thực tế',
		actualvolume: 'thể tích thực tế',
		actualcharges: 'thu phí thực tế',
		integral: 'tích phân',
		Actualexpressfee: 'phí chuyển phát nhanh thực tế ',
		currency: 'tiền tệ',
		Totalorders: 'số lượng đơn hàng',
		Reprintthesheet: 'in đơn mặt hàng lại',
		once: 'lần',
		Unscannedoutgoing: 'chưa scan xuất kho',
		LanShoutime: 'thời gian thu gom',
		NotLanShou: 'chưa thu gom',
		Printcode: 'in mã vạch SKU sản phẩm',
		Printentry: 'in mã vạch của đơn nhập kho',
		Barcodeprinting: 'in mã vạch',
		printingquantity: 'số lượng in',
		Scanincoming: 'scan và nhập kho',
		Thesellerside: 'phía người bán',
		Estimatedvolume: 'tổng thể tích dự tính',
		viewdetails: 'kiểm tra chi tiết',
		Guidethe: 'export',
	},
	homeTwo: {
		title: 'shop/kho-tổng quat',
		width: 'rộng',
		Wholewarehousetransferinventoryandcorrespondingrelationship: 'di chuyển cả kho và quan hệ đối ứng',
		whitelist: 'danh sách trắng',
		weight: 'trọng lượng',
		Waybillnumber: 'mã vân đơn',
		Warehousetype: 'loại kho',
		Warehousescanout: 'kho scan và xuất kho（kho nước ngoại sử dụng）',
		Warehousemothersku: 'mother sku kho',
		Warehousemother: 'warehousemother',
		Warehousemessage: 'ghi chú kho',
		Warehousecode: 'mã kho',
		Warehouse: 'kho',
		volume: 'thể tích',
		vkf: 'hỗ trợ thao tác',
		Viewselleroffers: 'kiểm tra ữu đại cho người bán',
		Viewpreaccountedpointsdetails: 'kiểm tra chi tiết tích phân dự tính sử dụng',
		Viewpointsdetails: 'kiểm tra chi tiết tích phân',
		Viewinventorydiary: 'kiểm tra nhật ký kho hàng',
		View: 'kiểm tra/sửa đổi',
		Userportrait: 'Userportrait',
		Unpaid: 'chưa thanh toán',
		Unmarked: 'không có dấu hiệu',
		Unfold: 'mở/thu gọn',
		Turnonautomaticmessagetranslation: 'mở tính năng tự động phiên dịch tin nhắn',
		Turnon: 'mở',
		Transportationcosts: 'cước phí',
		translation: 'phiên dịch',
		Totalsales: 'tổng doanh thu',
		Totalremaininginventory: 'tổng kho hàng còn lại',
		totalpoints: 'tổng tích phân',
		Totalpayment: 'tổng ngạch thanh toán',
		Totalinventory: 'tổng kho hàng',
		Totalcurrentpurchases: 'tổng số hàng mua hiện nay',
		Totalconsumptionamount: 'tổng kim ngạch tiêu phí',
		ToProcess: 'kho ở Thái Lan',
		ToCheck: 'đơn hàng đợi xét duyệt',
		Tobeconfirmedbytheseller: 'đợi người bán xác nhận',
		Thesellerhasbeendetermined: 'người bán đã xác nhận',
		Theintervalbetweenthelastconsumptionandthepresent: 'khoảng cách từ 1 lần tiêu phí gần đây đến nay',
		Thaiselleruser: 'người dụng Thái Lan',
		Thailandwarehouse: 'kho ở Thái Lan',
		Thailandtestwarehouse: 'kho kiểm nghiệm Thái Lan',
		Thailanddistributionwarehouse: 'kho distribution Thái Lan(kiểm nghiệm)',
		Thailand: 'Thái Lan',
		Thail: 'Thái Lan',
		Testingwarehouse: 'kho kiểm nghiệm',
		TechnicalSupport: 'hỗ trợ ký thuật',
		Synchronizeshopeeconversation: 'đồng bộ đối thoại shopee',
		Successfullyreceived: 'tiếp nhận thành công',
		Successfullypaidtheorder: 'thanh toán đơn hàng thành công',
		Successfullyclaimedorder: 'đã đòi bổi thường thành công-đơn hàng',
		Successful: 'đơn hàng đã đòi bổi thường thành công',
		Subwarehouse: 'kho chi nhánh trong tài khoản kho hiện nay',
		SubInspection: 'số đơn hàng',
		StoreName: 'tên shop',
		Stockreceipt: 'quản lý đơn nhập kho',
		Stockmanage: 'quản lý kho hàng',
		Spotinventory: 'kho hàng',
		Spendingpower: 'khả năng tiêu thụ',
		Specificationname: 'tên quy cách',
		SmartChat: 'quản lý phân nhóm',
		Singleproductlibrary: 'kho hàng đơn độc',
		Singleproduct: 'hàng đơn độc hoặc setmeal',
		signout: 'tăng xuất',
		Signforreminder: 'nhận hàng và thúc giục bình luận',
		Showresults: 'trình bày hiệu quả',
		Shopfilter: 'sàng chọn shop',
		Shop: 'shop',
		Shippingwarehouse: 'kho giao hàng',
		Shipmentreminder: 'nhắc nhở giao hàng',
		Setupselleroffers: 'cài đặt ưu đãi cho người bán',
		Setupanemptypackage: 'cài đặt nộp không',
		Setmeal: 'Setmeal',
		Senttogether: 'tổng gửi đi',
		Sensitivegoodsbyland: 'hàng nhạy cảm vận chuyển bằng đường bộ',
		send: 'gửi đi',
		Sellingprice: 'giá bán',
		Sellerusercurrentlybound: 'người dùng đã liên kết',
		Sellertype: 'loại người bán',
		Sellerside: 'phía người bán',
		Sellerpurchasequantity: 'số hàng người mua đặt mua',
		Sellernotes: 'người bán ghi chú',
		SellerMessage: 'người mua dặn dò',
		Seller: 'người bán',
		Selfbuiltorder: 'đơn hàng tự sáng lập',
		Selfbuiltmanualorder: 'đơn hàng tự sáng lập',
		Selectstorage: 'chọn để nhập kho',
		Selectdate: 'chọn thời gian',
		selectall: 'select all',
		seedetails: 'kiểm tra chi tiết',
		Search: 'tìm kiếm mã kho，sku，tên hàng',
		Scanarea: 'kho scan',
		Returnstatus: 'đang trả hàng',
		ReturnsManagement: 'quản lý trả/đổi hàng',
		return: 'trở về',
		Resetthepickedquantity: 'cài đặt lại số lượng chọn hàng',
		Resetorder: 'cài đặt đơn hàng',
		Required: 'không thể thiếu',
		Remindertype: 'loại nhắc nhở',
		Reminder: 'nhắc nhở thúc giục thanh toán',
		Remarks: 'ghi chú',
		Remainingdeliverytimefrommoretoless: 'thời gian còn lại cho giao hàng,từ nhiều đến ít',
		Remainingdeliverytimefromlesstomore: 'thời gian còn lại cho giao hàng,từ ít đến nhiều',
		Remainingdeliverytime: 'thời gian còn lại cho giao hàng',
		Relative: 'giá cả trung bình của sản phẩm tương đối và tỷ lệ premium tiêu phí trung bình',
		Rechargenow: 'nạp tiền ngay',
		Receivefailed: 'tiếp nhận thất bại',
		reasonsforreturn: 'nguyên nhân trả hàng',
		Questionandanswermanagement: 'quản lý câu hỏi',
		Quantitypicked: 'số lượng chọn hàng',
		Quantity: 'số lượng',
		Pushtime: 'thời gian Push',
		Purchasequantityinteger: 'số hàng mua（số chẵn）',
		Purchasequantity: 'số hàng mua',
		productstatus: 'trạng thái hàng',
		productname: 'tên hàng',
		Productcollection: 'thu tập sản phẩm',
		Processed: 'đã xử lý',
		Processed: 'đơn hàng đã xử lý',
		Privatewarehouse: 'kho tư hữu',
		Printthecouriersign: 'in đơn chuyển phát nhanh',
		printingtime: 'thời gian in',
		Printbarcode: 'in mã vạch',
		Pricesensitivity: 'mức độ nhảy cảm về giá cả',
		Pricesensitive: 'giá cả nhạy cảm',
		Priceinsensitive: 'giá cả không nhạy cảm',
		Presale: 'bán trước hay không',
		Preemptivepoints: 'dự tính sử dụng tích phân',
		Position: 'Position',
		PointsAvailable: 'tích phân có thể sử dụng ',
		Platformtype: 'loại nền tảng',
		Personalcenter: 'trung tâm cá nhân',
		Pendingthesellertoverifythreturn: 'đợi người bán thẩm tra trả hàng',
		Pendingreview: 'đợi xét duyệt',
		Paymenttime: 'thời gian thanh toán',
		paymentsuccessful: 'thanh toán thành công',
		Packingdate: 'thời gian đóng gói',
		OverseasWarehouseComplaintCenter: 'trung tâm khiếu nại',
		Outboundfee: 'phí xuất kho',
		ordinary: 'bình thường',
		OrderType: 'loại đơn hàng',
		OrderTracking: 'tìm kiếm đơn hàng',
		Ordertimerange: 'phạm vi thời gian đơn hàng',
		Ordertimefrommorningtonight: 'thời gian lên đơn từ sáng đến muộn',
		Ordertimefromlatetoearly: 'thời gian lên đơn từ muộn đến sáng',
		Ordernumberorwaybillnumber: 'số đơn hàng hoặc mã vân đơn',
		ordernumber: 'số đơn hàng',
		Orderlookup: 'tìm kiếm đơn hàng',
		Orderdata: 'dữ liệu đơn hàng',
		Orderactuallypaid: 'ngạch thực tế thanh toán',
		order: 'đợi xác nhận bồi thường-đơn hàng',
		operating: 'thao tác',
		Oneclickgenerationprice: 'giá cả một kiện chuyển hộ',
		Oneclickcollection: 'một bấm thu tập ',
		Offshelfdistribution: 'off shelf distribution',
		Numberofwarehousesku: 'số lượng son sku trong kho',
		Numberofoutboundorders: 'số lượng đơn hàng đã xuất kho',
		Numberofordersrejected: 'số lượng đơn hàng bị tự chối nhận hàng',
		Numberofordersconsumptionnumber: 'số lượng đơn hàng（số tiêu phí)',
		Numberofcancellationsafterdelivery: 'số lượng đơn hàng bị huỷ sau xuất kho',
		Notprinted: 'chưa in',
		Notoutofstock: 'chưa xuất khô',
		Notgenerated: 'chưa tạo ra',
		Nomessage: 'không có dặn dò',
		Nodata: 'không có dữ liệu',
		No: 'không có',
		Newlyaddedproducts: 'sản phẩm nhập kho mới tăng',
		Negotiate: 'hiệp thương',
		Nationalcurrency: 'tiền tệ quốc gia',
		Multiplechoice: 'mở mô thức chọn hàng loạt',
		MonitoringPrice: 'sản phẩm trực tuyến',
		Monitoredproducts: 'sản phẩm đã giám sát',
		Modifyorderinformation: 'sửa đổi thông tin đơn hàng',
		Middlevalue: 'giá trị trung',
		Memberrechargeinstructions: 'thuyết minh về  thành viên nạp tiền：1 nhận dân tệ tương đương với 1 tích phân，nạp tiền càng nhiều，tích phân càng nhiều',
		Mediumloyaltyandhighprice: 'trung thành trung bình và giá cao',
		mark: 'đánh dấu',
		Malaysia: 'Malaysia',
		Machinelearningautomaticclassification: 'machine học tập tự động phân loại',
		loyalty: 'mức độ trung thành',
		lowvalue: 'giá cả thấp',
		Lowconsumption: 'tiêu phí thấp',
		long: 'dài',
		Logisticstype: 'loại Logistics',
		Logisticsinformation: 'thông tin Logistics ',
		Logistics: 'Logistics',
		Linkcollection: 'link thu tập',
		Limitationofclaims: 'hiệu lực đòi bồi thường：thường là trong vòng 30 ngày,nếu chưa đòi bồi thường với nền tảng trong vòng 30 ngày,thì coi là bỏ tư cách đòi bồi thường,cuối cùng người bán sẽ tổn thất tiền bồi thường (như tiền bồi thường cao nhất 2000 Thai Baht cho người bán site TL)！nếu kịp thời đòi bồi thường với nền tảng,sẽ giúp bạn giảm tổn thất,nâng cao lợi nhuận của bạn！',
		kjbgf: 'về đơn hàngCOD của shop bản thổ,nếu người mua không nhận hàng,tỷ lệ mất kiện hàng nâng cao,hệ thống tự động giám sát kiện hàng bị mất và vận chuyển thất bại.',
		Iwanttodistribute: 'tôi muốn distribute',
		Islosinghighprices: 'đang mất giá cả cao',
		Islosing: 'đang mất',
		Includequery: 'bao gồm tìm kiếm',
		InClaimOrder: 'đang đòi bồi thường-đơn hàng',
		Inboundstatus: 'trạng thái nhập kho',
		Inboundproductdetails: 'chi tiết hàng nhập kho',
		Inboundordernumber: 'số đơn nhập kho',
		Inboundordercreationtime: 'thời gian sáng lập đơn nhập kho',
		Importproducts: ' Import sản phẩm',
		Ihaveacted: 'tôi đã thay mặt',
		Icansupply: 'tôi có thể cung ứng sản phẩm',
		Highvaluelost: 'đã mất giá trị cao',
		highvalue: 'giá trị cao',
		Highloyaltyandhighprice: ' trung thành cao giá cao',
		high: 'cao',
		Hideorder: 'ẩn đơn hàng',
		GroupName: 'tên nhóm ',
		Groupdescription: 'mô tả phân nhóm',
		Giveaway: 'quà tặng',
		Giftlibrary: 'kho quà tặng',
		Generatewarehousinglist: 'tạo ra đơn nhập kho',
		Generalcargo: 'hàng bình thường vận chuyển bằng đường bộ',
		Find: 'tìm kiếm',
		Filtertoshoworhideorders: 'sàng chọn biểu thị hay ẩn đơn hàng',
		Exportorder: 'Export đơn hàng',
		Exportall: 'toàn bộ Export',
		Export: 'Export',
		Export: 'Export Excel',
		Expiredate: 'thời gian hết hạn',
		Expand: 'mở/thu gọn',
		Estimatedtotalvolume: 'tổng thể tích dự tính',
		EstimatedCompensationPoints: 'tích phân bồi thường dự tính',
		Edittemplate: 'bản mẫu sửa chỉnh',
		Editname: 'sửa đổi tên',
		edit: 'sửa chỉnh',
		Distributionwarehousemerchandise: 'sản phẩm trong kho distribution',
		Distributionwarehouse: 'kho distribution',
		Distributionselectionlibrary: 'kho chọn hàng và distribution',
		Distributionplatform: 'nền tảng distribution',
		description: 'miêu tả',
		Deliverytime: 'thời gian xuất kho',
		Deliveryplace: 'nơi giao hàng',
		DeliveryMethod: 'phương thức giao hàng',
		Deleteselectedproductsinbulk: 'xóa hàng đã chọn hàng loạt',
		delete: 'xóa',
		CustomerProfile: 'danh mục',
		Custombuyergrouping: 'phân nhóm người mua tùy chỉnh',
		Currentlyselected: 'đã chọn hiện tại',
		Currentlyonly: 'hiện nay chỉ ủng hộ thu tập sản phẩm trong nền tảng shopee,xin nhập link trang sản phẩm ！',
		CreatList: '8 cái kỷ lục',
		Creationtime: 'thời gian sáng lập',
		Courierhasbeendelivered: 'chuyển phát nhanh đã gửi đến',
		Courierhasbeencollected: 'chuyển phát nhanh đã thu gom',
		Couriercollection: 'số hàng đã xuất kho và thu gom',
		countryregion: 'quốc gia và khu vực',
		container: 'container',
		contactseller: 'liên hệ người bán',
		Confirmthechanges: 'xác nhận sửa đổi',
		Confirmreceipt: 'xác nhận nhận hàng',
		Completetime: 'thời gian hoàn thành',
		completed: 'đã hoàn thành',
		complete: 'hoàn thành',
		Complaints: 'khiếu nại và đòi bồi thường',
		Complaintorderstobeprocessedbythewarehouse: 'đơn hàng bị khiếu nại và đợi kho xử lý',
		Compensation: 'đòi bồi thường：sau nộp mẫu biểu đòi  bồi thường cho nhân viên dịch vụ nền tảng，hệ thống sẽ tự phán đoán đơn hàng đòi bồi thường của bạn sẽ được bồi thường hay không，tiết kiệm thời gian của bạn.bấm menu đối ứng dưới đây《đợi xác nhận bồi thường-đơn hàng》《đang đòi bồi thường-đơn hàng》《đòi bồi thường thành công-đơn hàng》',
		Commoditystatus: 'trạng thái hàng',
		Commoditycollection: 'thu tập sản phẩm',
		Combinatoriallibrary: 'kho setmeal',
		Cloudblacklist: 'danh sách đen Internet',
		Claimsuccessfultime: 'thời gian đòi bồi thường thành công',
		ClaimAssistant: 'hỗ trợ bồi thường',
		claim: 'trợ lý đòi bồi thường：là tính năng đặc biệt mà Tiệm Tiểu Sinh thiết kế dành cho người bán bản thổ,giúp người bán kịp thời phát hiện những đơn hàng bị tự chối nhận hàng vì COD hoặc mất kiện hàng,thuận lợi cho người bán export biểu mẫu để đòi bồi thường với nền tảng',
		Churn: 'đã mất',
		Chooseawarehouse: 'chọn kho',
		Chooseastore: 'chọn shop',
		checkorder: 'kiểm tra đơn hàng',
		Checkcompleted: 'thẩm tra hoàn thành',
		Changethetime: 'thời gian sửa đổi',
		CaringSMS: 'đóng',
		Cancelorder: 'đơn hàng bị huỷ',
		Canceldetails: 'thông tin chi tiết về đơn hàng bị huỷ',
		Buyersname: 'tên người mua',
		Buyerpurchasequantity: 'số hàng người mua đặt mua',
		Buyermessage: 'người mua dặn dò',
		Buyerhasconfirmed: 'người mua đã xác nhận',
		box: 'hộp',
		blacklist: 'danh sách đen',
		Bindingtime: 'thời gian liên kết',
		Batchsettingofflags: 'cài đặt dấu hiệu hàng loạt',
		Batchoperation: 'thao tác hàng loạt',
		Batchexportorders: 'export đơn hàng hàng loạt',
		Batchexportoforders: 'export đơn hàng hàng loạt',
		Barcode: 'mã vạch',
		Averageconsumptiontimeinterval: 'khoảng cách thời gian tiêu phí trung bình ',
		AuthorizeShop: 'kiểm tra chi tiết sử dụng tích phân',
		Audited: 'đã xét duyệt',
		Applicationforcancellation: 'xin phép huỷ đơn',
		Amount: 'kim ngạch',
		Allsubskusinstorage: 'toàn bộ son sku nhập kho',
		Allsites: 'toàn bộ sites',
		Allsellers: 'toàn bộ người bán',
		Allorders: 'toàn bộ đơn hàng',
		AllLists: 'chi phí tuyến đầu',
		Allcountries: 'toàn bộ quốc gia',
		All: 'toàn bộ',
		agree: 'đồng ý',
		Afterrecharging: 'sau nạp tiền,có thể sử dụng các tính năng như kho nưới ngoại、kho kiểm nghiệm、kho tư hữu ngay',
		Addnotes: 'thêm ghi chú',
		Additnow: 'thêm ngay',
		Addcustomgroup: 'thêm phân nhóm tùy chỉnh',
		Actualquantity: 'số lượng hàng gửi đạt thực tế',
		Actualpickingquantity: 'số chọn hàng thực tế',
		Actualarrivalquantityinwarehouse: 'số lượng hàng mà kho thực tế nhận được',
		Activityprice: 'giá cả ưu đãi',
		Activityid: 'id hoạt động',
		invitecashback: 'chia sẻ với bạn bè',
		pointdetails: 'kiểm tra chi tiết sử dụng tích phân',
		Sellersname: 'tên người bán',
		SellersAccount: 'tài khoản người bán',
		boundtime: 'thời gian liên kết',
		Sellersname: 'tên người bán',
		orderSearch: 'tìm kiếm số đơn',
		orthersSearch: 'tìm kiếm tên hàng，sku hàng',
		syncSingleOrder: 'đồng bộ số đơn',
		urgent: 'thúc giục xử lý đơn hàng hay không',
		checkTime: 'thời gian thâm trả',
		orderPrinted: 'in đơn mặt hàng',
		hasPrint: 'đã in,tải lại trạng hiện tại',
		returnReason: 'nhập nguyên nhân trả lại xét duyệt',
		jkf: 'trả lại ngay',
		scanArea: 'kho scan số đơn hoặc số vận đơn',
		scanProduct: 'kho scan mã vạch sản phẩm',
		returnReview: 'trả lại để xét duyệt',
		resetorder: 'cài đặt đơn hàng',
		resetPickingNum: 'cài đặt số lượng chọn hàng',
		checkDone: 'thẩm tra hoàn thành',
		purcahseNum: 'số hàng mua',
		singleOrSetmeal: 'sản phẩm đơn độc hoặc setmeal',
		cusCode: 'CUSCODE/mã vạch',
		sku: 'SKU',
		pickingNum: 'số lượng chọn hàng',
		retrunDesc: 'không thể thiếu nguyên nhân trả lại để xét duyệt ！',
		nodata: 'không có dữ liệu đơn hàng！',
		descPicktip: 'xin xác định đã hoàn thành thẩm tra về số hàng đóng gói chưa？',
		outProduct: 'lưu ý xuất kho',
		yes: 'xác định',
		cancel: 'huỷ',
		noorderdata: 'không có dữ liệu đơn hàng！',
		comfirmCheck: 'xin xác định đã hoàn thành thẩm tra về số hàng đóng gói chưa？',
		fkuvkf: 'lưu ý xuất kho',
		kvjjkf: 'đã hoàn thành',
		kvjfk: 'thẩm tra',
		vkjfhbvm: 'vui lòng scan số đơn trước！',
		fikvnf: 'số chọn hàng và số hàng người mua đặt mua nhất trí！',
		vkhlf: 'thẩm tra hoàn thành',
		systemNoorder: 'hệ thống không có thông tin về đơn hàng này hiện nay,xin scan số đơn chính xác！',



	},

	complaint: {
		complaintReasonTip1: "xin nhập lý do complaint",
		complaintReasonTip2: "xin nhập lý do complaint của người bán(không thể thiếu)",
		cancel: "huỷ",
		determine: "xác nhận",
		close: "",
		complaintDetailTip: "chi tiết complaint",
		sellerLeaveMessage: "người bán dặn dò",
		sellerLeaveMessageTip: "xin nhập dặn dòn gười bán (không thể thiếu)",
		WarehouseLeaveMessage: "nền tảng dặn dò",
		WarehouseLeaveMessageTip: "xin nhập dặn dò của kho(không thể thiếu)",
		PlatformLeaveMessage: "nền tảng dặn dò",
		PlatformLeaveMessageTip: "xin nhập dặn dò nền tảng(không thể thiếu)",
		overseasWarehouseComplaints: "trung tâm khiếu nại",
		orderQuery: "tìm kiếm đơn hàng",
		orderQueryTip: "nhập số đơn để tìm kiếm",
		query: "tìm kiếm",
		wareHouseHaveEx: "toàn bộ đơn hàng đã xuất kho",
		sellerComplaint: "đơn hàng đang bị người bán khiếu nại",
		haveFinish: "đã hoàn thành",
		orderId: "số đơn",
		orderStatus: "trạng thái đơn hàng",
		orderPaid: "ngạch thanh toán thực tế",
		warehouseHaveCompensation: "kho đã bồi thường",
		specificationName: "tên quy cách",
		number: "số lượng",
		orderTime: "thời gian lên đơn",
		payTime: "thời gian thanh toán",
		printTime: "thời gian in",
		warehouseExTime: "thời gian xuất kho",
		deliveryTime: "thời gian giao hàng",
		storeName: "tên shop",
		deliveryMethod: "phương thức vận chuyển",
		WaybillNum: "mã vận đơn",
		PlatformType: "loại hình nền tảng",
		sellerLeaveMessage: "người bán dặn dò",
		complaintCompensate: "khiếu nại và đòi bồi thường",
		waitWarehouseConfirm: "đợi kho xác nhận",
		waitPlatformType: "đợi nền tảng xử lý",
		haveCompensation: "đã bồi thường",
		integral: "tích phân",
		viewDetail: "kiểm tra chi tiết",
		confirmTip: "đã đòi bồi thường với kho,đợi kho xử lý！",

	},


	home: {
		title: 'giới thiệu sơ lược về cửa hàng/kho',
		allproduct: 'toàn bộ hàng',
		inproduct: 'hàng trong kho',
		allshop: 'toàn bộ cửa hàng-đơn hàng',
		sale: 'thu nhập người bán',
		quantity: 'lượng tiêu thụ',
		grossprofit: 'lợi nhuận ròng',
		grossmargin: 'lợi nhuận gộp',
		allstorehuozhi: 'toào bộ số hàng trong kho-giá trí hàng sẵn ',
		houzhi: 'giá trị hàng',
		shipingcost: 'chi phí vận chuyển',
		allshopsales: 'tình trạng bán hàng cửa hàng',
		allstoresales: 'kho/warehouse-tình trạng bán hàng',
		shopname: 'tên cửa hàng',
		shopsales: 'kim ngạch tiêu thụ',
		shopquantity: 'lượng tiêu thụ',
		cost: 'giá thành dự tính',
		avg: 'kim ngạch tiêu thụ/ngày（AVG）',
		operate: 'thao tác',
		linepic: 'sơ đồ phân chia ',
		tipdialog: ' sơ đồ về khâu bán hàng của cửa hàng',
		close: 'đóng',
		storename: 'tên kho',
		tip1: '(đã giảm trừ：phí vân chuyển thực tế ,phí vân chuyển dự tính，phí giao dịch cho nền tảng)',
		tip2: 'đã giảm trừ：giá thành mua sắm，phí vận chuyển tuyến đầu（TQ-VN)',
		tip3: 'chỉ gồm phí mua hàng sẵn  trong kho',
		tip4: 'giá thành dự tính=giá thành mua sắm+phí vận chuyển tuyến đầu（TQ-VN)+phí giao dịch cho nền tảng',
		secondPwsTip: 'liên quan đến thông tin tài sản riềng tư,vui lòng nhập lại mật khẩu',
		secondPws_Two: 'vừa đăng ký mặc định',
		secondChange: 'nhấn để sửa mật khẩu phụ',
		secondPwsInput: 'vui lòng nhập mật khẩu',
		confirm: 'xác nhận '


	},
	header: {
		title: 'Tiệm Tiểu Sinh-hệ thống quản lý xuyên biên giới',
		huanyinru: 'hoan nghênh bạn'
	},
	login: {
		system: 'trung tâm đăng nhập',
		tip: 'một nền tảng dành phục vụ cho người bán Đông Nam Á ,giúp bạn nâng cao lợi nhuận ròng ',
		account: 'vui lòng nhập tài khoản E-mail',
		passsword: 'vui lòng nhập mật khẩu',
		remember_password: 'nhớ mật khẩu',
		login: 'đăng nhập',
		desc: ' Tiệm Tiểu Sinh- dành phục vụ cho người bán Shopee/Lazada bản thổ ',
		desc1: 'chuyên ngành công cấp dịch vụ trực tuyến  cho khu vực Đông Nam Á/ một kiện chuyển hộ tại kho internet ',
		desc2: 'tự nghiên cức và xây dựng hệ thống ERP liên kết với Shopee/Lazada,có thể thực hiện quản lý và kiểm tra kho tóm lược bằng một bấm ',
		desc3: 'cung cấp dịch vụ hỗ trợ xử lý tranh chấp cho người bán và người,theo dõi đánh giá tồi  ',
		desc4: ' dự toán hoạt đồng mua sắm bằng dữ liệu lớn ',
		desc5: 'ủng hộ trả hàng,',
		th: 'Thái Lan',
		my: 'Ma-lai-xi-a',
		ph: 'Phi-li-pin',
		tw: 'Đài Loan',
		sg: 'Singapore',
		vn: 'Việt Nam',
		id: 'In-đô-nê-xi-a',
		forget: 'quên mật khẩu',
		registor: 'bấm vào đăng ký'
	},
	registor: {
		center: 'trung tâm đăng ký（người bán）',
		mail: 'vui lòng nhập E-mail',
		nickname: ' tên nick người bán',
		passsword: ' mật khẩu người bán không thể thiếu hơn 6 chữ số，gồm chữ ,chữ số,ký tự ',
		confirm_pws: 'xác nhận mật khẩu',
		phone: 'dụng để thông báo thông tin quan trọng hoặc liên hệ khẩn cấp',
		verification: 'mã xác nhân E-mail',
		getCode: 'nhận mã xác nhận e-mail',
		register: 'đăng ký',
		log: 'bấm để vào trang đăng nhập ',
		invitationCode: 'nếu không có mã mời,thì không cần điền'
	},
	aside: {
		home: 'trang chủ',
		dianpusouquan: ' cửa hàng ủy quyền',
		wodedingdang: ' đơn đặt hàng của mình',
		allOrder: 'toàn bộ đơn đặt hàng',
		shenghedang: 'đơn hàng đợi xét duyệt',
		chulidang: 'đơn hàng đợi xử lý',
		yifahuodingdang: 'đơn hàng đã  thu gom ',
		sellerManagement: 'Quản lý người bán',
		zhuanchuandan: 'Chuyển hàng tồn kho',
		wentidang: 'đơn hàng có vấn đề',
		xiangshangchanpin: '  hàng trong kho',
		shengchengchangkuchanpin: 'import hàng',
		changkunchanpin: ' hàng trong kho',
		quanbuzhachanshanpin: 'toàn bộ hàng trong kho',
		rukuguangli: ' quản lý nhập kho',
		kuchuguanli: ' quản lý hàng trong kho',
		godownentry: 'đơn nhập kho',
		processed: 'đơn hàng đã xử lý',
		recharge: 'nạp tiền ngay',
		yunweiguanli: 'hoạt động và quản lý',
		discountProducts: 'hàng giảm giá',
		claimAssistant: ' trợ giúp cho việc đòi bồi thường',
		Management: ' hoạt động và quản lý',
		Performance_ranking: ' bảng xếp hàng về hiệu suất của nhóm ',
		Monitoring_Price: 'giám sát báo giá một cách thông minh',
		Customer_Service: ' dịch vụ khách hàng ',
		Customer_Profile: 'hình ảnh của khách hàng',
		SmartChat: 'nhân viên dịch vụ thông minh',
		CaringSMS: 'tin nhắc quan tâm',
		Returned: 'quản lý trả hàng',
		CreatList: 'sáng lập nhận kho',
		AllLists: 'nhập kho trên đường vận chuyển',
		fenjianhedui: 'phân chia và nghiệm hàng ',
		daibaochuku: 'đóng gói xuất kho',
		tuhuanguanli: ' quản lý trả/đổi hàng',
		ScanPrint: 'Quét in',


	},

	shopaccess: {
		diangpusouquan: 'cửa hàng ủy quyền',
		bindshop: 'ủy quyền cửa hàng shopee ',
		bindshop_LAZADA: 'ủy quyền cửa hàng LAZADA',
		bindstore: 'liên kết kho',
		shopId: 'ID cửa hàng',
		shopName: 'tên cửa hàng',
		shopSite: 'site cửa hàng',
		shopStatus: 'trạng thái',
		accessTime: 'thời gian ủy quyền',
		Expiredate: 'thời gian hết hạn',
		operate: 'thao tác',
		storeID: 'ID kho',
		userId: 'ID người dùng',
		userName: 'tên người dùng',
		storeName: 'tên kho',
		createTime: 'thời gian sáng lập',
		storeAdresse: 'vị trí kho',
		Untie: 'hủy liên kết cửa hàng',
		UniteStore: 'hủy liên kết kho',
		UniteStoreSuccess: 'hủy liên kết kho thành công！',
		UniteShopSuccess: 'hủy liên kết cửa hàng thành công！',
		selectStore: 'vui lòng chọn kho cần liên kết',
		cancel: 'xóa',
		comfirm: 'xác nhận ',
		bangdinSuccess: 'liên kết kho thành công！',
		enterStoreinfo: 'vui lòng nhập thông tin về kho mới xây dựng',
		enterUserName: 'vui lòng nhập tên người dùng',
		enterStoreName: 'vui lòng nhập tên kho',
		selected: 'vui lòng chọn quốc gia',
		xinjian: 'kho chi nhánh mới xây dựng',
		lazada_shortCode: ' mã người bán',
		lazada_account: 'tài khoản người dùng',
		lazada_name: 'tên cửa hàng',
		lazada_location: 'vị trí',

	},
	pendingorder: {
		title: 'đơn hàng đợi xét duyệt',
		search: 'tìm kiếm',
		allcurrentpage: 'chọn toàn bộ trạng hiện tại',
		Mass_review_orders: ' xét duyệt đơn hàng hàng loạt',
		synchronize: 'đồng bộ trạng thái đơn hàng',
		last_3_days: '3 ngày gần đây',
		last_7_days: '7 ngày gần đây',
		last_1_month: '1 tháng gần đây',
		last_3_month: '3 tháng gần đây',
		orderSn: 'số đơn hàng',
		status: ' trạng thái đơn hàng',
		paytime: 'thời gian thanh toán',
		delivery_time: 'thời gian còn lại cho giao hàng khi đã qua thời gian giao hàng ',
		sku: 'SKU',
		quantity: 'số lượng',
		shopName: 'tên cửa hàng',
		shopid: 'Id cửa hàng',
		recipient: 'người nhận hàng',
		phone: 'điện thoại',
		methods: 'phương thức vận chuyển ',
		actually_paid: 'tiền thanh toán thực tế',
		waybill_number: 'số vận đơn ',
		review: 'xét duyệt đơn hàng',
		search_tip: 'vui lòng nhập số đơn hàng',
		nodata: 'hiện không có đơn hàng',
		orderstotal: 'đơn hàng',
		select: "vui lòng chọn kho giao hàng",
		cancel: "xóa",
		confirm: 'xác nhận',
		UNAUDIT: "đợi xét duyệt",
		cash_on_delivery: 'thanh toán khi giao hàng',
		pending_upgrade: 'đợi cập nhật',
		notgenerated: "tiền thanh toán thực tế",
		synchronized: "đơn hàng đã đồng bộ đến trạng thái mới nhất ，vui lòng chờ một lát để cập nhật trang web！",
		Successful_review: "xét duyệt thành công！",
		day: 'ngày',
		hours: 'đồng hồ',
		min: 'phút',
		time_order: 'xếp thời gian đơn hàng',
		Positive: 'thời gian thanh toán cho đơn hàng -sớm đến muộn',
		Reverse: 'thời gian thanh toán cho đơn hàng-muộn đến sớm',
		Positive01: "thời gian còn lại cho giao hàng-nhiều đến ít",
		Reverse01: 'thời gian còn lại cho giao hàng-ít đến nhiều',
		auto_distribute: 'tự động xét duyệt đơn hàng',
		Inventory: 'số hàng trong kho',
		In_warehouse: 'trong kho',
		committed: 'đợi giao hàng',
		on_line: 'online',
		Turn_on: 'mở/đóng  tính năng tự động xét duyệt đơn hàng',
		Store_Name: 'tên cửa hàng',
		warehouse: 'kho',
		un_include: ' loại trừ đơn hàng thiếu hàng hay không',
		yes: 'có',
		no: 'không',
		auto_distribute: 'tự động xét duyệt đơn hàng',
		open: 'mở',
		Turned_on: 'đã mở',
		shut_down: 'đóng',
		confirm: 'xác nhận',
		oop: 'trong những đơn hàng đã chọn ,sâu bộ lọc theo số hàng trong kho và trình độ cấp bách về  thời gian giao hàng cuối cùng:',
		llo: 'đơn hàng có hàng sẵn có thể  xét duyệt thông qua',
		ggo: ' số đơn hàng',
		prick: 'kim ngạch',
		hho: 'thời gian giao hàng cuối cùng',
		pkl: 'đề nghị không thông qua đơn hàng thiếu hàng',
		cancel: 'hủy bỏ',
		uuo: 'chỉ thông qua đơn hàng có hàng sẵn',
		iio: 'tiếp tục thông qua toàn bộ',
		addpackingfee: ' thay mặt dán đơn hay không',
		cancelTime: 'thời gian hủy bỏ'




	},

	storePending: {
		Form: 'loại nền tảng',
		UserName: 'chọn người bán',
		shoptype: 'chọn cửa hàng',
		Warehouse_type: ' loại kho',
		Loading_status: 'đang tải',
		Printstatus: ' đang in',
		LogisticsType: 'loại vận chuyển',
		orderMakr: ' dấu đơn hàng',
		lastDeliveryTime: 'giao hàng cuối cùng',
		orderStatus: 'trạng thái đơn hàng',
		exwarehouse: 'xuất kho hay không',
		orderInclude: 'đơn hàng ',
		all: 'toàn bộ',
		singlesku: 'một sku',
		multiplesku: 'nhiều sku',
		shipped: 'đã giao hàng',
		tobeshipped: 'đợi giao hàng',
		yes: 'đã xuất kho',
		notYet: 'chưa xuất kho',
		printed: 'đã in',
		notprinted: 'chưa in',
		notgenerated: "chưa tạo ra",
		Generated: 'đã tạo ra',
		loadign: 'đang tải',
		massArrangeShipment: 'tạo ra số vận đơn ',
		drop_off: 'drop off tạo ra',
		pick_up: 'pick up tạo ra',
		massprint: 'in đơn phân phối hàng hàng loạt',
		PrintPacklist: 'in mặc định đơn phân chọn hàng',
		PrintPicklist: 'in nhanh đơn phân phối hàng hàng loạt',
		MassPrintShipingLabel: 'in đơn mặt hàng chuyển phát nhanh hàng loạt',
		PrintShipingLabel: 'in mặc định đơn mặt hàng',
		ShipingLabel_Packlist: 'in nhanh đơn mặt hàng&đơn phân chọn hàng',
		ReturnBacktoUser: 'trả lại để xét duyệt ',
		SynchronizeOrder: 'đồng bộ đơn hàng',
		desc: 'phân phối hàng trước ，lại phân chọn hàng，có thể giảm thấp tỷ lệ sai lầm',
		fisrtStep: 'bước 1:tạo ra số vận đơn ',
		secondStep: 'bước 2:in nhanh đơn phân phối',
		threeStep: 'bước3:in nhanh đơn mặt hàng+đơn phân chọn hàng',
		fourStep: 'bước 4: kiểm nghiệm hàng&xuất kho',
		firstDesc: 'nhận chuyển phát nhanh tận nơi nhận chọn Pick Up,giao hàng đến cửa hàng chọn Drop OFF',
		secondDesc: 'in đơn phân phối hàng loạt này,lấy toàn bộ hàng cần giao từ kho trước',
		threeDesc: 'áp dụng phương thức in nhanh đơn mặt hàng+đơn phân chọn hàng để nâng cao tốc độ in',
		fourDesc: 'áp dụng phương thức phân chia và nghiệm hàng và đóng gói xuất kho,có thể phân chia quá trình này để nâng cao hiểu suất ',
		Inventory: 'thiếu hàng hay không',
		Enough: 'hàng đầy đủ',
		noEnough: 'hàng không đủ',
		pushTime: 'thời gian gửi vào',
		tenBefore: 'trước 10 giờ cùng ngày',
		tenAfter: 'sau 10 giờ cùng ngày',
		specialOrder: 'có phải là đóng gói không có hàng',
		norMall: 'không phải là đóng gói không có hàng',
		enptry: 'đóng gói không có hàng'


	},

	unprocessedorder: {
		title: 'đơn hàng đợi xử lý',
		search: 'tìm kiếm',
		allcurrentpage: 'chọn toàn bộ trạng hiện tại',
		Mass_review_orders: 'xét duyệt đơn hàng hàng loạt',
		synchronize: 'đông bộ trạng thái đơn hàng',
		last_3_days: '3 ngày gần đây',
		last_7_days: '7 ngày gần đầy',
		last_1_month: '1 tháng gần đây',
		orderSn: 'số đơn đặt hàng',
		status: ' trạng thái đơn hàng',
		paytime: 'thời gian thanh toán',
		delivery_time: 'thời gian còn lại khi đã qua thời gian giao hàng',
		sku: 'SKU',
		quantity: 'số lượng',
		shopName: 'tên cửa hàng',
		shopid: 'Id cửa hàng',
		recipient: 'người nhận hàng',
		phone: 'điện thoại',
		methods: 'phương thức vận chuyển ',
		actually_paid: 'tiền thanh toán thực tế',
		waybill_number: 'số vận đơn ',
		review: 'xét duyệt đơn hàng',
		search_tip: 'vui lòng nhập số đơn hàng ',
		nodata: 'hiện không có đơn hàng',
		orderstotal: 'đơn hàng',
		select: "vui lòng chọn kho giao hàng",
		cancel: "xóa",
		confirm: 'xác nhận',
		UNAUDIT: "đợi xét duyệt",
		cash_on_delivery: 'thanh toán khi giao hàng',
		pending_upgrade: 'đợi cập nhật',
		notgenerated: "chưa tạo ra",
		Mass_generate_waybill_number: "tạo ra số vận đơn hàng loạt ",
		Mass_print_orders: "in đơn hàng hàng loạt",
		Mass_print_picking_list: "in đợn phân chọn hàng hàng loạt",
		pick_off: "Pick up tạo ra",
		drop_off: "Drop off tạo ra",
		allshops: 'toàn bộ cửa hàng',
		allorders: 'toàn bộ đơn đặt hàng',
		tobegenerated: 'đợi tạo ra',
		tobeprinted: 'đợi in',
		Defaultprint: 'in mặc định',
		fastprint: 'in nhanh',
		viewhistory: 'kiểm tra kỷ lục in',
		logistic: 'toàn bộ thông tin về vận chuyển',
		printed: "đã in  ",
		printed_time: 'thời gian in',
		print_order: 'in đơn hàng',
		print_picking_list: 'in đơn phân chọn hàng ',
		delivery_store: 'kho giao hàng',
		todelivered: 'đợi giao hàng',
		all_store: 'toàn bộ kho',
		pingliancancelreview: 'trả lại hàng loạt để xét duyệt  ',
		cancelreivew: 'đơn hàng đã cài đặt thành trạng thái đợi xét duyệt thành công ！',
		initTrickingNo: {
			createNO: 'đang tạo ra số vận đơn ',
			main: 'ảnh chính',
			ordersn: ' số đơn hàng',
			trickingNo: 'số vận đơn ',
			ttp01: 'đã hoàn tất',
			ttp02: 'trang đơn hàng',
			ttp03: 'in đơn hàng'

		},
		pingliandayin: 'vui lòng chọn đơn hàng！',
		pingliandayin01: 'vui lòng chọn những đơn hàng cùng cửa hàng để in！',
		haimeishenchendingdang: 'vui lòng chờ tạo ra số vận đơn ，lại in！',
		searchContent: 'vui lòng nhập nội dung tìm kiếm',
		Export: 'export xlsx',
		fenle: 'tìm kiếm đơn hàng theo loại hàng'

	},
	shippedorder: {
		title: 'đơn hàng đã giao hàng',
		search: 'tìm kiến',
		allcurrentpage: 'chọn toàn bộ trang hiện tại',
		Mass_review_orders: ' xét duyệt đơn hàng hàng loạt',
		synchronize: 'đồng bộ trạng thái đơn hàng',
		last_3_days: '3 ngày gần đây',
		last_7_days: '7 ngày gần đây',
		last_1_month: '1 tháng gần đây',
		orderSn: 'số đơn hàng',
		status: 'trạng thái đơn hàng',
		paytime: 'thời gian thanh toán',
		delivery_time: 'thời gian còn lại cho giao hàng',
		sku: 'SKU',
		all_store: 'toàn bộ kho',
		quantity: 'số lượng',
		shopName: 'tên cửa hàng',
		shopid: 'Id cửa hàng',
		recipient: 'người nhận hàng',
		phone: 'điện thoại',
		methods: 'phương thức vận chuyển ',
		actually_paid: 'tiền thanh toán thực tế',
		waybill_number: 'số vận đơn ',
		review: ' xét duyệt đơn hàng',
		search_tip: 'vui lòng nhập số đơn hàng',
		nodata: 'hiện không có đơn hàng',
		orderstotal: 'đơn hàng',
		select: "vui lòng chọn kho giao hàng",
		cancel: "hủy bỏ",
		confirm: 'xác nhận',
		UNAUDIT: "đợi xét duyệt ",
		cash_on_delivery: 'thanh toán khi giao hàng',
		pending_upgrade: 'đợi cập nhật',
		notgenerated: "chưa tạo ra",
		Mass_generate_waybill_number: "tạo ra số vận đơn hàng loạt ",
		Mass_print_orders: "in đơn hàng hàng loạt",
		Mass_print_picking_list: "in đợn phân chọn hàng hàng loạt",
		pick_off: "Pick off tạo ra",
		drop_off: "Drop off tạo ra",
		allshops: 'toàn bộ cửa hàng',
		allorders: 'toàn bộ đơn hàng',
		shipped: 'đã giao hàng',
		pending_receipt: 'đã gửi đến,đợi xác nhận',
		confirm_receipt: "đã xác nhận hoàn tất",
		printed_time: 'thời gian in',
		print_order: 'in đơn hàng',
		print_picking_list: 'in đơn phân chọn hàng ',
		delivery_store: 'kho giao hàng',
		todelivered: 'đợi giao hàng',
		view_logistics: "kiểm tra vận chuyển "




	},
	problemorder: {
		title: 'đơn hàng có vấn đề',
		tap_tuhuoguanli: 'quản lý việc trả hàng',
		tap_tuhuobaoguo: 'đóng gói trả hàng trong kho',
		tap_maijiaqueren: 'người bán đã xác nhận',
		tap_audited: 'đã xử lý',
		tap_canceled: 'đã hủy đơn hàng',
		tap_return: 'đơn trả hàng',
		tap_in_cancel: 'yêu cầu hủy bỏ đơn hàng',
		tap_in_cancel01: 'đang xin phép',
		tap_alerdy_return: 'đã chấp nhận trả hàng',
		tap_cancel_return: 'hủy trả hàng',
		tap_in_return: 'đang trả hàng',
		tap_dispute: 'người bán tranh luận',
		tap_ruling: 'đang phán quyết',
		tap_returned_money: 'đã hoàn tiền',
		tap_close: 'đã đóng',
		tap_return_bysellser: 'người bán kiểm toán trả hàng',
		tap_seller_comfirm: 'người bán đã xác nhận',
		tap_processed: 'đã xử lý',
		tap_delivery_failed: 'giao hàng thất bại',
		tap_courier_loss: 'mất mát đóng gói',
		tap_delivery_timeout: 'giao hàng hết giờ',
		tap_pay_timeout: 'thanh toán hết giờ',
		tap_seller_cancel: 'người mua hủy bỏ',
		tap_others: 'khác',
		tap_ordered: 'kho đã in đơn hàng（không thể hủy bỏ）',
		tap_nerver_order: 'kho chưa in đơn hàng（có thể hủy bỏ）',
		nodata: ' hiện không có đơn hàng',
		return_trickNO: 'số vận đơn trả hàng ',
		original_order: 'số đơn hàng ban đầu',
		return_order: 'số đơn hàng bị trả lại',
		order_status: 'tình trạng đơn hàng',
		cancel_time: 'thời gian hủy bỏ',
		print_time: 'thời gian in',
		quantity: 'số lượng',
		return_quantity: 'số trả hàng',
		cancel_reason: 'nguyên nhân đơn hàng bị hủy bỏ',
		shop: 'cửa hàng',
		receipent: 'người nhận hàng ',
		phone: 'điện thoại',
		return_reason: 'nguyên nhân trả hàng',
		seller_name: 'tên nick người mua',
		seller_Email: 'Eamil của người mua',
		deliver_store: 'kho giao hàng',
		delivery_method: 'phương thức vận chuyển ',
		actuall_pay: 'tiền thanh toán thực tế',
		trickNO: 'số vận đơn ',
		return_count: 'kim ngạch đơn hàng bị trả',
		origin_prick: 'giá cả đặt mua không có chiết khấu',
		buyer_delivery_deadline: 'thời gian cuối cùng người mua giao hàng',
		seller_processing_return_due: 'thời gian cho người bán sử lý trả hàng đã hết ',
		view_logistics: "kiểm tra vận chuyển",
		return_package: 'ảnh hàng liên quan đến trả hàng',
		confirmed_by_seller: 'đăng bán lại hoặc tiêu hủy',
		be_processed_by_store: 'đợi kho xử lý',
		search_tip: 'kiểm tra đơn hàng',
		search: 'tìm kiếm',
		no: 'hiện không có',
		price: 'giá cả'

	},
	mygoods: {
		allShop: 'toàn bộ cửa hàng',
		ppo: 'kỷ lục',
		search: 'tìm kiếm',
		search_tip: 'có thể tìm kiếm bằng tên hàng，sku',
		synchronize: 'đồng bộ với sản phẩm trên shopee',
		Generate_warehouse_items: 'import hàng trong kho',
		itemID: 'ID hàng',
		shop: 'cửa hàng',
		price: 'giá cả',
		stock: 'kho',
		cusCode: ' mã số kho',
		sales: 'số lượng tiêu thụ',
		status: 'tình trạng',
		update: 'thời gian cập nhật',
		sku: 'sku',
		Whether_to_booking: 'có bán trước hay không',
		yes: 'có',
		no: 'phải',
		more: 'thêm',
		viewOrder: 'kiểm tra đơn hàng',
		viewSales: 'kiểm tra tình trạng bán hàng',
		generated: 'đã import hàng trong kho',
		isTarget: 'sản phẩm này đã bị chọn',
		vieworder: 'kiểm tra đơn hàng',
		viewsales: 'kiểm tra tình trạng bán hàng',

		qingdang: {
			title: "danh mục hàng",
			Img: 'ảnh',
			name: 'tên hàng',
			cost: 'Giá vốn',
			operate: 'thao tác',
			dele: 'xóa',
			store: 'kho nhận hàng',
			qingkong: 'xả kho',
			submit: 'nộp',
			choose: 'chọn kho...'
		},
		details: {
			title: "chi tiết danh mục kho",
			Img: 'ảnh',
			name: 'tên cửa hàng',
			SKU: 'SKU',
			cusCode: 'cusCode',
			ok: 'xác nhận ',
			success: 'nhập số liệu vào kho thành công ',
			fail: 'nhập số liệu vào kho thất bại（kho đã có）',
		}
	},

	binditems: {
		allShop: 'toàn bộ cửa hàng',
		ppo: 'kỷ lục',
		search: 'tìm kiếm',
		search_tip: 'nhập tên hàng để tìm kiếm',
		Generate_warehouse_items: 'liên kết các hàng',
		itemID: 'ID hàng',
		shop: 'cửa hàng',
		price: 'giá cả',
		stock: 'kho',
		cusCode: 'mã số kho',
		sales: 'số lượng tiêu thụ',
		satus: 'tình trạng',
		update: 'thời gian cập nhật',
		sku: 'sku',
		generated: 'đã  liên kết',
		bind: 'liên kết',
		jieban: 'hủy liên kết',
		isTarget: 'đã chọn ',
		bindDetexl: {
			title: "liên kết các hàng",
			tip: 'vui lòng nhập mã số hàng',
			search: 'tìm kiếm',
			Img: 'ảnh',
			shopId: 'cửa hàngId',
			name: 'tên hàng',
			SKU: 'sku',
			dele: 'xóa',
			operate: 'thao tác',
			qingkong: 'xóa tất cả',
			submit: 'nộp',
			cusCode: 'mã số kho',
			store: 'kho'
		},
		details: {
			title: "tình trạng liên kết",
			Img: 'ảnh',
			name: 'tên hàng',
			SKU: 'SKU',
			cusCode: 'mã số kho',
			ok: 'xác nhận ',
			success: 'liên kết thành công',
			fail: 'liên kết thất bại （hàng đã bị liên kết）',
		}
	},
	userStoreItems: {
		ok: 'mình hiểu rồi',
		Prompt: 'lợi nhắc',
		ppo: 'kỷ lục',
		search: 'tìm kiếm',
		search_tip: 'có thể tìm kiếm bằng mã kho，sku,tên hàng ，mã vạch hàng ',
		synchronize: 'đồng bộ số đơn hàng đợi giao hàng',
		Generate_warehouse_items: 'tạo ra đơn nhập kho',
		stock_suggestion: 'góp ý mua sắm',
		allcurrentpage: 'chọn toàn bộ trang hiện tại',
		mass_open_updata_stock: 'mở tính năng tự đồng cập nhật số hàng trong kho hàng loạt',
		mass_close_updata_stock: ' đóng tính năng tự động cập nhật số hàng trong kho hàng loạt',
		kki: 'số hàng đã liên kết sẽ luôn cập nhật là số hàng trong kho thực tế（ngoài hàng bán trước)。',
		shop: 'cửa hàng',
		userName: 'tên người dùng',
		warehouse: 'kho',
		cost: 'Giá vốn',
		cusCode: 'mã số kho',
		online_stock: 'kho online',
		shipping_stock: 'tổng số đơn hàng đợi giao hàng',
		total_stock: 'số hàng trong kho',
		auto_update: 'tự động cập nhật số hàng trong kho',
		create_ruku: 'sáng lập nhập kho',
		selected: 'đã chọn ',
		edit: 'biên tập',
		nodata: 'hiện không có sản phẩm',
		all: 'toàn bộ kho',
		confirmBtn: 'xác nhận',
		binditems: 'liên kết SKU chi nhánh này',
		caigoudangtip: 'xây dựng đơn hàng mua sắm thành công，số đơn hàng mua sắm là',
		delet: 'xóa',
		on: 'mở',
		off: 'đóng',
		caigou: {
			title: "danh mục mua sắm",
			Img: 'ảnh',
			name: 'tên hàng',
			caigouqunatity: 'số lượng mua sắm',
			anthreName: 'tên khác hàng',
			operate: 'thao tác',
			dele: 'xóa',
			tip: 'vui lòng nhập ghi chú cho kho',
			qingkong: 'xóa tất cả',
			submit: 'nộp',
		},
		bindItem: {
			title: ' thông tin về hàng đã liên kết',
			xinzhen: 'hàng liên kết mới',
			anthreName: 'tên hàng',
			operate: 'thao tác',
			shopName: 'tên của hàng',
			jieban: 'hủy liên kết',
			tip: 'hàng trong kho ít nhất cần phải liên kết một hàng trực tuyến，nếu không cần hàng này thì xóa đi ',
			jiebansuccess: 'hủy liên kếtthành công'
		},
		update: {
			tip: 'nhắc nhở cập nhật số hàng trong kho ',
			open: 'thôi，mở đi',
			close: 'đóng',
			close01: 'thôi，đừng mở',
			open01: 'hiểu rồi，vẫn mở',
			text01: 'sau khi mở tính năng tự động cập nhật số hàng trong kho，số hàng trong kho trên shopee của toàn bộ hàng mà hàng trong kho này đã liên kết sẽ được tự đồng thành số hàng còn lại thực tế của hàng này，vui lòng xác nhận mở hay không？',
			text02: 'vui lòng chọn hàng cần đóng tính năng tự động cập nhật số hàng trong kho！',
			text03: ' sau khi đóng tính năng tự động cập nhật số hàng trong kho，số hàng trong kho của hàng này sẽ không ảnh hưởng đến số hàng trong kho trên shopee của toàn bộ hàng đã liên kết ，vui lòng xác nhận mở hay không？',
			text04: 'vui lòng chọn hàng cần mở tính năng tự động cập nhật số trong kho！',
			text05: 'sau khi mở tính năng tự động cập nhật số hàng trong kho，số hàng trong kho trên shopee của toàn bộ hàng mà hàng trong kho này đã liên kết sẽ được tự đồng thành số hàng còn lại thực tế của hàng này：',
			text06: '，vui lòng xác nhận mở hay không？',
			text07: 'sau khi đóng tính năng tự động cập nhật số hàng trong kho，số hàng trong kho của hàng này sẽ không ảnh hưởng đến số hàng trong kho trên shopee của toàn bộ hàng đã liên kết ，vui lòng xác nhận mở hay không？'
		},
		Quantitytobeshipped: 'đã xét duyệt và đợi giao hàng',
		long: 'chiều dài',
		width: 'chiều rộng',
		height: 'chiều cao',
		weight: 'trọng lượng',
		more: 'thao tác thêm',
		vieworder: 'kiểm tra đơn hàng',
		viewsales: 'kiểm tra tình trạng tiêu thụ',
		viewstockstore: 'kiểm tra nhật ký kho',
		del: 'xóa',
		quehuo: 'nhắc lại thiếu hàng'


	},
	sellerpurchase: {
		All_warehouses: 'toàn bộ kho',
		All_inbound_orders: 'toàn bộ đơn nhập kho',
		Warehousing: 'tìm kiếm số đơn nhập kho',
		Find: 'tìm kiếm',
		Create_warehouse_receipt: 'xây dựng đơn nhập kho',
		order_number: 'số đơn nhập kho',
		infact_time: 'thời gian hàng gửi đến thực tế',
		status: 'trạng thái đơn nhập kho',
		Creation_time: 'thời gian dự tính hàng gửi đến',
		Warehouse: 'nhập kho',
		country: 'số lương mua',
		message: 'tin nhắn',
		operating: 'thao tác ',
		ship: 'tổng giá thành vận chuyển',
		View_items: 'kiểm tra mặt hàng',
		delet: 'xóa',
		wait_store_check: 'đợikhokiểm tra',
		wait_check_in: 'đợi người bán xác nhận nhập kho',
		aleady_check_in: 'đã xác nhận nhập kho',
		comfirm: ' xét duyệt nhập kho',
		cusCode: 'mã số kho',
		name: 'tên hàng',
		Purchase_quantity: 'số lượng mua sắm',
		Purchase_information: 'thông tin về mặt hàng mua sắm',
		rukudanghao: 'số đơn nhập kho',
		create_time: 'thời gian sáng lập danh mục mặt hàng mua sắm',
		rukustore: 'kho',
		sellerMessage: 'tin nhắn người bán',
		rukushuliangcomfirm: 'xác nhận số hàng trong đơn mua sắm đã nhập kho',
		confirm_time: 'thời gian xác nhận mục hàng mua sắm',
		rukustore: 'nhập kho',
		storeMessage: 'lời nhắc cho kho',
		rukuNo: 'số hàng nhập kho',
		actualNo: 'số hàng đã gửi đên thực tế',
		ok: 'đã xác nhận，hàng trong khon đã tăng thêm',
		I_know: 'mình hiểu rồi',
		warn: 'lời nhắc',
		sub: 'nộp cho người bán xác nhận',
		tosellermsg: "lời nhắc cho người bán",
		anthoeName: 'tên khác sản phẩm',
		check: 'kiểm tra',

	},
	lazada: {
		time: 'thời gian mua',
		total: 'tổng kim ngạch',
		paytotal: 'tiền thanh toán',
		shippingfee: 'phí vận chuyển',
		fahuoleixi: 'loại giao hàng',
		zuihoufahuo: 'thời gian còn lại để giao hàng',
		shop: 'cửa hàng',
		shopid: 'ID cửa hàng',
		paymenthod: 'phương thức thanh toán',
		receipt: 'người nhận hàng',
		phone: 'điện thoại',
		trickno: 'số vận đơn ',
		printTime: 'inthời gian',
		choose: 'chọn phương thức vận chuyển',
		generate: 'tạo ra',
		pendinggenerate: 'tiền thanh toán thực tế'
	},
	orderPrint: {
		WarehouseType: ' loại kho：',
		LoadingStatus: 'đang tải：',
		PrintStatus: 'đang in：',
		LogisticsType: 'loại Logistics：',
		FinalDelivery: 'giao hang cuối cùng：',
		OrderStatus: 'trạng thái đơn hàng：',
		OrderContains: 'đơn hàng gồm：',
		Searchquery: 'tìm kiếm kiểm tra：',
		Includequery: 'bao gồm tìm kiếm：',
		exclude: 'bài trừ',
		Precise: 'tóm lược',
		generatingWaybillNo: 'bắt đầu tạo ra số vận đơn ',
		Default_printing: 'in mặc định',
		Ordertimeorder01: 'xếp thời gian lên đơn hàng（sớm đến muộn）',
		Ordertimeorder02: ' xếp thời gian（muộn đến sớm）',
		Sortbyquantity01: 'xếp số（nhiều đến ít）',
		Sortbyquantity02: 'xếp số（ít đến nhiều）',
		Sort_by_number_ofsku01: 'xếp số sku（nhiều đến ít）',
		Sort_by_number_ofsku02: 'sku（ít đến nhiều）',
		Sort_by_pushtime_early: 'xếp hàng thời gian gửi đến（muộn đến sớm）',
		Sort_by_pushtime_late: 'xếp hàng thời gian gửi đến（sớm đến muộn）',
		MassSetPickupTime: 'cài đặt phương thức lấy hàng hàng loạt（Pick up hoặc Drop off）：',
		Unselect_current_page: 'chọn những trang chưa trọn ',
		Select_current_page: 'chọn toàn bộ trạng hiện tại',
		Order_is_scheduled: 'đơn hàng hiện tại đã  được xử lý',
		all: 'toàn bộ',
		Loaded: 'đã tải',
		not_loaded: 'chưa tải',
		Generated: 'đã tạo ra',
		Not_generated: 'tiền thanh toán thực tế',
		Printed: 'đã  in',
		To_print: 'chưa in',
		To_delivered: 'đợi giao hàng',
		Pickup_failed: 'lấy hàng thất bại',
		Multiple_SKU: 'nhiều SKU',
		Single_SKU: 'một SKU',
		select_Order: 'vui lòng chọn đơn hàng！',
		waybill_No: 'hệ thống đang tạo ra số vận đơn ，vui lòng chời một lát để cập nhật lại trang web hiện tại！',
		Copy: 'sao chép ký tự thành công',
		Order_sorting: 'xếp đơn hàng',
		Pickup_time: 'thời gian lấy hàng',
		Order_scheduled: 'đơn hàng hiên tại đã được xử lý',
		Print_status: 'trạng thái in văn bản',
		Packaged: 'đã xuất kho',
		Unpackaged: 'chưa xuất kho',
		Combine_print_orders: 'tổng hợp in đơn hàng',
		Combined_print_picklist: 'tổng hợp in đơn chọn hàng',
		Regenerate_order: 'tạo ra lại đơn mặt hàng',
		tip: 'đơn hàng bị mất hoặc hệ thống thông báo sai lầm,vui lòng tạo ra lại đơn hàng,lại in!',
		Print_name: 'in tên',
		shop: 'cửa hàng',
		latest_time: 'thời gian in-(thời gian mới nhất)',
		operare: 'thao tác',
		print_order: 'in đơn hàng',
		Printed_order: 'đã  in(đơn hàng)',
		Print_picklist: 'in đơn phân chọn hàng hàng loạt',
		Printed_picklist: 'đã  in(đơn phân chọn hàng)',
		close: 'đóng',
		Order_acquisition_status: 'thu thông tin về tình trạng đơn hàng：',
		completed: 'đã hoàn tất',
		order: 'trang',
		total: 'tổng cộng',
		tip02: 'đơn hàng không được ủng hộ sắp xếp vào thời gian này ',
		search_tip: 'vui lòng nhập số đơn hàng',
		search_tip02: "vui lòng nhập tên hàng,Id hàng,SKU",
		open01: 'mở kiểu mẫu chọn hàng loạt',
		open02: 'chọn toàn bộ',
		open03: 'chọn những chưa chọn',
		already: 'đã tạo ra số vận đơn ',
		default_second: 'không cài đặt mặc định vào ngày tiếp theo',
		store: ' chọn cửa hàng：',
		stock: 'loại kho：'



	},
	remind: {
		header: 'tính năng nhắc nhở',
		remind_message: 'nếu mở tính năng nhắc lại tự động, thì sẽ thu phí theo số tin nhắc đã tự động gửi đến ,giá tin nhắc tuy theo quốc gia 。',
		charge: '(giá tin nhắc quốc tế：Ma-lai-xi-a 0.25 điểm thưởng /một ，Thái Lan 0.15  điểm thưởng/một)',
		seller_back: 'cài đặt tính năng nhắc lại',
		shopee: 'cửa hàng shopee',
		orderCare: ' theo dõi đơn hàng',
		record: "kỷ lục sử dụng",
		paymentRemind: "nhắc lại thanh toán",
		open: "mở",
		close: "đóng",
		displayEchart: "trưng bày kết quả",
		totalSend: "số đã gửi",
		successRecive: "số thành công tiếp nhận",
		edit: "mẫu sửa đổi",
		remindTypt: "loại nhắc lại",
		orderId: "số đơn đặt hàng",
		orderIdPlaceholder: "vui lòng nhập số đơn hàng",
		buyerName: "tên người mua",
		buyerPlaceholder: "tìm kiếm tên người mua",
		tableTypt: "loại",
		tableChargeNum: "số thu phí",
		integralCost: "số điểm thưởng đã sử dụng",
		status: "đã nhận hàng",
		arriveTime: "thời gian gửi đến",
		arriveTime: "thời gian gửi đạt",
		shipReminder: "nhắc nhở giao hàng",
		signRemind: "nhận hàng và thúc giục bình luận",
		displayEffect: "trình bày hiệu quả",
		succseePayOrdersNum: "số lượng đơn hàng thành công thanh toán",
		successSendMessage: "sau gửi tin nhắn",
		pleaseSelect: "vui lòng chọn",
		lately: "gần đây",
		totalSend: "tổng gửi đi",
		strip: "bản",
		successRecive_: "tiếp nhận thành công",
		successPayOrder: "thanh toán đơn hàng thành công",
		successPay: "thanh toán thành công",
		sendAndSuccessSendCount: "số tin nhắn gửi và số gủi thành công",
		ifOnlyRemindCod: "chỉ nhắc nhở đơn hàng COD hay không",
		orderId: "số đơn",
		buyerName: "tên người mua",
		Type: "loại hình",
		CountNum: "bản tin nhắn thu phí",
		CountIntegral: "tiêu hao tích phân",
		deliveryResult: "kết quả gửi đạt",
		arriveTime: "thời gian gửi đạt",
		acceptFail: "tiếp nhận thất bại",
		acceptSuccess: "tiếp nhận thành công",
		sending: "đang gửi",
		acceptOutTime: "tiếp nhận quá thời",
		latelySendAndSuccessCount: "số tin nhắn đã gửi và số gửi thành công gần đây",
		sendMessageTotal: "tổng số tin nhắn đã gửi",
		sendSuccessCount: "số tin nhắn gửi thành công",
		successPayCount: "số thành công thanh toán",
		toData: "cách đây",
		setCountOption_tip1: "trước",
		setCountOption_tip2: "tổng gửi ",
		setCountOption_tip3: "tin nhắn gửi đi thành công",
		In: 'ở',
		seccessPay: 'tổng thanh toán thành công',
		order: "đơn hàng",
		queryTime: "",
		//remind_Template
		back: "trở về",
		currentTemplate: "bản mẫu tin nhắn hiện tại",
		Bracket_tip: "( trong dấu ngoặc là lượng biến đổi đơn hàng，hệ thống sẽ tự động thu được)",
		currentSelectTemplate: "bản mẫu đã chọn hiện tại ",
		testTemplate: "bản mẫu tin nhắn kiểm nghiệm",
		sentTestMessage: "gửi tin nhắn kiểm nghiệm",
		systemTemplate: "bản mẫu hệ thống",
		customTemplate: "bản mẫu tùy chỉnh",
		defaultLanguage_tip: "ban đầu mặc định ngôn ngữ là tiếng Anh",
		customTemplateLanguage_tip: "bản mẫu tùy chỉnh không ủng hộ ngôn ngữ nhiều nước",
		saveSetting: "bảo tồn cài đặt",
		insertLabel: "thêm nhãn",
		what_label: "nhãn là gì",
		label_tip: "sau thêm nhãn,khi gửi tin nhắn hệ thống sẽ tự động điền vào dữ liệu đơn hàng hoặc tên đối ứng trong nhãn，không cần tự chỉnh sửa các nội dung.",
		haveInput: "đã nhập",
		character: "ký tự",
		countCharacterTip: "ID người mua quá dài sẽ có khả năng dẫn đến thu phí nhiều",
		limitLengthTip: "ký tự tin nhắn nhiều nhất là 536 cái ",
		messageChargeTip: "báo giá tin nhắn quốc tế：Malaysia 0.25 tích phân/bản,Thái Lan 0.15 tích phân/bản",
		messageCount: "số bản tin nhắn",
		paymentRemind_tip1: "sau người mua lên đơn 30 phút nhưng còn chưa thanh toán ,hệ thống sẽ tự động gửi tin nhắn（kim ngạch đơn hàng 0 USD trở lên mới nhắc nhở ）.",
		paymentRemind_tip2: "1 người bán chỉ có thể thúc giục thanh toán 1 lần cùng ngày.",
		paymentRemind_tip3: "đơn hàng đã thanh toán của người mua trong shop cùng ngày≥1,sẽ tự động huỷ thúc giục thanh toán.",
		shipRemind_tip1: "sau người bán giao hàng，sẽ tự động gửi tin nhắn thông báo người mua(kim ngạch đơn hàng 0 USD trở lên mới nhắc nhở）.",
		shipRemind_tip2: "nếu đã nhận hàng hoặc hàng đã đến thành phố người mua thì không gửi",
		signRemind_tip1: "trong vòng 72 người mua nhận hàng,tự động gửi tin thông báo（nếu người mua đã xác nhận nhận hàng thì không gửi）,kim ngạch đơn hàng 0 USD trở lên mới nhắc nhở）.",
		sendCondition: "tiều kiện gửi",
		chargeStandard: "tiêu chuẩn thu phí",
		addTemplate: "thêm bản mẫu",
		messageType: "loại tin nhắn",
		chargeCountStandard: "tiêu chuẩn thu phí",
		messageType_tip1: "không bao gồm ký tự đặc biệt",
		messageType_tip2: "ký tự/bản",
		templateChoose: "lựa chọn bản mẫu",
		testPhoneNum_tip: "vui lòng nhập điện thoại kiểm nghiệm",
		English: "tiếng Anh",
		Chinese: "tiếng Trung",
		My: "tiếng Malaysia",
		Th: "tiếng Thái Lan",
		recipientName: "tên người nhận",
		OrderId: "số đơn",
		shopName: "tên shop",
		purchaseDate: "ngày mua",
		selectTemplate: "vui lòng chọn bản mẫu",
		failSaveTemplate: "bảo tồn bản mẫu thất bại",
		confirmButtonText: "xác định",
		inputeContent: "vui lòng nhập nội dung",
		addCustomFail: "thêm bản mẫu tùy chỉnh thất bại",
		outLimit: "chiều dài ký tự tin nhắn tùy chỉnh quá giới hạn",
		confirmDeleteCustom: "thao tác này sẽ xóa bản mẫu tùy chỉnh,tiếp tục hay không?",
		tip: "lưu ý",
		cancel: "xóa",
		successDelete: "xóa thành công",
		haveCancelDelete: "đã huỷ bỏ xóa",
		haveSendTestMessage: "đã gửi tin nhắn kiểm nghiệm",
		failSendTestMessage: "gửi tin nhắn kiểm nghiệm thất bại",
		phoneFormatErr: "quy cách số điện thoại sai hoặc chưa chọn bản mẫu kiểm nghiệm"
	},

	distribution: {
		//erpba trang nền tảng distribution trong hệ thống
		// Community
		shipmentPlace: "nơi giao hàng",
		generateH5: " tạo ra trang chỉa sẻ h5",
		searchStore: "tìm kiếm mã kho,sku,tên sản phẩm",
		mSKU: "mSKU",
		price: "giá cả",
		oneOffer: "một kiện chuyển hộ",
		stockNum: "kho hàng",
		haveDistribution: "tôi đã Distribution",
		havenDistribution: "tôi muốn Distribution ",
		//Tab
		distributionProduct: "sản phẩm trong kho distribution",
		distributionLibrary_tab: "kho chọn hàng để distribution ",
		distributionHaveSupply_tab: "tôi có thể cung ứng sản phẩm",
		distributionHaveAgent: "tôi đã thay mặt",
		//hasAgent
		stockType: "loại kho",
		selectAll: "chọn toàn bộ trang hiện tại",
		operationBatch: "thao tác hàng loạt",
		operationBatchDelete: "xóa sản phẩm đã chọn hàng loạt",
		sSKUNum: " số lượng sSKU",
		totalStock: "tổng kho hàng",
		releaseProduct: "đưa ra sản phẩm",
		updateItemTip1: "hiện nay sản phẩm trong khọ distribution chưa liên kết thông tin bản mẫu,vui lòng liên kết một sản phẩm lại đưa ra！",
		updateItemTip3: "sang trang quản lý bản mẫu để liên kết",
		cancel: "xóa",
		tip: "lưu ý",
		determine: "xác nhận",
		confirmDelete: "vui lòng xác nhận xóa sản phẩm đã chọn？",
		deleteSuccess: "xóa thành công",
		//myselfproduct
		distributionH5Link: "linh trang chia sẻ H5 về sản phẩm distribution",
		copy: " copy",
		deleteFileTip: "xóa thất bại！",
		failReason: "nguyên nhân thất bại",
		nowSelect: "đã chọn hiện tại",
		importProducts: "import sản phẩm",
		havenProduct: "không có sản phẩm",
		offshelfdistribution: "off shelf distribution",
		Onshelfdistribution: "On shelf distribution",
		confirmOffshelf: "xác định Off shelf sản phẩm này ？",
		confirmOnshelf: "xác định on shelf sản phẩm này đến kho chọn hàng để distribution ？",
		successOnshelf: "On shelf distribution thành công！",
		successOffShelf: "off shelf distribution thành công！",
		successCopy: "copy thành công"
	},



	h5: {
		verification: 'mã xác minh SMS',
		phone: 'số điện thoại',
		login: 'đăng nhập ngay lập tức',
		send: 'Gửi mã xác minh',
		phoneDesc: 'Nhập số điện thoại di động',
		passWordeDesc: 'nhập mã xác nhận',
		DSX_index_note: 'Thân mến~ Bạn chưa đăng nhập! ',
		DSX_index_log: "đăng nhập ngay lập tức",
		DSX: 'cửa hàng thích hợp',
		DSX_title: 'Nền tảng phân phối nguồn địa phương Dianxiaosheng Đông Nam Á',
		DSX_qty: 'Số lượng giao ngay',
		DSX_dropship: 'Phân phối ngay bây giờ',
		DSX_specification: 'thông số kỹ thuật (1)',
		DSX_price: '1 cái thay cho giá',
		DSX_qty1: 'Cổ phần:',
		DSX_des: 'Mô tả Sản phẩm',
		DSX_details: 'Thông tin chi tiết sản phẩm',
		DSX_index_slogn: 'Danh sách nóng phân phối hàng hóa giao ngay Đông Nam Á',
		DSX_index_recommendation: 'danh sách khuyến nghị hấp dẫn',
		DSX_index_th: 'Nước Thái Lan',
		DSX_index_my: 'Malaysia',
		DSX_index_ph: 'Philippines',
		DSX_index_tw: 'Đài Loan',
		DSX_index_id: 'Indonesia',
		DSX_index_vn: 'Việt Nam',
		DSX_index_bz: 'Brazil',
		DSX_index_cn: 'Kho thử nghiệm Trung Quốc',
		DSX_index_price: '1 cái thay cho giá',
		DSX_index_profit: 'Tỷ suất lợi nhuận gộp',
		DSX_index_qty: 'Khoảng không quảng cáo tại chỗ',
		DSX_index_country: 'Phân tích thị trường Malay',
		DSX_index_sample: 'Tôi muốn một mẫu',
		DSX_index_dropship: 'Tôi muốn phân phối',
		DSX_index_welcome: 'Chào mừng',
		DSX_index_signout: 'từ bỏ',
		DSX_index_back: 'trở lại',
		DSX_index_Quote: 'Nhận yêu cầu',
		DSX_index_detail: 'Thông tin chi tiết sản phẩm',
		DSX_index_distribute: 'Phân phối ngay bây giờ',
		DSX_index_tips: 'Sản phẩm đã được phân phối thành công vào tài khoản shopee của bạn. Để phân phối sản phẩm lên nền tảng shopee, vui lòng truy cập nền tảng phân phối trên PC: Tôi là đại lý, tiếp tục hoạt động!',



	},

	other: {
		a1: 'Tải hình ảnh không thành công...',
		a2: 'Đang tải hình ảnh...',
		a3: 'Liên hệ với dịch vụ khách hàng',
		a4: 'Dịch vụ khách hàng kho hàng ở nước ngoài',
		a5: 'Khép kín',
		a6: 'Nhấp để tải xuống gói cài đặt plug-in CRX',
		a7: 'Giới thiệu plugin',
		a8: 'Beianalysis là một công cụ hoạt động được cung cấp đặc biệt cho người bán trên Shopee, có thể giúp người bán trên Shopee lựa chọn sản phẩm và phân tích dữ liệu sản phẩm một cách hiệu quả. Áp dụng cho Shopee Thái Lan, Malaysia, Indonesia, Việt Nam và tám trang web khác, bạn có thể tự tin trải nghiệm. Nó có thể hiển thị các dữ liệu liên quan sau trên bất kỳ trang chi tiết sản phẩm nào của Shopee',
		a9: '①Ngày ra mắt sản phẩm; doanh số bán hàng/doanh số/khách truy cập/chỉ số chuyển đổi; nghi ngờ gian lận.',
		a10: '② Theo dõi sản phẩm trên Shopee theo thời gian thực, tìm kiếm nguồn hàng cùng loại, sản phẩm cạnh tranh cùng mẫu mã…',
		a11: 'Hướng dẫn sử dụng:',
		a12: 'Nhấp để xem: đề xuất ngành/đề xuất tìm kiếm/đề xuất cửa hàng ba tình huống sử dụng',
		a13: 'Hướng dẫn cài đặt',
		a14: 'Cách 1: Sau khi giải nén file tải về, bạn hãy đặt nó trên màn hình nền máy tính được đề xuất để dễ dàng thao tác. Các bước thao tác như sau:',
		a15: 'Mở Google Chrome --> Tìm góc trên bên phải... > Sau đó nhấn Open tìm -More Tools --> Sau đó tìm -Extensions --> Bật chế độ nhà phát triển --> Kéo file .CRX vào desktop trực tiếp Gửi đến giao diện ở chế độ nhà phát triển và quá trình cài đặt có thể hoàn tất!',
		a16: 'Cách 2: Sau khi lên mạng một cách khoa học,',
		a17: 'nhấp vào liên kết',
		a18: 'Truy cập Google Mall để cài đặt trực tiếp:',
		a19: 'Quét mã để tải xuống ứng dụng nền tảng phân phối Android',
		a20: 'Ứng dụng người bán (Android)',
		a21: 'Ứng dụng kho hàng (Android)',
		a22: 'Lời nhắc nhở',
		a23: 'Ứng dụng phía người bán: Nó có thể thực hiện quản lý đơn đặt hàng / trả lại và trò chuyện đa cửa hàng Shopee, bao gồm dịch tự động, trả lời tự động, chuyển đổi nhiều cửa hàng, v.v.',
		a24: 'Ứng dụng phía kho hàng: Với máy quét PDA hoặc Bluetooth, nó có thể thực hiện phân loại và kiểm tra đơn hàng, quét ra khỏi kho, quét trả lại và trao đổi, v.v.',
		a25: 'lịch sử in',
		a26: 'Tìm kiếm số thứ tự',
		a27: 'tìm kiếm',
		a28: 'Hợp nhất bản in',
		a29: 'chọn',
		a30: 'tên',
		a31: 'Thời gian in - (thời gian gần nhất)',
		a32: 'lần in',
		a33: 'vận hành',
		a34: 'Kiểm tra',
		a35: 'Thêm số vận đơn',
		a36: 'Vui lòng nhập số vận đơn sẽ được thêm vào:',
		a37: 'Vui lòng nhập số vận đơn',
		a38: 'xác nhận',
		a39: 'Kiểm tra và chấp nhận hàng hóa đã đóng gói',
		a40: 'Vui lòng xác nhận số vận đơn của hàng hóa đã nhận:',
		a41: 'Vui lòng chọn số vận đơn',
		a42: 'Chi tiết nạp tiền',
		a43: 'Tìm kiếm theo thời gian giao dịch',
		a44: 'Tìm kiếm theo thời gian thanh toán',
		a45: 'ngày bắt đầu',
		a46: 'ngày cuối',
		a47: 'ĐẾN',
		a48: 'phương thức thanh toán:',
		a49: 'Tình trạng thanh toán:',
		a50: 'xin vui lòng chọn',
		a51: 'Loại:',
		a52: 'Đặt hàng',
		a53: 'Số thứ tự thanh toán',
		a54: 'tích phân',
		a55: 'tình trạng',
		a56: 'phương thức thanh toán',
		a57: 'thời gian sáng tạo',
		a58: 'Chi tiết khấu trừ điểm',
		a59: 'Loại giao dịch',
		a60: 'số thứ tự',
		a61: 'giờ giao dịch',
		a62: 'điểm còn lại',
		a63: 'chọn phân loại sản phẩm',
		a64: 'sắp xếp thứ tự',
		a65: 'Tìm kiếm tên sản phẩm, SKU',
		a66: 'hình ảnh',
		a67: 'mã kho',
		a68: 'ID hàng hóa',
		a69: 'Mã cửa hàng',
		a70: 'Bộ lọc cửa hàng:',
		a71: 'Trả về bộ lọc lý do: ',
		a72: 'Xuất Excel',
		a73: 'xuất tất cả',
		a74: 'Tất cả các Khiếu nại',
		a75: 'Sau khi xuất Excel và gửi cho dịch vụ khách hàng của nền tảng, bạn có thể nhấp vào nút Bắt đầu yêu cầu để liệt kê đơn đặt hàng này dưới dạng yêu cầu đang chờ xử lý nhằm tránh nhầm lẫn với đơn đặt hàng gói hàng mới bị mất',
		a76: 'lý do trả lại',
		a77: 'Số lượng',
		a78: 'cập nhật thời gian',
		a79: 'yêu cầu thời gian thành công',
		a80: 'Thời gian hiệu lực yêu cầu còn lại',
		a81: 'bắt đầu yêu cầu bồi thường',
		a82: 'kiểm tra hậu cần',
		a83: 'Để được liên hệ với dịch vụ khách hàng của nền tảng',
		a84: 'yêu cầu thành công',
		a85: 'Thông tin hậu cần',
		a86: 'Số vận đơn:',
		a87: 'số thứ tự:',
		a88: 'Tình trạng hiện tại: ',
		a89: 'thời gian',
		a90: 'Chi tiết hậu cần',
		a91: 'Điền thông tin nhận hàng',
		a92: 'Loại hàng hóa:',
		a93: 'Ôn lại',
		a94: 'dài:',
		a95: 'Điền vào chiều dài của mục',
		a96: 'Chiều rộng:',
		a97: 'Điền vào chiều rộng của mục',
		a98: 'cao:',
		a99: 'Điền vào chiều cao của mục',
		a100: 'cân nặng:',
		a101: 'Điền vào trọng lượng của mặt hàng',
		a102: 'Nhấp để tải ảnh lên',
		a103: 'Chỉ có thể tải lên các tệp jpg/png và không quá 500kb',
		a104: 'Lời nhắc nhở',
		a105: 'Nên xuất đơn hàng cần khiếu nại hiện tại sang bảng excel để lưu trữ dữ liệu trước khi thực hiện tất cả các khiếu nại, sau khi xác nhận, dữ liệu sẽ vào danh sách các đơn hàng đang khiếu nại!',
		a106: 'Hủy bỏ',
		a107: 'Xác nhận yêu cầu bắt đầu',
		a108: 'Tải lại đơn đặt hàng',
		a109: 'Chọn cửa hàng:',
		a110: 'Điền vào thứ tự:',
		a111: 'Điền vào số thứ tự',
		a112: 'tải ngay bây giờ',
		a113: 'tất cả',
		a114: 'Gói đã bị mất',
		a115: 'Giao hàng thất bại',
		a116: 'WeChat Pay',
		a117: 'Alipay',
		a118: 'Chưa thanh toán',
		a119: 'hoàn thành',
		a120: 'đóng cửa',
		a121: 'Đã sử dụng',
		a122: 'Theo điểm - từ nhiều đến ít',
		a123: 'Theo điểm - từ ít đến nhiều',
		a124: 'Thời gian tạo đơn hàng - từ sáng đến tối',
		a125: 'Thời gian tạo đơn hàng - từ muộn đến sớm',
		a126: 'Theo số lượng mua - từ nhiều đến ít',
		a127: 'Theo số lượng mua - từ ít đến nhiều',
		a128: 'Theo SKU - từ ít đến nhiều',
		a129: 'Mua theo SKU-từ nhiều đến ít',
		a130: 'tuần trước',
		a131: 'tháng trước',
		a132: 'Ba tháng qua',
		a133: 'Yêu cầu xác nhận đang chờ xử lý',
		a134: 'khiếu nại đang chờ xử lý',
		a135: 'Khiếu nại đã thành công',
		a136: 'Dịch vụ khách hàng của nền tảng phân phối',
		a137: 'nạp điện',
		a138: 'Sự tiêu thụ',
		a139: 'vấn đề hậu cần',
		a140: 'không có',
		a141: 'Thực hiện thao tác này sẽ hủy yêu cầu đối với đơn đặt hàng này, hãy xác nhận để hủy yêu cầu?',
		a142: 'gợi ý',
		a143: 'Vui lòng điền thông tin nhận hàng theo yêu cầu',
		a144: 'Thực hiện thao tác này sẽ hủy yêu cầu đối với đơn đặt hàng này, hãy xác nhận để hủy yêu cầu?',
		a145: 'Chắc chắn',
		a146: 'Hủy bỏ',
		a147: 'Chưa thanh toán',
		a148: 'Đã thanh toán',
		a149: 'Wechat',
		a150: 'Vui lòng đánh dấu vào mục',
		a151: 'Hiện tại không có đơn đặt hàng có thể được yêu cầu! ',
		a152: 'Vui lòng chọn một đơn đặt hàng',
		a153: 'Plug-in bảng dữ liệu phân tích vịnh',
		a154: 'Chọn Phương thức Thanh toán',
		a155: 'Không tải được mã QR thanh toán',
		a156: 'Số tiền thanh toán:',
		a157: 'nhân dân tệ',
		a158: 'Vui lòng sử dụng mã Alipay-quét để thanh toán',
		a159: 'Vui lòng sử dụng mã quét WeChat để thanh toán',
		a160: 'từ bỏ thanh toán',
		a161: 'Giao dịch hoàn tất',
		a162: 'Việc bán hàng',
		a163: 'Doanh thu hàng tồn kho:',
		a164: 'Chu kỳ bổ sung:',
		a165: 'Nhập chu kỳ bổ sung (số thuần túy)',
		a166: 'Xác nhận các thay đổi',
		a167: 'Khấu trừ hàng tồn kho trong quá trình vận chuyển',
		a168: 'Số mua được đề xuất',
		a169: 'Số lượng trên tay',
		a170: 'Số lượng đang vận chuyển',
		a171: 'Doanh số trung bình/ngày',
		a172: 'Chu kỳ bổ sung',
		a173: 'Doanh số bán hàng ước tính trong 7 ngày',
		a174: 'doanh số bán hàng ước tính trong 14 ngày',
		a175: 'doanh số bán hàng ước tính trong 30 ngày',
		a176: 'Những ngày còn lại có sẵn để bán',
		a177: 'bầu trời',
		a178: 'Tạo đơn đặt hàng',
		a179: 'tên sản phẩm',
		a180: 'Doanh thu hàng tồn kho',
		a181: 'Thời gian giao hàng mới nhất',
		a182: 'Trạng thái bán hàng tại cửa hàng',
		a183: 'xuất khẩu',
		a184: 'Ghi công đơn đặt hàng',
		a185: 'Đơn đặt hàng đại lý',
		a186: 'Trật tự tự xây dựng',
		a187: 'Đơn đặt hàng của người bán',
		a188: 'Ràng buộc hàng hóa',
		a189: 'Thêm ràng buộc hàng hóa',
		a190: 'Sản phẩm bán trước',
		a191: 'Đúng',
		a192: 'KHÔNG',
		a193: 'Cởi trói',
		a194: 'Tất cả các đơn đặt hàng thuộc về',
		a195: 'các loại',
		a196: 'khởi tạo hệ thống',
		a197: 'Đơn hàng sẽ được trừ kho hoặc đưa trở lại kệ hàng',
		a198: 'Thứ tự lưu trữ được thêm vào',
		a199: 'Kiểm tra đơn hàng chuyển',
		a200: 'Chuyển nhượng chứng khoán',
		a201: 'sửa đổi kho',
		a202: 'Nhắc nhở hết hàng',
		a203: 'Lời nhắc không thể bán được',
		a204: 'Doanh số bán hàng',
		a205: 'Việc bán hàng',
		a206: 'thời gian',
		a207: 'việc bán hàng',
		a208: 'cảnh báo hết hàng--',
		a209: 'Xác nhận gỡ bỏ ghim?',
		a210: 'Gỡ bỏ ghim thành công',
		a211: 'Vui lòng chọn một sản phẩm',
		a212: 'Một tháng trước',
		a213: 'Quản lý kiểm soát giá',
		a214: 'Thiết lập kiểm soát giá',
		a215: 'Số lượng Thiết lập',
		a216: 'Bảo quản',
		a217: 'Hình thuộc tính',
		a218: 'Tên gọi sku',
		a219: 'Giá cung cấp',
		a220: 'Giá bán buôn',
		a221: 'Giới hạn dưới kiểm soát giá phân phối',
		a222: 'Đặt giới hạn thấp hơn của giá bán cho các sản phẩm được liệt kê bởi các đại lý',
		a223: 'Thông tin đại lý',
		a224: 'Đại lý：',
		a225: 'Tài khoản：',
		a226: 'Mã kho hàng：',
		a227: 'Số gian hàng trên kệ：',
		a228: 'Giá chiết khấu trực tuyến',
		a229: ' Dỡ khỏi kệ sản phẩm đại lý',
		a230: 'Đề nghị nhập số lượng đại lý (khi là -1 có nghĩa là không hạn chế)',
		a231: 'Thành công！',
		a232: 'Giao dịch thành công！',
		a233: 'Xác nhận muốn cưỡng chế xóa nhà phân phối：',
		a234: 'sản phẩm… ?？',
		a235: 'Vâng',
		a236: 'Hạ sản phẩm thành công！',
		a237: 'Đại lý',
		a238: 'Biên tập',
		a239: 'Lưu cập nhật',
		a240: 'Giới hạn dưới của giá bán trực tuyến của kệ phân phối đại lý',
		a241: 'Sửa thông tin đơn hàng',
		a242: 'Đây có phải là một sản phẩm không:',
		a243: 'Lựa chọn kho hàng:',
		a244: 'Nhập ký tự tìm kiếm',
		a245: 'Tìm kiếm',
		a246: 'Đã chọn:',
		a247: 'Không có sản phẩm trong kho hàng',
		a248: 'Kho:',
		a249: 'sku mẹ：',
		a250: 'Lưu giữ trong kho：',
		a251: 'Một sản phẩm',
		a252: 'Gói',
		a253: 'Sản phẩm thông thường',
		a254: 'Sản phẩm phân phối',
		a255: 'Tìm theo tên sản phẩm',
		a256: 'Tìm theo mã kho',
		a257: 'Tìm kiếm theo mã sản phẩm',
		a258: 'Hệ thống phát hiện kho hàng bạn chưa kích hoạt, vui lòng đến cửa hàng ủy quyền và kích hoạt kho hàng bạn cần! ',
		a259: 'Tài khoản hiện tại chưa có tài khoản liên kết với kho! ',
		a260: 'Chưa có mô tả',
		a261: 'Thiết lập công thức tính giá cho giá bán lẻ',
		a262: 'Tỷ giá: tỷ giá đồng RMB sang nội tệ, Ví dụ 1 RMB =5.19 Baht, tức: tỷ giá hối đoái 0.192',
		a263: 'Chiết khấu: ví dụ sản phẩm chiết khấu 6, tức là: giảm giá 40%"',
		a264: 'Phí xuất kho: các quốc gia khác nhau có giá khác nhau',
		a265: 'Thêm công thức tính',
		a266: 'Công thức',
		a267: 'Phí nước ngoài RMB',
		a268: 'Tỷ giá',
		a269: 'Khu vực',
		a270: 'Tỷ suất lợi nhuận%',
		a271: 'Chiết khấu',
		a272: 'Thiết lập mặc định',
		a273: 'Xóa',
		a274: 'Xác nhận',
		a275: 'Thay ảnh chính từ link shopee',
		a276: 'Vui lòng nhập url liên kết trang chi tiết sản phẩm của shopee',
		a277: 'Vui lòng đợi trong khi tải tài nguyên hình ảnh. . . ',
		a278: 'Đang tải hoàn tất! ',
		a279: 'Được',
		a280: 'Tải hình ảnh thuộc tính lên',
		a281: 'Chỉ tải lên các tệp jpg, và không quá 10M',
		a282: 'gợi ý nhập hàng',
		a283: '1. Số ký tự trong tiêu đề sản phẩm lớn hơn 20 nhưng nhỏ hơn 120',
		a284: '2.sku độ dài không vượt quá 20 ký tự',
		a285: 'Phát hành sản phẩm',
		a286: 'Danh mục sửa đổi',
		a287: 'Thông tin cơ bản!',
		a288: 'Thông báo cửa hàng',
		a289: 'Hình ảnh chính của sản phẩm',
		a290: 'Sắp xếp ngẫu nhiên ảnh',
		a291: 'Thêm hình mờ',
		a292: 'Thay ảnh từ link shopee',
		a293: 'Chỉ có thể tải lên tối đa 8 tệp jpg/png, không quá 10M',
		a294: 'tải lên hình ảnh',
		a295: 'Tiêu đề sản phẩm',
		a296: 'Số lượng ký tự tiêu đề nên được kiểm soát trong khoảng 20~120 ký tự',
		a297: 'thuộc tính hàng hóa',
		a298: 'vui lòng nhập',
		a299: '2  Qui cách lưu kho',
		a300: 'Cách tính giá bán lẻ:(Giá cung cấp',
		a301: 'Tỷ suất lợi nhuận gộp',
		a302: 'Chiết khấu',
		a303: 'Công thức tính giá bán lẻ tự động',
		a304: 'Trợ lý hàng loạt',
		a305: 'Xóa hàng loạt các ký tự giống nhau của sku',
		a306: 'giá hàng lưu kho',
		a307: 'Thiết lập hàng loạt',
		a308: 'Độ dài ký tự nằm trong khoảng 5~20',
		a309: 'Giá bán lẻ (Nội tệ)',
		a310: 'Lưu kho',
		a311: 'mã khách hàng ghim',
		a312: 'Xóa',
		a313: 'Qui cách đóng gói',
		a314: 'Trọng lượng (kg):',
		a315: 'Thể tích (cm):',
		a316: 'Loại hậu cần:',
		a317: 'Kho gửi hàng：',
		a318: 'Miêu tả sản phẩm',
		a319: 'Vui lòng nhập nội dung',
		a320: 'Ra mắt sản phẩm ngay',
		a321: 'Đăng sản phẩm trên shopee',
		a322: 'Đăng sản phẩm của TikTok Shop',
		a323: 'Đề nghị bổ sung hình ảnh thuộc tính sản phẩm trước khi đăng',
		a324: 'Đại lý sản phẩm này bất thường, đề nghị làm lại đại lý, sau đó đưa lên giá',
		a325: 'Vui lòng truy cập nền TIKTOK để thiết lập kho giao hàng. Nếu bạn không biết địa chỉ kho giao hàng, vui lòng liên hệ bộ phận chăm sóc khách hàng của Xiaosheng',
		a326: 'Sản phẩm đã lên kệ thành công trên TikTok Shop',
		a327: 'Vui lòng điền giá bán lẻ!',
		a328: 'Sản phẩm có vấn đề bất thường, vui lòng đại lý lại hoặc liên hệ với dịch vụ khách hàng của nền tảng để xử lý! ',
		a329: 'Sku sản phẩm không được để trống',
		a330: 'Không được để trống trọng lượng và thể tích! ',
		a331: 'Hình ảnh chính của sản phẩm không được quá 8 hình',
		a332: 'Vui lòng tải tệp .xlsx dưới 2M lên',
		a333: 'Kích thước của ảnh đại diện đã tải lên không được vượt quá 10MB!',
		a334: 'Thuộc tính bán hàng',
		a335: 'Qui cách',
		a336: 'Đăng sản phẩm Lazada',
		a337: 'Vui lòng điền giá bán lẻ',
		a338: 'Số lượng ảnh chính tối đa không được vượt quá 8! ',
		a339: 'Trang chủ',
		a340: 'Tôi đã được đại diện',
		a341: 'Trung tâm cá nhân',
		a342: 'in',
		a343: 'Xuất PDF',
		a344: 'Tổng số hộp:',
		a345: 'Hộp',
		a346: 'Quy cách giấy:',
		a347: 'Chiều rộng giấy:',
		a348: 'Chiều cao giấy:',
		a349: 'ừm',
		a350: 'giấy nhiệt',
		a351: 'tùy chỉnh',
		a352: 'Mã vạch sản phẩm',
		a353: 'Tệp của tôi',
		a354: 'Tạm không có',
		a355: 'kho sku mẹ：',
		a356: 'Kho con sku：',
		a357: 'Chức vụ:',
		a358: 'Toàn bộ',
		a359: 'chọn cửa hàng',
		a360: 'Trạng thái sản phẩm',
		a361: 'Mở rộng các cửa hàng còn lại',
		a362: 'Hiện đang cùng với…：',
		a363: 'Đang trong cuộc hội thoại',
		a364: 'danh sách hội thoại',
		a365: 'Đã đọc',
		a366: 'Tin nhắn này là tin nhắn thoại, vui lòng đăng nhập APP để xem',
		a367: ' Chưa đọc',
		a368: 'Nhấp để tải lên',
		a369: 'Gửi',
		a370: 'Nội dung gửi không được để trống!',
		a371: 'kết nối websock thành công',
		a372: 'kết nối websock không thành công',
		a373: 'Vui lòng chọn thông số sản phẩm',
		a374: 'Trung tâm phân phối Dian Xiaosheng',
		a375: 'giỏ hàng',
		a376: 'Tất cả sản phẩm (0)',
		a377: 'Sản phẩm đã chọn',
		a378: 'chọn tất cả',
		a379: 'Thông tin sản phẩm',
		a380: 'đơn giá',
		a381: 'Số lượng',
		a382: 'Ủy quyền thành công! ',
		a383: 'dấu nhắc lỗi',
		a384: 'Xin lỗi, trang Xiaosheng bạn truy cập không tồn tại! ',
		a385: 'Nhấp vào đây để quay lại trang chủ của Xiaosheng! ',
		a386: 'Lựa chọn cửa hàng:',
		a387: 'Đang tải đơn đặt hàng',
		a388: 'Bật chế độ đa lựa chọn',
		a389: 'Tải lại trang hiện tại',
		a390: 'Dấu thiết lập hàng loạt',
		a391: 'Không',
		a392: 'Đang lấy dữ liệu...',
		a393: 'Đang tải dữ liệu...',
		a394: 'Trung tâm đăng ký',
		a395: 'Số điện thoại di động:',
		a396: 'Mật khẩu người dùng:',
		a397: 'Xác nhận mật khẩu:',
		a398: 'mã xác nhận:',
		a399: 'số điện thoại di động',
		a400: 'mật khẩu người dùng',
		a401: 'mã xác nhận',
		a402: 'Lấy mã xác minh',
		a403: 'Đăng ký ngay',
		a404: 'Đã có tài khoản, vui lòng vào PC để đăng nhập! ',
		a405: 'Mua gói quà ngay',
		a406: 'Cửa hàng Xiaosheng',
		a407: 'Cung cấp các nhà kho và giải pháp phân phối nước ngoài địa phương xuyên biên giới',
		a408: 'Tập trung vào các bộ phận nhỏ của mỹ/đông nam á địa phương dịch vụ',
		a409: '①Cung cấp một nguồn cung cấp độc quyền mới lạ trong khu vực hoa kỳ, một sản xuất linh hoạt tùy biến, một lô.',
		a410: '②Cung cấp dịch vụ kho hàng mỹ ở nước ngoài, chuyên về các bộ phận nhỏ (quần áo, nhà ở, vỏ điện thoại, vv).',
		a411: '③Hỗ trợ nhà kho/nhà kho nước ngoài của người bán, cung cấp các dịch vụ hệ thống ERP/WMS thuần túy.',
		a412: 'Đồng bộ hóa hàng tồn kho chính xác',
		a413: 'Tỷ lệ chính xác của hàng tồn kho là 99,99%, ràng buộc hàng tồn kho trực tuyến ở nhiều cửa hàng và ngăn không cho điểm bán vượt mức bị khấu trừ',
		a414: 'Trợ lý Yêu cầu bồi thường',
		a415: 'Người bán nhanh chóng phát hiện ra các đơn đặt hàng bị COD từ chối hoặc bị thất lạc trong quá trình chuyển phát nhanh, để người bán có thể yêu cầu bồi thường kịp thời từ nền tảng, thu hồi khoản lỗ và tăng lợi nhuận ròng của bạn! ',
		a416: 'Nền tảng phân phối',
		a417: 'Điểm địa phương ở Đông Nam Á, một phần phân phối trên kệ, hàng tồn kho chính xác, ràng buộc liên kết, để ngăn bán quá nhiều',
		a418: 'Trò chuyện với Shopee',
		a419: 'Dịch tự động tiếng Thái, tiếng Việt, tiếng Indonesia, tiếng Mã Lai, tiếng Anh, trả lời tự động, chuyển đổi nhiều cửa hàng, trả lời nhanh',
		a420: 'Chào mừng bạn đăng nhập vào Xiaosheng',
		a421: 'tài khoản đăng nhập',
		a422: 'Đăng ký tài khoản',
		a423: 'Nhập tài khoản người dùng',
		a424: 'Nhập mật khẩu người dùng',
		a425: 'Đăng nhập tài khoản:',
		a426: 'Mật khẩu đăng nhập:',
		a427: 'Khu vực số:',
		a428: 'Đăng ký tài khoản:',
		a429: 'Nhập số điện thoại di động hoặc email',
		a430: 'Biệt danh người dùng',
		a431: 'Xác nhận mật khẩu',
		a432: 'Vui lòng nhập mã xác minh',
		a433: 'Các mục bắt buộc, nếu không vui lòng liên hệ với dịch vụ khách hàng',
		a434: 'Mã mời',
		a435: 'Đăng ký ngay',
		a436: 'Nhấp để gửi mã xác minh',
		a437: 'Vui lòng nhập số tài khoản hoặc mật khẩu! ',
		a438: 'Vui lòng nhập số điện thoại di động',
		a439: 'Số dư tài khoản không đủ',
		a440: 'Mã xác nhận đã gửi thành công, bạn chú ý kiểm tra nhé! ',
		a441: 'Vui lòng nhập địa chỉ email của bạn để nhận mã xác minh! ',
		a442: 'Vui lòng điền vào tài khoản người dùng! ',
		a443: 'Vui lòng điền mật khẩu của người dùng! ',
		a444: 'Vui lòng điền mã xác nhận! ',
		a445: 'Mật khẩu nhập hai lần không khớp, vui lòng xác nhận lại mật khẩu! ',
		a446: 'Đăng ký thành công',
		a447: 'Vui lòng điền tên người dùng! ',
		a448: 'Vui lòng điền đúng mật khẩu tài khoản! ',
		a449: 'Đăng nhập thành công, chuyển đến trang chủ',
		a450: '③ERP hỗ trợ tự động đồng bộ hóa kho của cùng một mặt hàng trên các nền tảng khác nhau của Shopee/Lazade để tránh bán quá nhiều! ',
		a451: 'trung tâm đăng nhập',
		a452: 'Vui lòng nhập số điện thoại di động của bạn để nhận mã xác minh! ',
		a453: 'Đăng nhập mã xác minh điện thoại di động',
		a454: 'Không được để trống số điện thoại! ',
		a455: 'Mã xác minh được gửi bất thường, vui lòng thử lại sau! ',
		a456: 'Vui lòng nhập số tài khoản hoặc mật khẩu! ',
		a457: 'Đăng ký thành công, chuyển đến trang chủ! ',
		a458: 'Yêu cầu số điện thoại di động! ',
		a459: 'Loại đăng ký',
		a460: 'Đăng ký điện thoại di động',
		a461: 'Email đăng ký',
		a462: 'khu vực số',
		a463: 'Số hộp thư',
		a464: 'Mật khẩu đăng nhập',
		a465: 'Nickname Bên bán',
		a466: 'Hãy điền địa chỉ email của bạn',
		a467: 'Đề nghị nhập mật khẩu(Hơn 6 chữ số, kết hợp chữ cái)',
		a468: 'Vui lòng nhập mã xác minh của điện thoại di động của bạn',
		a469: 'Vui lòng nhập mã xác minh email',
		a470: 'Vui lòng nhập tên người bán',
		a471: 'Mã mời(không bắt buộc)',
		a472: 'Hai mật khẩu đã nhập không thống nhất, vui lòng xác nhận lại mật khẩu',
		a473: 'Vui lòng nhập tên người bán',
		a474: 'Đăng ký thành công, thông tin người dùng đang được liên kết và phân tích',
		a475: 'Hội thành công! ',
		a476: 'Liên kết không thành công, vui lòng liên hệ với dịch vụ khách hàng của Xiaosheng! ',
		a477: 'Chuyên gia bản địa hóa Đông Nam Á',
		a478: 'Email điện thoại',
		a479: 'Vui lòng điền đúng số điện thoại di động! ',
		a480: 'Đăng nhập thành công, đến trang chủ! ',
		a481: 'Quốc gia',
		a482: 'Danh mục cấp một',
		a483: 'danh mục phụ',
		a484: 'Danh mục cấp ba',
		a485: 'Tổng số trang',
		a486: 'Không thể in ra sau khi tải? ',
		a487: 'Trang in hiện tại',
		a488: 'trang',
		a489: 'Số trang mỗi lần in',
		a490: 'Đóng in hàng loạt',
		a491: 'Bật chức năng in hàng loạt',
		a492: 'Tiến trình tải trang mặt',
		a493: 'Giấy A4',
		a494: 'Giấy A5',
		a495: 'Giấy nhiệt (tùy chỉnh)',
		a496: 'Tải trang mặt không bình thường',
		a497: 'Hoàng Tặng',
		a498: 'Tin nhắn của người mua',
		a499: 'Tin nhắn từ người bán',
		a500: 'Đang lấy dữ liệu order mặt, vui lòng chờ trong giây lát. . . ',
		a501: `<div class="Section0" style="layout-grid:15.6000pt;"><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:center;line-height:12.0000pt;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:21.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="黑体">ShopsBu Privacy Policy</font></span></b><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:11.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><o:p></o:p></span></b></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Release date: October 15, 2025 &nbsp;&nbsp;；Effective Date: October 15, 2025</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Thank you for visiting the e-commerce business management platform of Guangzhou Xiangrong Information Technology Co., Ltd. (hereinafter referred to as "us" or "ShopsBU"). This policy applies to Guangzhou Xiangrong Information Technology Co., Ltd., which provides products and services for ShopsBU. We attach great importance to the privacy and personal information security protection of our users (hereinafter referred to as "you"). We will strictly comply with legal and regulatory requirements, take corresponding security measures, and do our best to protect your personal information and privacy security. In view of this, we have formulated this "ShopsBU Privacy Policy" (hereinafter referred to as "this policy") and draw your attention to:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This policy applies to all functions and services provided by our store's e-commerce business management platform. Please carefully read and thoroughly understand this policy before using the various functions or services we provide. Only after confirming full understanding and agreement can you start using them.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To protect your relevant rights, this policy will explain to you how Dianxiaosheng's products and services will collect, use, and store your personal information, and what rights you have. Please read, understand, and agree to this policy before using Dianxiaosheng's products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Before using our products and services, please carefully read and thoroughly understand this privacy policy. Only after confirming that you fully understand and agree can you start using it. We will check and update our policies from time to time. Please visit this page regularly to ensure that you are aware of the latest version of our privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">By using or continuing to use products and services related to Dianxiaosheng, you agree to our collection, use, storage, and sharing of your information in accordance with this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This privacy policy will help you understand the following:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In order to provide services to you and enterprise users, optimize our services, and ensure account security, Dianxiaosheng will collect information that you voluntarily provide, authorize, or generate due to the use of the service when registering or using it in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you register an account on the platform or log in to an existing account: We will collect your email address, phone number, login password, name, and country;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use the waybill query function on the platform, we will collect your waybill number and logistics tracking information;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use this platform for product order distribution and shipping, we will collect your store name, product information, and shipping address. After obtaining your permission, we will collect the names, phone numbers, addresses, and order information of buyers on your platform from third-party e-commerce platforms such as TEMU and Tiktok Shop (including package information, order items, prices, ordering time, shipping time, etc.);</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service is not mentioned in the above description and has collected your information, we will separately explain the content, scope, and purpose of the information collection to you through page prompts, interaction processes, website announcements, etc., in order to obtain your consent.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The data we collect during the provision of services to you may be used in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Provide services to you. We will collect and store certain types of information about your use of this website. Our purpose of collecting this information is to improve the operation of the website, enable us to provide services, and accurately evaluate the website's performance;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Use your personal information to communicate with you. You may receive notifications from us via email or mobile push notifications you submit, such as when the status of your package changes or when we launch new services, promotions, etc. You can unsubscribe at any time;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist us in designing new services and improving our existing services;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Allow you to participate in surveys related to our products and services, conduct market activities related to our services, and push you the latest market activity information and discount plans;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist national judicial, administrative, security and other authorities in conducting investigations, and comply with applicable laws, regulations and other obligations promised to the authorities.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not sell, rent, trade or otherwise disclose your personal information to anyone under any circumstances, except in the following special circumstances:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Service providers and suppliers: In order to manage, supply, and improve the services of our store staff, as well as for marketing purposes, we may disclose personal information, including transaction information, to service providers and suppliers. Such as logistics companies, suppliers, and payment service providers, data storage and management suppliers, marketing and promotion suppliers, and suppliers that send email and SMS notifications. Used to help us improve our services and products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Protecting legitimate rights and other legal purposes: We may be required to disclose information, such as being summoned, appearing in court, or being asked by law enforcement officers to conduct investigations, or any other legal requirement for us to disclose such information. We will also disclose personal information when necessary to protect our legal rights or to enforce our terms of use and other agreements. ShopsBUs may provide your personal information based on search warrants, subpoenas, or other lawful and effective inquiries or orders, or other requirements of applicable laws.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Merger and/or sale of assets: We usually do not sell, trade, or rent your personal information to any third-party company in the normal course of business. However, we may acquire, merge, or be acquired by another company, or we may dispose of some or all of our assets, in which case your personal information may be disclosed to another company, subject to compliance with privacy policies.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Your personal information will be transferred and stored in Amazon Cloud, while other personal information will be transferred and stored on Tencent Cloud servers in the United States. Unless required or permitted by law for a longer retention period, we will retain the information collected from or about you for the shortest period of time necessary to achieve the purposes described in this privacy policy. When the information is no longer needed for these purposes, we will delete it or save it in a form that does not identify you. When determining this retention period, we will consider various criteria, including the type of service you request or provide, the nature of our relationship with you, the impact on the services we provide to you if we delete certain information about you, and the retention period required by law. Please note that once you successfully apply to cancel your ShopsBU account, we will complete the review of your account cancellation as soon as possible. After the application is approved, we will completely delete your personal data. If we cease to operate our products or services, we will notify you in the form of individual deliveries or announcements, and delete your personal data after ceasing to operate our products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have implemented industry standard security measures to protect the personal data you provide from unauthorized access, public disclosure, use, modification, damage, or data loss. We will take the following reasonable and feasible measures to protect your personal data:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use encryption technology to ensure the confidentiality of data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use trusted protection mechanisms to prevent malicious attacks on data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have deployed access control mechanisms to ensure that only authorized personnel can access personal data, and we have organized security and privacy training courses to raise employees' awareness of the importance of protecting personal data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will use secure encryption technology to protect your personal data during transmission. Take all appropriate organizational, managerial, and technical measures to protect the security of the personal data you provide within our internal organization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our physical, technical, or management safeguards are violated, resulting in unauthorized access, public disclosure, alteration, or destruction of data that damages your legal rights, we will be held responsible. After the unfortunate occurrence of a personal data security incident, we will promptly inform you of the requirements of laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, as well as suggestions for you to independently prevent and reduce risks, remedial measures taken for you, etc. We will promptly notify you of the situation related to the event through email, letter, phone, push notifications, and other means.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Although our business aims to protect your personal information, please understand that there is currently no 100% security anywhere, whether online or offline. The ShopsBU account requires a username and password to log in. Please protect your username and password and never disclose them to third parties.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the relevant laws, regulations, and standards in your local area, as well as the prevailing practices in other countries and regions, we guarantee that you exercise the following rights over your personal data. You have the right to demand that we:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1. Accessing your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to access your personal information, except for exceptions provided by laws and regulations. If you want to exercise your data access rights, you can access them yourself through the following methods:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Account information: If you wish to access or edit personal profile information in your account.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can log in to your store's Xiaosheng platform account through: personal homepage → click on the avatar in the upper right corner → click on "personal information" → browse your nickname, phone number, country, and email;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. Correct your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you discover errors in the personal information we process about you, you have the right to request us to make corrections. You can submit a correction request through the methods listed in "1. Accessing Your Personal Information".</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are unable to correct these personal information through the above link, you can contact us using the contact information listed in Chapter 11 of this Privacy Policy. We will reply to your correction request within 5-7 working days.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Delete your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In the following situations, you can request the deletion of personal information by sending us an email:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates laws and regulations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we collect and use your personal information without your consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates our agreement with you;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you no longer use our products or services, or if you cancel your account;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we no longer provide you with products or services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we decide to respond to your deletion request, we will also notify the entities that have obtained your personal information from us to delete it in a timely manner, unless otherwise provided by laws and regulations, or if these entities have obtained your independent authorization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4. Cancel your account</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can cancel the previously registered account at any time. You can send us an account cancellation application email using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. After canceling your account, we will cease providing you with products or services and immediately delete your personal information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5. Obtain a copy of your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to obtain a copy of your personal information. If you need to obtain a copy of the personal information we have collected from you, you can contact us using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. We will submit a copy of your personal information to you via email. Subject to compliance with relevant legal regulations and technical feasibility, we will provide you with a copy of your personal information upon your request.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6. Consumer Rights of California Residents</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the California Consumer Privacy Act, California residents have the right to know, access, and delete their personal data. California residents also have the right to choose not to allow businesses to sell their personal data, as well as the right not to be discriminated against for exercising California's privacy rights. We will not sell your personal data to anyone for any purpose, nor will we discriminate in responding to privacy requests.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a resident of California, please be sure to review this privacy policy for important information regarding your rights under California privacy laws and how to submit requests to us based on these rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7. Responding to your above request</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will respond to the above request within 5-7 working days. Please refer to Chapter 11 of this Privacy Policy for contact information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not be able to respond to your request in the following situations:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests related to the fulfillment of legal and regulatory obligations by personal information controllers;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to national security and defense security;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to public safety, public health, and major public interests;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to criminal investigation, prosecution, trial, and execution of judgments;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The personal information controller has sufficient evidence to indicate that the personal information subject has subjective malice or requests for abuse of rights;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests made to safeguard the significant legitimate rights and interests of personal information subjects or other individuals, such as life and property, but with difficulty in obtaining their consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Responding to a request from a personal information subject would result in serious harm to the legitimate rights and interests of the personal information subject or other individuals or organizations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests involving trade secrets.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We expect parents or guardians to guide minors in using our services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a minor under the age of 14, you should read and agree to this policy under the supervision and guidance of your parents or other guardians before using our products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. We attach great importance to protecting the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We protect the personal information of minors in accordance with relevant laws and regulations. In the case of collecting personal information of minors with the consent of parents, we will only use, share or publicly disclose this information when permitted by law, with the explicit consent of parents or guardians, or when necessary to protect minors.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Self inspection and receiving feedback</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we find that we have collected personal information of minors without obtaining verifiable parental consent in advance, we will try to delete the relevant data as soon as possible. At the same time, we have established strict rules for the collection and use of underage information to protect the personal information security of children and adolescents. If you are the guardian of a minor and have any questions about the personal information of the minor under your guardianship, please contact us through the contact information disclosed in this policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We are committed to adhering to the highest privacy protection standards in the processing and transfer of personal information worldwide. When you use our services, your personal information may be transferred to servers located on Tencent Cloud. This type of international transfer will follow strict data protection and privacy security measures to ensure the same level of privacy protection as we provide locally to you.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">For personal information transferred to Tencent Cloud servers located in Guangzhou, China, we comply with relevant privacy and data protection laws in China and the United States, including but not limited to ensuring that there are corresponding security measures in place, such as encryption and access control, to safeguard data security and privacy. In addition, we will monitor relevant legal changes to ensure that our practices can adapt to these changes in a timely manner and safeguard users' privacy rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will transfer personal information of EU users in accordance with the requirements of the EU General Data Protection Regulation (GDPR). This means that when personal information leaves the European Union and economic regions, we will transfer it by adopting standard contractual terms recognized by the European Commission or when there is sufficient data protection in the receiving country. We promise to regularly evaluate the data protection level of the receiving country and ensure the effective implementation of protection measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions or need assistance regarding the cross-border transfer of your personal information, please contact us.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use cookies and other similar technologies to enhance your experience using this service. When you use this service, we may use relevant technologies to send one or more cookies or anonymous identifiers to your device to collect and store information about your access and use of this service. We promise not to use cookies for any purposes other than those described in this privacy policy. We use cookies and similar technologies mainly to achieve the following functions or services:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Accelerate navigation</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Track website usage</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Identify user identity, access permissions, and preferences</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Conduct research and diagnosis to improve our content, products, and services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can refuse or manage cookies or data analytics tools through your browser settings. However, please note that if cookies or data analytics tools are disabled, you may not be able to enjoy the best service experience, and some services may not function properly.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To ensure that you are always aware of how we collect, use, and disclose your information, we will post any changes or updates to this privacy policy on this website and encourage you to review this privacy policy from time to time. If we change this privacy policy, we will notify you by modifying the date at the top of this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please protect your personal information properly and only provide it to others when necessary. If you discover that your personal information has been leaked, especially the username and password of this application, please contact the customer service of this application immediately so that this application can take corresponding measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions about this policy or other related matters, please contact us through https://erp.shopsbu.com// Contact us. You can also send your questions to https://erp.shopsbu.com/ Or send it to the following address:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Address: 1st Floor, Federal Building, No. 30 Caotang Road, Panyu District, Guangzhou City (Address)</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Postal code: 510520.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">发布日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">生效日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">感谢您访问</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台（以下称</font><font face="system">“我们”或“</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">”）。本政策适用于提供</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品和服务的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">。</font> <font face="system">我们非常重视用户（下称</font><font face="system">“您”）的隐私和个人信息安全保护，我们将严格按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息及隐私安全。鉴于此，我们制定本《</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策》（下称</font><font face="system">“本政策”）并提请您注意：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本政策适用于我们提供的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台所提供的所有的功能和服务。请您在使用我们提供的各项功能或服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为保障您的相关权利，本政策将向您说明</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务会如何收集、使用和存储您的个人信息及您享有何种权利，请您在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务之前，阅读、了解并同意本政策。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后再开始使用。我们会不时地检查并更新我们的政策，请您定期光顾本页面，以确保对最新版本隐私政策的了解。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您使用或继续使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务，都表示您同意我们按照本隐私政策收集、使用、储存和分享您的信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本隐私政策将帮助您了解以下内容：</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">一、</font> <font face="system">我们如何收集您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">二、</font> <font face="system">我们如何使用您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">三、</font> <font face="system">我们如何共享、披露您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">四、</font> <font face="system">我们如何存储您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">五、</font> <font face="system">我们如何保护您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">六、</font> <font face="system">您的权利</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">七、</font> <font face="system">我们如何处理未成年人的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">八、</font> <font face="system">您的个人信息如何在全球范围转移</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十、</font> <font face="system">本政策的变更</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">一、我们如何收集您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了向您和企业用户提供服务、优化我们的服务以及保障帐号安全，</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">会按照如下方式收集您在注册、使用服务时主动提供、授权或因为使用服务而产生的信息：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台注册账号或登录现有帐户：我们将收集您的电子邮箱地址、手机号码、登陆密码、姓名、国家；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台使用运单查询功能时，我们将收集您的运单号与物流跟踪信息；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您使用本平台进行产品订单配货发货时我们将收集您的店铺名称、商品信息、发货地址。我们通过您的准许后会从</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">TEMU</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">，</font>Tiktok Shop等第三方电商凭他平台收集您所在平台买家的姓名、电话、地址与订单信息（包括：包裹信息、订单商品、价格、商品下单时间、发货时间等）；</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:18.0000pt;
		mso-para-margin-left:0.0000gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
		mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p>&nbsp;</o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们通过页面提示，交互流程，网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得您的同意。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">二、我们如何使用您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在向您提供服务过程中收集的数据可能会以以下方式使用：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">向您提供服务。我们会收取并存储有关您使用本网站的某些类型的信息。我们收集这些信息的目的是为了让网站更好的运作、使我们能够提供服务、正确的评估网站的运行情况；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">使用您的个人信息与您沟通。您可能会收到我们通过您提交的电子邮件或者手机推送的通知，例如：当您的包裹状态发生改变或者我们有新服务上线、促销等。您可以随时取消订阅；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帮助我们设计新服务，改善我们现有服务；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">让您参与有关我们产品和服务的调查，开展与服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">协助国家司法、行政、安全机关等权利机构开展调查，并遵守适用法律法规及其他向有权机构承诺之义务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">三、我们如何共享、披露您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们不会以任何情形出售、出租、交易或以其他方式向任何人披露您的个人信息，以下特殊情况下除外：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">服务提供商和供应商：为了管理、供应和改进</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">的服务以及出于市场营销目的，我们可能会向服务提供商和供应商披露包括交易信息在内的个人信息。如物流公司、供应商和支付服务提供商，数据存储和管理供应商、营销和促销供应商、发送电子邮件和</font>SMS通知的供应商。用于帮助我们改进服务、产品。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">保护合法权利和其他法定目的：我们可能被要求披露信息，如被传唤、法院出庭或被执法机关人员要求进行调查，或者其它任何一切由法律要求我们披露这些信息。</font> <font face="system">我们还会在必要时披露个人信息，以保护我们的合法权利或执行我们的使用条款和其他协议。</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">可能会根据搜查令，传票或其他合法有效的查询或命令或适用法律的其他要求提供您的个人信息。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">合并和</font>/或出售资产：我们通常不会在正常经营过程中向任何第三方公司出售、交易、出租您的个人信息。但是，我们可能会收购、合并或被另一家公司收购，或者我们可能会处置部分或全部资产，在这种情况下，您的个人信息可能会被披露给另一家公司，但须遵守隐私政策 有效。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">四、我们如何存储您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您的个人信息将被传输并存储</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">亚马逊云</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">中，其他个人信息将被传输并存储美国腾讯云服务器中。除非法律要求或允许更长的保留期，否则我们将在实现本隐私政策所述目的所需的最短时间内保留从您处收集的或关于您的信息。当信息不再需要用于这些目的时，我们会将其删除或以不识别您身份的形式保存。在确定此保留期时，我们会考虑各种标准，包括您请求或提供的服务类型、我们与您关系的性质、如果我们删除您的某些信息，对我们向您提供的服务的影响，以及法律要求的保留期。请注意，当您申请注销您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户成功后，我们将尽快完成对您账户注销的审查。申请获得批准后，我们将完全删除的您的个人数据。如果我们停止经营产品或服务，我们将以逐一交付或公告的形式通知您，并在停止经营产品和服务后删除您的个人数据。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">五、我们如何保护您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们采取的安全措施我们使用了行业标准的安全措施来保护您提供的个人数据免受未经授权的访问、公开披露、使用、修改、损坏或数据丢失。我们将采取以下合理可行的措施来保护您的个人数据：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用加密技术来确保数据的机密性；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用可信的保护机制来防止对数据的恶意攻击；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们部署了访问控制机制，以确保只有授权人员才能访问个人数据，我们举办了安全和隐私培训课程，以提高员工对保护个人数据重要性的认识；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们将使用安全加密技术在传输过程中保护您的个人数据。采取一切适当的组织、管理和技术措施，保护您在我们内部组织中提供的个人数据的安全。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们的物理、技术或管理保障措施被违反，导致未经授权访问、公开披露、更改或破坏数据，从而损害您的合法权利，我们将承担责任。在个人数据安全事件不幸发生后，我们将及时告知您法律法规的要求：安全事件的基本情况和可能产生的影响，我们已经或将要采取的处置措施，以及您可以独立预防和降低风险的建议，为您采取的补救措施等。我们将通过电子邮件、信函、电话、推送通知等方式及时通知您与事件相关的情况。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">虽然我们的业务旨在保护您的个人信息，但请理解，目前在任何地方都不存在</font>100％的安全性，无论线上或线下。 </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帐户需要用户名和密码才能登录。请保护好您的用户名和密码，绝不向第三方透露。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">六、您的权利</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据您当地的相关法律、法规和标准以及其他国家和地区的通行做法，我们保证您对您的个人数据行使以下权利。您有权要求我们</font>:</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1.访问您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户信息</font>:如果您希望访问或编辑您的账户中的个人资料信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以登陆您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">平台账号通过：个人主页</font><font face="system">→点击右上角头像→点击「个人资料」→浏览您的昵称、手机号码、国家、邮箱；</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.更正您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过</font><font face="system">“1.访问您的个人信息”中罗列的方式提出更正申请。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您无法通过上述链接更正这些个人信息，您可按照本《隐私政策》第十一章中列明的联系方式与我们联系。我们将在</font>5-7个工作日内回复您的更正请求。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3.删除您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，您可以通过发送邮件向我们提出删除个人信息的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反法律法规；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们收集、使用您的个人信息，却未征得您的同意；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反了与您的约定；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您不再使用我们的产品或服务，或您注销了账号；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们不再为您提供产品或服务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">4.注销您的账户</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您随时可注销此前注册的账户。您可按照本隐私政策第十一章中列明的联系方式向我们发送账号注销申请邮件，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。在注销账户之后，我们将停止为您提供产品或服务，并立即删除您的个人信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">5. 获取您的个人信息副本</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权利获得您的个人信息副本。如您需要获取我们收集的您的个人信息副本您可按照本隐私政策第十一章中列明的联系方式与我们联系，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。我们会将个人信息副本通过邮件的形式提交给您。在符合相关法律规定且技术可行的前提下，我们将会根据您的要求向您提供您的个人信息副本。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">6. 加州居民消费者权益</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据《加州消费者隐私法》，加州居民有权了解、访问和删除他们的个人数据。加州居民也有权选择不让企业出售他们的个人数据，也有权不因行使加州隐私权而受到歧视。我们不会出于任何目的将您的个人数据出售给任何人，也不会在回应隐私权请求时进行歧视。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您是加州居民，请务必查看本隐私政策，了解有关您在加州隐私法下的权利以及如何根据这些权利向我们提交请求的重要信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">7. 响应您的上述请求</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于以上请求，我们将在</font>5-7个工作日内做出答复，联系方式请见本隐私政策第十一章节。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，我们将无法响应您的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与个人信息控制者履行法律法规规定的义务相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与国家安全、国防安全直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与公共安全、公共卫生、重大公共利益直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与犯罪侦查、起诉、审判和执行判决等直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">涉及商业秘密的请求。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">七、我们如何处理未成年人的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1. 我们期望父母或监护人指导未成年人使用我们的服务</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若您是未满</font>14周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.我们重视保护未成年人个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们根据相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3. 自查与接收反馈</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">八、您的个人信息如何在全球范围转移</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在全球范围内对个人信息的处理与转移承诺遵守最高的隐私保护标准。当您使用我们的服务时，您的个人信息可能会被转移到位于腾讯云服务器上。此类国际转移将遵循严格的数据保护和隐私安全措施，确保与我们在您本地提供的隐私保护同等水平。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于转移到位于中国广州的腾讯云服务器上的个人信息，我们遵循中国与美国的相关隐私和数据保护法律，包括但不限于，确保有相应的安全措施存在，如加密和访问控制，以保障数据的安全与隐私。此外，我们还将监控相关的法律变动，确保我们的做法能够及时适应这些变化，维护用户的隐私权益。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">针对欧盟用户的个人信息，我们将依照欧盟通用数据保护条例（</font>GDPR）的要求进行数据转移。这意味着当个人信息离开欧盟及经济区域时，我们将通过采用欧盟委员会认可的标准合同条款或在接收国有足够的数据保护水平时进行转移。我们承诺会定期评估接收国的数据保护水平，并确保保护措施的有效执行。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您对于您的个人信息跨境转移有疑问或需要帮助，请与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用</font>Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">加速导航</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">追踪网站使用情况</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">辨别用户身份、访问权限及偏好</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">进行研究和诊断以改善我们的内容、产品和服务</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以通过的浏览器设置拒绝或管理</font>cookies或数据统计工具。但请注意，如果停用cookies或数据统计工具，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十、本政策的变更</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了确保您随时了解我们如何收集、使用和披露您的哪些信息，我们将在本网站上发布本隐私政策的任何更改或更新，并鼓励您不时查看本隐私政策。</font> <font face="system">如果我们更改本隐私政策，我们会通过修改本隐私政策顶部的日期来通知您。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">如您对本政策或其他相关事宜有疑问，请通过</font><font face="微软雅黑">&nbsp;</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com//</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;与我们联系。您也可将您的问题发送至</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com/</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">或寄到如下地址：</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">地址：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">广州市</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">番禺区草堂路</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">30号</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">联邦大厦一楼</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;（收）</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">邮编：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">510520</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></div>`,
		a502: 'Xác định thanh toán bằng mã thanh toán',
		a503: 'Số tiền nạp',
		a504: 'thanh toán thực tế',
		a505: 'Hoàn tiền',
		a506: 'Thời gian tiêu thụ',
		a507: 'Tiếp tục đăng nhập',
		a508: 'Thanh toán bằng mã quét WeChat',
		a509: 'Sau khi người dùng nạp tiền thành công, vui lòng liên hệ với dịch vụ khách hàng của nền tảng để cung cấp thông tin về việc mở cửa hàng địa phương và các vấn đề liên quan!',
		a510: 'Dịch vụ khách hàng WeChat',
		a511: 'Nhận lệnh',
		a512: 'In ngay',
		a513: 'Tải lên biểu mẫu hậu cần trực tiếp',
		a514: 'Chỉ có thể tải lên tệp jpg/png và không quá 8M',
		a515: 'Số thứ tự lưu trữ',
		a516: 'số hộp',
		a517: 'Địa chỉ chi tiết',
		a518: 'Người nhận hàng',
		a519: 'Điện thoại',
		a520: 'hộp thư đăng nhập',
		a521: 'Số điện thoại di động',
		a522: 'Mật khẩu phải từ 6 ký tự trở lên',
		a523: 'vui lòng nhập email của bạn!',
		a524: 'Đề nghị nhập email hợp lệ！',
		a525: 'Vui lòng điền thông tin tài khoản!',
		a526: 'Hai lần nhập mật khẩu không giống nhau！',
		a527: 'Vui lòng nhập số điện thoại!',
		a528: 'Đề nghị nhập mã xác minh email！',
		a529: 'Vui lòng nhập địa chỉ email hoặc tên người bán!',
		a530: 'chọn địa bàn',
		a531: '(bắt buộc)',
		a532: 'tài khoản kho',
		a533: 'tên kho hàng',
		a534: 'mật khẩu kho',
		a535: 'Mã xác minh email',
		a536: 'Điền số tài khoản kho hàng',
		a537: 'Điền tên kho hàng',
		a538: 'Mật khẩu kho phải có ít nhất 6 ký tự, là sự kết hợp giữa chữ cái, số và ký tự',
		a539: 'Sao chép và chia sẻ liên kết đăng ký độc quyền của bạn. Sau khi người bán được mời nạp tiền, 1% số tiền sẽ được trả lại vào tài khoản của bạn ngay lập tức. Người bán được mời cũng có thể nhận ngay điểm thưởng 10 nhân dân tệ. Tất cả điểm có thể được sử dụng để phân phối Mua hàng , tiêu thụ hậu cần và kho hàng ở nước ngoài, v.v. Hãy chia sẻ với những người bán hàng và bạn bè của bạn để tạo ra một thị trường biển qua biên giới.',
		a540: 'Mời liên kết đăng ký người dùng',
		a541: 'Sao chép liên kết',
		a542: 'Mời liên kết người dùng',
		a543: 'Tài khoản bất thường, vui lòng liên hệ bộ phận chăm sóc khách hàng! ',
		a544: 'Sao chép thành công',
		a545: 'Hệ thống quản lý xuyên biên giới',
		a546: 'liên kết được liên kết',
		a547: 'Tập trung phục vụ người bán địa phương ở Đông Nam Á',
		a548: 'Tài khoản thích hợp của cửa hàng liên kết',
		a549: 'Vui lòng nhập tài khoản Xiaosheng của bạn',
		a550: 'Liên kết ngay lập tức',
		a551: 'Quản lý ủy quyền',
		a552: 'Đối tác chính thức',
		a553: 'Xin chúc mừng, ủy quyền cửa hàng thành công, vui lòng chọn thao tác bạn sẽ thực hiện!',
		a554: 'Đi tới trang chủ',
		a555: 'Thẩm duyệt đơn đặt hàng',
		a556: 'Nhập sản phẩm',
		a557: 'sản phẩm chứng khoán',
		a558: 'Đăng ký thành công, đến trang đăng nhập! ',
		a559: 'Quản lý hình mờ',
		a560: 'Khôi phục ảnh gốc',
		a561: 'Áp dụng tất cả ảnh',
		a562: 'Chỉ sử dụng ảnh hiện tại',
		a563: 'Xác nhận trả lại',
		a564: 'Bạn có chắc chắn muốn tiếp tục xóa hình mờ không? ',
		a565: ' Đã xóa thành công!',
		a566: 'Kho sở thuộc',
		a567: 'Số lượng quà tặng',
		a568: 'Sản phẩm không liên kết',
		a569: 'phút',
		a570: 'Đơn hàng đã khiếu nại kho và đang chờ kho xử lý! ',
		a571: 'Vui lòng xác nhận thông tin sau',
		a572: 'Nhập nhận xét cho người bán (tùy chọn)',
		a573: 'Vui lòng điền thông báo của kho hàng (bắt buộc)',
		a574: 'Nhập số đơn hàng cần tìm',
		a575: 'Khiếu nại đơn đặt hàng được xử lý bởi nhà kho',
		a576: 'Đồng ý khiếu nại của người bán này sẽ trừ số điểm',
		a577: 'Vui lòng điền điểm mà nhà kho sẵn sàng thanh toán',
		a578: 'Chi tiết khiếu nại',
		a579: 'Tin nhắn trong kho',
		a580: 'Thông báo nền tảng',
		a581: 'Trung tâm khiếu nại kho hàng ở nước ngoài',
		a582: 'Tìm kiếm đơn hàng',
		a583: 'Trạng thái đơn đặt hàng',
		a584: 'Thanh toán thực tế theo đơn đặt hàng',
		a585: 'Điểm bù ước tính',
		a586: 'Tên thông số kỹ thuật',
		a587: 'Số lượng',
		a588: 'thời gian phục vụ',
		a589: 'Thời gian thanh toán',
		a590: 'Thời gian in',
		a591: 'Thời gian giao hàng',
		a592: 'Tên cửa hàng',
		a593: 'Phương thức vận chuyển',
		a594: 'số vận đơn',
		a595: 'Loại sàn giao dịch',
		a596: 'trả',
		a597: 'Đồng ý',
		a598: 'thương lượng',
		a599: 'đang chờ xử lý nền tảng',
		a600: 'Xem chi tiết',
		a601: 'Vui lòng điền lý do từ chối!',
		a602: 'Giao dịch thành công!',
		a603: 'Sản phẩm mới',
		a604: 'Đặt lại thứ tự',
		a605: 'Quay lại',
		a606: 'Lưu trữ trong kho',
		a607: 'Thay đổi',
		a608: 'Xác nhận muốn xóa?',
		a609: 'Đơn hàng đã được chỉnh sửa thành công! ',
		a610: 'Nó đã được thiết lập lại thứ tự ban đầu! ',
		a611: 'Đơn đặt hàng do người dùng tạo',
		a612: 'Tạo đơn hàng',
		a613: 'Điền thông tin người nhận hàng',
		a614: 'Thêm kho sản phẩm',
		a615: 'Tổng khối lượng ước tính',
		a616: 'Tổng trọng lượng ước tính',
		a617: 'Khi loại kho hàng',
		a618: 'Phí chuyển phát ước tính',
		a619: 'Chọn hậu cần:',
		a620: 'trọng lượng đầu tiên',
		a621: 'Chi phí trọng lượng đầu tiên',
		a622: 'phí gia hạn',
		a623: 'Phương thức thanh toán',
		a624: 'Nhận xét Đơn hàng',
		a625: 'Để lại tin nhắn cho nhà kho:',
		a626: 'Mã bưu điện',
		a627: 'Vui lòng chọn một quốc gia',
		a628: 'tỉnh',
		a629: 'Thành phố',
		a630: 'Địa chỉ',
		a631: 'âm lượng(Dài*Rộng*Cao/cm)',
		a632: 'Trọng lượng/KG',
		a633: 'Số lượng mua',
		a634: 'Vui lòng chọn hậu cần',
		a635: 'theo trọng lượng',
		a636: 'theo số lượng',
		a637: 'Lấy trọng lượng/trọng lượng thể tích lớn hơn',
		a638: 'Vui lòng nhập người nhận hàng',
		a639: 'Vui lòng nhập tỉnh',
		a640: 'Vui lòng nhập số điện thoại',
		a641: 'Vui lòng điền tên thành phố',
		a642: 'Vui lòng nhập khu vực',
		a643: 'Vui lòng nhập địa chỉ chi tiết của người nhận hàng',
		a644: 'Vui lòng chọn quốc gia',
		a645: 'Hàng tự dựng phải mặc định là hàng cùng kho! ',
		a646: 'Đã tồn tại kho sản phẩm trùng lặp! ',
		a647: 'Vui lòng thêm sản phẩm của đơn đặt hàng! ',
		a648: 'Đơn hàng tự tạo đã được tạo thành công! Gửi lại đơn hàng để được xem xét! ',
		a649: 'Bắt ​​buộc phải có nội dung bầu trời đầy sao đỏ! ',
		a650: 'Vui lòng chọn loại sản phẩm',
		a651: 'Vui lòng chọn kho giao hàng',
		a652: 'Thêm sản phẩm',
		a653: 'Chọn Kho',
		a654: 'Bạn có thể nhập tên sản phẩm và sku để tìm kiếm',
		a655: 'Kho hiện đang được kiểm toán',
		a656: 'Chỉ hàng tồn kho tại chỗ mới được tự động phê duyệt và sẽ không được tự động thông qua nếu không có sản phẩm nhập khẩu trong kho hoặc nếu sản phẩm được lưu trữ trong kho là 0',
		a657: 'Hình ảnh chính',
		a658: 'Hiện tại không có sku nào',
		a659: 'kho sku mẹ',
		a660: 'Số lượng sku con',
		a661: 'Chọn SKU',
		a662: 'Xin lưu ý: Nếu sản phẩm được ràng buộc dưới dạng kho SKU ảo, thì sản phẩm này sẽ không được sắp xếp nữa. Chức năng này phù hợp với các cài đặt như quà tặng ảo. ',
		a663: 'Liên kết sku ảo',
		a664: 'Liên kết sản phẩm tồn kho',
		a665: 'Sửa đổi thành công! ',
		a666: 'Vui lòng kiểm tra sản phẩm',
		a667: 'Vui lòng chọn SKU của sản phẩm',
		a668: 'Đơn hàng phải chứa ít nhất một mặt hàng! ! ! ',
		a669: 'Xác nhận xóa?',
		a670: 'Loại kho là kho sản phẩm, vui lòng chọn loại sản phẩm! ! ! ! ',
		a671: 'Kho kiểm tra hiện tại chưa hỗ trợ chức năng kiểm tra tự động, vui lòng chọn lại loại kho! ',
		a672: 'Vui lòng chọn kho kiểm toán',
		a673: 'Ghi chú thông tin đơn hàng:',
		a674: 'Thông tin đặt hàng nhận xét hàng loạt',
		a675: 'Nhận xét đơn hàng là do người bán thêm vào, chỉ kho hàng và người bán trên nền tảng mới nhìn thấy, nếu không điền có nghĩa là mặc định không có tin nhắn của người bán! ',
		a676: 'Lời nhắc lỗi liên kết',
		a677: 'lý do',
		a678: 'Tạo đơn hàng tự tạo theo đợt',
		a679: 'Tải xuống mẫu nhập',
		a680: 'Kéo tệp excel vào đây hoặc nhấp để tải lên',
		a681: 'Đang tải dữ liệu, vui lòng đợi. . . ',
		a682: 'Tải dữ liệu hoàn tất, vui lòng làm mới trang! ',
		a683: 'Trong số các đơn hàng bạn đã chọn, sau khi lọc theo số lượng tồn thực tế trong kho và mức độ khẩn cấp đến ngày giao hàng',
		a684: 'Kiểm toán thành công',
		a685: 'Chi tiết kiểm tra',
		a686: 'điểm giữ lại',
		a687: 'Kiểm tra thất bại',
		a688: 'Nguyên nhân thất bại',
		a689: 'Chi phí Tích điểm',
		a690: 'Thời hạn giao hàng',
		a691: 'Dấu nhắc hệ thống',
		a692: 'Đã nhận (￥) - tổng giá cung',
		a693: 'giá cung cấp * số lượng mua',
		a694: 'Lệnh giao ngay có thể được phê duyệt',
		a695: 'Đề xuất cho các đơn hàng hết hàng không được thông qua',
		a696: 'Đơn đặt hàng xem xét hàng loạt',
		a697: 'Bật đánh giá tự động',
		a698: 'Đồng bộ trạng thái đơn hàng',
		a699: 'xuất hàng loạt',
		a700: 'Thứ tự nhận xét hàng loạt',
		a701: 'Đơn hàng thủ công tự dựng',
		a702: 'Tạo một đơn đặt hàng thủ công',
		a703: 'Tạo đơn hàng thủ công theo đợt',
		a704: 'ỨNG DỤNG Người Bán',
		a705: 'Ứng dụng di động của người bán có thể thực hiện quản lý đánh giá đơn hàng/trả hàng và trò chuyện đa cửa hàng Shopee, bao gồm dịch tự động, trả lời tự động, chuyển đổi nhiều cửa hàng, v.v.',
		a706: 'Đảo ngược lựa chọn',
		a707: 'bản ghi',
		a708: 'Lợi nhuận gộp ước tính',
		a709: 'Tổng giá cung cấp',
		a710: 'Đơn đặt hàng phân phối',
		a711: 'Nhà cung cấp',
		a712: 'Lý do rút tiền',
		a713: 'Sửa đổi thứ tự',
		a714: 'thứ tự nhận xét',
		a715: 'Xóa danh sách tự tạo',
		a716: 'Vui lòng chọn đơn hàng! ',
		a717: 'Gửi thành công thông tin nhận xét! ',
		a718: 'Việc gửi là bất thường, hãy thử lại sau một thời gian! ',
		a719: 'Gửi thành công! ',
		a720: 'Hiện tại không có lệnh giao ngay nào có thể được phê duyệt! ',
		a721: 'Đóng đánh giá tự động thành công! ',
		a722: 'Bật đánh giá tự động thành công! ',
		a723: 'Sau khi kiểm tra đơn hàng, hãy xem lại! ',
		a724: 'đánh giá này',
		a725: 'Trong số lượng đặt hàng có',
		a726: 'Đơn hàng không bị ràng buộc hoặc kho kiểm tra không nhất quán và không thể kiểm tra. Bạn có muốn tiếp tục kiểm tra phần còn lại không',
		a727: 'Đặt hàng? ',
		a728: 'Tiếp tục xét các đơn hàng còn lại',
		a729: 'Được',
		a730: 'Đợi phê duyệt',
		a731: 'COD (thu tiền khi nhận hàng)',
		a732: 'được liên kết thành công dưới dạng mã hàng ảo',
		a733: 'Liên kết thành công! ',
		a734: 'Các sản phẩm tồn kho hiện đang bị ràng buộc:',
		a735: 'sku mẹ',
		a736: 'sku con',
		a737: 'Hiện tại chưa có tin tức về sản phẩm hết hàng! ',
		a738: 'Vui lòng liên kết sản phẩm trong kho trước khi thực hiện thao tác này! ',
		a739: 'Xác nhận khôi phục đơn hàng? ',
		a740: 'Bạn có chắc chắn đặt một gói trống không? ',
		a741: 'Cài đặt thành công! ',
		a742: 'Lệnh trưng bày sẽ khôi phục lại việc chiếm giữ kho hàng trực tuyến của các sản phẩm trong kho, bạn có chắc chắn hủy bỏ ẩn không? ',
		a743: 'Ẩn đơn hàng sẽ hủy bỏ việc chiếm giữ kho hàng trực tuyến của sản phẩm trong kho. Bạn có chắc chắn ẩn đơn hàng này không? (hiển thị có thể phục hồi)',
		a744: 'Đơn hàng đã được hiển thị',
		a745: 'Đơn hàng bị ẩn',
		a746: 'Vui lòng chọn lệnh xuất! ',
		a747: 'Thời gian này sẽ xuất',
		a748: 'Chi tiết đơn hàng, bạn có muốn xuất tiếp không? ',
		a749: 'xuất excel ngay lập tức',
		a750: 'Tất cả các cửa hàng',
		a751: 'Lần này sẽ đồng bộ：“',
		a752: '”Gần đây',
		a753: 'Đơn hàng    ngày, dự tính sẽ mất 30-59 giây để tiến hành đồng bộ dữ liệu đơn hàng, sau khi đồng bộ dữ liệu, đề nghị làm mới trang hiện tại, bạn có muốn tiếp tục đồng bộ không?',
		a754: 'Đồng bộ đơn hàng',
		a755: 'Lập tức đồng bộ ',
		a756: 'Đang đồng bộ dữ liệu đơn hàng, vui lòng đợi!',
		a757: 'Dữ liệu đơn hàng đã được đồng bộ, vui lòng làm mới!',
		a758: 'Chỉ tải lên các tệp loại excel!',
		a759: 'Hiện tại chỉ có thể chọn một tệp, vui lòng xóa tệp đó và tiếp tục tải lên',
		a760: 'Cửa hàng không bị ràng buộc',
		a761: 'Lệnh chờ xử lý',
		a762: 'Đơn đặt hàng không vượt qua được đánh giá trong vòng 2 giờ kể từ khi thanh toán',
		a763: 'Bật',
		a764: 'Truy vấn số thứ tự',
		a765: 'sắp xếp thứ tự',
		a766: 'Thời gian đặt hàng từ muộn đến sớm',
		a767: 'Thời gian đặt hàng từ sáng đến tối',
		a768: 'Thời gian giao hàng còn lại từ nhiều đến ít',
		a769: 'Thời gian giao hàng còn lại từ ít đến nhiều',
		a770: 'Bạn có chắc chắn muốn đóng không? ',
		a771: 'Bạn có chắc muốn mở nó không? ',
		a772: 'Đơn hàng chưa qua duyệt trong vòng 2h mở bán! ',
		a773: 'Đơn hàng chưa được duyệt trong vòng 2 giờ đóng cửa! ',
		a774: 'Tùy chọn cửa hàng',
		a775: 'loại hàng hóa',
		a776: 'Khu vực nông thôn',
		a777: 'loại đơn đặt hàng',
		a778: 'Đánh giá rút kho',
		a779: 'Trạng thái liên kết',
		a780: 'Hiển thị ẩn',
		a781: 'Thứ tự bình thường',
		a782: 'chứa sản phẩm phân phối',
		a783: 'Hóa đơn tự lập',
		a784: 'hàng phổ thông',
		a785: 'Hàng nhạy cảm',
		a786: 'Danh sách nền tảng tự tạo',
		a787: 'Đơn hàng không ràng buộc',
		a788: 'Đơn hàng từ các kho khác nhau',
		a789: 'Ẩn',
		a790: 'Hiển thị',
		a791: 'Tạo đơn hàng thủ công',
		a792: 'Vui lòng chọn cửa hàng! ',
		a793: 'Thông tin đơn hàng đã được đặt lại! xin vui lòng làm mới! ',
		a794: 'Vui lòng chọn đơn hàng cần xem lại! ',
		a795: 'Vui lòng chọn kho kiểm toán',
		a796: 'Loại kho kiểm tra là kho sản phẩm, vui lòng chọn loại hàng hóa! ',
		a797: 'Hiện tại không có lệnh giao ngay nào có thể được xem xét',
		a798: 'Đang đồng bộ dữ liệu đơn hàng, vui lòng đợi trong giây lát! ',
		a799: 'thuộc về người bán',
		a800: 'Xóa đơn hàng thành công! ',
		a801: 'Thông tin nhận gói hàng đã được gửi cho người bán, vui lòng kiên nhẫn chờ xác nhận của người bán! ',
		a802: 'Hãy kiên nhẫn chờ xác nhận của người bán! ! ',
		a803: 'Chọn người bán:',
		a804: 'Đơn hàng đã tồn tại! ',
		a805: 'Hủy gói',
		a806: 'Khởi chạy lại',
		a807: 'khác',
		a808: 'Điền thông tin trả lại đã nhận',
		a809: 'Chọn kho nhận hàng',
		a810: 'Để lại tin nhắn cho người bán',
		a811: 'Gói trả lại',
		a812: 'loại hoạt động',
		a813: 'Số lượng trên kệ',
		a814: 'Thông tin trả về',
		a815: 'Vui lòng chọn kho vận chuyển',
		a816: 'Người bán xác nhận loại hoạt động trả hàng:',
		a817: 'Tên sản phẩm',
		a818: 'Vui lòng nhập số lượng trên kệ',
		a819: 'Để lại tin nhắn cho nhà kho (tùy chọn)',
		a820: 'Để lại tin nhắn cho người bán (tùy chọn)',
		a821: 'Kho nhận hàng trả lại',
		a822: 'Kéo ảnh vào đây, hoặc',
		a823: 'Chưa có ảnh',
		a824: 'Trạng thái lúc đó',
		a825: 'số tiền trả lại',
		a826: 'Quay lại',
		a827: 'biệt hiệu của người mua',
		a828: 'Email người mua',
		a829: 'Thời hạn giao hàng của người mua',
		a830: 'Người bán sắp xử lý hàng trả lại',
		a831: 'Giá cả',
		a832: 'Mẫu trả lại',
		a833: 'Hủy đơn hàng',
		a834: 'tổng số tiền',
		a835: 'Lý do hủy',
		a836: 'Loại lô hàng',
		a837: 'Kho giao hàng',
		a838: 'Cửa hàng',
		a839: 'tất cả các đơn đặt hàng',
		a840: 'Đã hủy',
		a841: 'Trả lại đơn đặt hàng',
		a842: 'Hủy Đơn',
		a843: 'Tất cả cửa hàng',
		a844: 'Vui lòng chọn kho nhận hàng',
		a845: 'Vui lòng nhập số lượng trên kệ',
		a846: 'Người bán đang xác nhận, vui lòng kiên nhẫn chờ đợi! ',
		a847: 'Kho hàng đang được xác nhận, hãy kiên nhẫn chờ đợi! ',
		a848: 'Chưa được đánh giá',
		a849: 'Người mua',
		a850: 'hệ thống',
		a851: 'Người bán không trả lời câu hỏi của tôi kịp thời',
		a852: 'Người mua không thanh toán, hệ thống tự động hủy',
		a853: 'Người mua không muốn nữa',
		a854: 'Gói đã bị mất',
		a855: 'Người bán chưa giao hàng',
		a856: 'Dịch vụ hậu cần không thể giao đến khu vực của người mua',
		a857: 'Gói hàng bị hỏng',
		a858: 'Chức năng hàng hóa bị hỏng',
		a859: 'Người bán gửi nhầm hàng! ',
		a860: 'Người mua không nhận được hàng',
		a861: 'khoảng thời gian',
		a862: 'Tổng số lượng đơn đặt hàng phân phối',
		a863: 'thu nhập điểm',
		a864: 'Xuất biểu mẫu excel',
		a865: 'Quét ra khỏi kho (chỉ dành cho kho ở nước ngoài)',
		a866: 'Chọn ngày',
		a867: 'số thứ tự',
		a868: 'Tìm số thứ tự',
		a869: 'ngày đóng gói',
		a870: 'Số lượng đặt hàng bên ngoài',
		a871: 'Số lần hủy sau khi giao hàng',
		a872: 'Số bộ sưu tập nhanh',
		a873: 'Điểm trừ',
		a874: 'điểm thu nhập',
		a875: 'Xem đơn hàng',
		a876: 'Xuất lệnh',
		a877: 'In ký hiệu chuyển phát nhanh',
		a878: 'Loại hậu cần:',
		a879: 'Loại người bán',
		a880: 'Chế độ hàng nhạy cảm',
		a881: 'Chế độ vận chuyển hàng hóa thông thường',
		a882: 'Chế độ giao hàng nhạy cảm đã được kích hoạt',
		a883: 'Đã bật chế độ giao hàng tổng hợp',
		a884: 'Tôi biết rồi',
		a885: 'Quét ra khỏi thư viện',
		a886: 'Không có tin nhắn của người bán',
		a887: 'Không có mã vạch',
		a888: 'Không có thông tin',
		a889: 'Số lượng lấy bất thường! ',
		a890: 'Vui lòng quét số thứ tự trước! ',
		a891: 'Em ơi, em chưa ràng buộc shopee! ',
		a892: 'Đến cửa hàng shopee bị ràng buộc! ',
		a893: 'đã nhận',
		a894: 'không được thu thập',
		a895: 'số thứ tự',
		a896: 'Phương thức vận chuyển',
		a897: 'Nhận xét của người bán',
		a898: 'Đẩy thời gian',
		a899: 'Thông tin liên hệ',
		a900: 'Điểm thoát',
		a901: 'Tạo số vận đơn',
		a902: 'Khởi tạo PDF',
		a903: 'In lại trang mặt',
		a904: 'Vận đơn đã được tạo, vui lòng làm mới trang theo cách thủ công!',
		a905: 'Vui lòng tạo số vận đơn và in nó!',
		a906: 'Số lượng xuất đi thực tế của người bán',
		a907: 'Không có tên hậu cần',
		a908: 'Đơn hàng đã được xử lý',
		a909: 'Nhập truy vấn số đơn đặt hàng',
		a910: 'Phí gửi đi',
		a911: 'Lợi nhuận đơn đặt hàng phân phối',
		a912: 'Danh sách phân phối',
		a913: 'Lưu trữ bộ lọc:',
		a914: 'loại nhà kho',
		a915: 'Trả đơn đặt hàng',
		a916: 'Truy vấn',
		a917: 'Rebinding',
		a918: 'Sản phẩm trong kho chưa liên kết',
		a919: 'liên kết',
		a920: 'Không phát hiện thấy kho giao hàng',
		a921: 'Người bán yêu cầu phương thức xử lý',
		a922: 'Phương pháp xử lý thực tế của nhà kho',
		a923: 'Trạng thái trả về:',
		a924: 'Người bán đã xác minh hàng trả lại',
		a925: 'Người bán đã xác nhận',
		a926: 'Đã xử lý',
		a927: 'Vui lòng chọn phương thức xử lý',
		a928: 'Người bán xác nhận thành công, đang chờ xử lý kho hàng',
		a929: 'Đơn hàng đang chờ xem xét, vui lòng thao tác sau khi xem xét đơn hàng! ',
		a930: 'Thử nghiệm',
		a931: 'phương pháp in',
		a932: 'Bảng mặt & danh sách chọn',
		a933: 'Chỉ nhận lệnh khuôn mặt',
		a934: 'Chỉ danh sách chọn hàng',
		a935: 'Thu phóng một bề mặt',
		a936: 'Văn bản mô tả',
		a937: 'Vui lòng điền thông tin giao hàng trước',
		a938: 'Xuất tập tin xlsx',
		a939: 'Danh sách cửa hàng',
		a940: 'Bản in lịch sử',
		a941: 'Khoảng thời gian in',
		a942: 'kiểu in',
		a943: 'Số lượng đặt hàng in',
		a944: 'tái bản',
		a945: 'Kiểm tra',
		a946: 'in một mặt',
		a947: 'tên in',
		a948: 'Thời gian in (lần đầu tiên)',
		a949: 'không được in',
		a950: 'đã in',
		a951: 'Lệnh in',
		a952: 'In danh sách chọn mặc định',
		a953: 'Nó đã được in, tải lại trang hiện tại',
		a954: 'Không thể trả lại để xem xét',
		a955: 'Được rồi, tôi hiểu rồi',
		a956: 'Tiến độ xử lý đơn hàng',
		a957: 'Đã nhận được chuyển phát nhanh! ',
		a958: 'Kho quét xong bỏ kho, chờ chuyển phát nhanh đến lấy rồi lên mạng! ',
		a959: 'Kho hàng đã kiểm tra xong, đang chờ kho hàng quét hết kho hàng! ',
		a960: 'Kho đã in bảng mặt để phân loại, kho đang chờ kiểm định! ',
		a961: 'Kho hàng đã phân phối xong, chờ kho hàng in bảng mặt phân loại! ',
		a962: 'Đã duyệt, chờ phân kho và phân phối! ',
		a963: 'Số vận đơn đang được tạo, vui lòng không rời khỏi trang hiện tại! ',
		a964: 'Tổng',
		a965: 'đơn hàng/đã hoàn thành',
		a966: 'Truy vấn đơn hàng',
		a967: 'Chứa truy vấn',
		a968: 'Tìm kiếm tên sản phẩm, mã sản phẩm',
		a969: 'Đẩy thời gian sắp xếp (từ sớm đến muộn)',
		a970: 'Đẩy thời gian sắp xếp (từ muộn đến sớm)',
		a971: 'Điền thông tin cơ bản của người gửi chuyển phát nhanh',
		a972: 'Tên người gửi',
		a973: 'Số điện thoại người gửi',
		a974: 'Địa chỉ chi tiết của người gửi hàng',
		a975: 'Nhãn hiệu lô/ghi chú',
		a976: 'Đồng bộ số đơn đặt hàng đơn',
		a977: 'Thông tin đơn đặt hàng xuất hàng loạt',
		a978: 'đơn hàng được sửa đổi bởi người dùng',
		a979: 'Thêm dấu',
		a980: 'Thu tiền khi nhận hàng',
		a981: 'kiểm tra thời gian',
		a982: 'Không được chọn',
		a983: 'không ra khỏi kho',
		a984: 'Hậu cần',
		a985: 'không được tạo',
		a986: 'tiến trình đặt hàng',
		a987: 'Lời nhắc khẩn cấp',
		a988: 'Xử lý nhanh',
		a989: 'Đang tải lệnh chờ, vui lòng đợi!!!',
		a990: 'Gửi thành công thông tin nhận xét! ',
		a991: 'Việc gửi là bất thường, xin vui lòng thử lại sau một thời gian! ',
		a992: 'Hệ thống phát hiện bạn chưa điền thông tin giao hàng cơ bản, vui lòng điền trước để có thể in nhanh hàng loạt! ',
		a993: 'Đã lưu thành công! ',
		a994: 'Ngươi cấp tốc mệnh lệnh này, mỗi ngày mệnh lệnh chỉ có thể xúc tiến một lần! ',
		a995: 'Thời gian xem xét đơn hàng hiện tại chưa quá 24 giờ, không thể gấp rút đặt hàng, nếu sau 24 giờ duyệt đơn hàng vẫn chưa in thì có thể đôn đốc đặt hàng, cảm ơn. ',
		a996: 'Hiểu rồi',
		a997: 'Cùng một đơn hàng mỗi ngày chỉ được nhắc một lần, bạn có chắc chắn muốn nhắc gấp số đơn hàng này không? ',
		a998: 'Nhắc để nhắc',
		a999: 'Nhân viên kho đã được thông báo để ưu tiên đẩy nhanh đơn hàng! ',
		a1000: 'Xác nhận rút tiền',
		a1001: 'Lệnh? ',
		a1002: 'Đã trả lại thành công để xem xét! ',
		a1003: 'Đang đồng bộ hóa, quá trình này mất khoảng 50-60 giây! ! ! ',
		a1004: 'sổ tay tự tạo',
		a1005: 'Người bán đã ghi chú',
		a1006: 'Không có dấu',
		a1007: 'Vận đơn đã được tạo và trang hiện tại đang được làm mới! ',
		a1008: 'Vui lòng chọn thứ tự in! ',
		a1009: 'Kính gửi người dùng, nếu bạn đã in xong đơn đặt hàng, vui lòng làm mới trang hiện tại để nhận trạng thái đơn hàng mới nhất',
		a1010: 'Làm mới',
		a1011: 'Làm mới trang',
		a1012: 'Tiếp tục in tất cả',
		a1013: 'xóa các bản sao và tiếp tục in',
		a1014: 'Quản lý địa chỉ',
		a1015: 'Người nhận hàng',
		a1016: 'Chi tiết về việc không thể tạo vận đơn',
		a1017: 'Lý do tạo lỗi',
		a1018: 'Chọn hậu cần giao hàng',
		a1019: 'Chọn Hậu cần',
		a1020: 'Thể tích/cm',
		a1021: 'Vận chuyển hàng hóa thực tế',
		a1022: 'số vận đơn',
		a1023: 'Dài/cm',
		a1024: 'Rộng/cm',
		a1025: 'Cao/cm',
		a1026: 'số thuần túy',
		a1027: 'Tiền tệ',
		a1028: 'số vận đơn',
		a1029: 'Đặt địa chỉ giao hàng mặc định',
		a1030: 'Đặt địa chỉ giao hàng mặc định',
		a1031: 'Hóa đơn logistics tự xây dựng',
		a1032: 'Tạo hàng loạt danh sách khuôn mặt & danh sách chọn',
		a1033: 'Danh sách chọn mặt & in hàng loạt',
		a1034: 'Điền và sửa đổi thông tin chi tiết của người gửi hàng',
		a1035: 'Xem hồ sơ in lịch sử',
		a1036: 'Tấm mặt mặc định in bằng một cú nhấp chuột',
		a1037: 'Hàng tồn kho trực tuyến',
		a1038: 'Số lượng gửi đi',
		a1039: 'Điền thông tin hậu cần giao hàng vào biểu mẫu tự tạo',
		a1040: 'Điền phí kho kiểm tra',
		a1041: 'Vui lòng nhập chiều cao',
		a1042: 'Vui lòng nhập chiều dài, chiều rộng và chiều cao của mặt hàng',
		a1043: 'Vui lòng nhập chiều rộng',
		a1044: 'Vui lòng chọn hậu cần',
		a1045: 'Vui lòng nhập trọng lượng',
		a1046: 'Thông tin giao hàng hậu cần đã được gửi thành công! ',
		a1047: 'Dấu hoa thị màu đỏ là bắt buộc, vui lòng điền vào! ',
		a1048: 'Không có ghi chú của người bán',
		a1049: 'Vui lòng điền lý do trả lại để xem xét',
		a1050: 'thứ tự bình thường',
		a1051: 'Hiện có chứa các số vận đơn chưa được tạo hoặc các đơn hàng đang được tạo, xác nhận tất cả các số vận đơn đã tạo trước khi in!',
		a1052: 'Sử dụng chế độ này để in biểu mẫu sẽ khiến trình duyệt bật lên nhiều cửa sổ biểu mẫu, vui lòng cố gắng chọn cùng một người bán và cùng một đơn đặt hàng hậu cần để in',
		a1053: 'Tôi hiểu rồi, tiếp tục in',
		a1054: 'Lỗi dữ liệu vận đơn nền, vui lòng tạo lại số vận đơn, sau đó xác nhận để in vận đơn! ',
		a1055: 'Các đơn hàng có số vận đơn chưa được tạo, vui lòng xác nhận số vận đơn đã tạo trước khi in! ',
		a1056: 'Vui lòng xác nhận rằng tất cả các đơn đặt hàng đã tạo số vận đơn trước khi in! ',
		a1057: 'Vui lòng đặt địa chỉ gửi mặc định trước khi in',
		a1058: 'Vui lòng đặt địa chỉ gửi mặc định trước khi in',
		a1059: 'Hiện được chọn',
		a1060: 'Theo thứ tự, vâng',
		a1061: 'Số vận đơn chưa được tạo cho đơn hàng hoặc đang được tạo, vui lòng xác nhận rằng tất cả các đơn hàng được chọn đã tạo số vận đơn trước khi in',
		a1062: 'Theo thứ tự sẽ có',
		a1063: 'Lệnh này sẽ được in lặp lại, xác nhận có in tiếp không? ',
		a1064: 'được người bán xác nhận',
		a1065: 'quản lý kho hàng',
		a1066: 'mặt hàng trong kho',
		a1067: 'gói kho',
		a1068: 'quà kho',
		a1069: 'Kho hàng đang được vận chuyển',
		a1070: 'Quản lý mua hàng',
		a1071: 'Nạp tiền ngay',
		a1072: 'Đã định cư tại các cửa hàng địa phương',
		a1073: 'Báo giá kho ở nước ngoài',
		a1074: 'Báo giá ERP thuần túy',
		a1075: 'Chuyển đổi mã QR',
		a1076: 'Danh sách yêu cầu',
		a1077: 'Lưu ràng buộc',
		a1078: 'Thêm mục bên trái vào liên kết bên phải',
		a1079: 'Chọn sản phẩm',
		a1080: 'sẽ ràng buộc hàng hóa',
		a1081: 'thêm',
		a1082: 'Bình thường',
		a1083: 'Đã dỡ khỏi kệ',
		a1084: 'Cài đặt câu hỏi đầu tiên',
		a1085: 'Cài đặt cơ sở kiến ​​thức',
		a1086: 'cài đặt từ khóa',
		a1087: 'Hiện đang cùng với…',
		a1088: 'Khách',
		a1089: 'Thời gian giao hàng còn lại ngoài giờ',
		a1090: 'nhắc nhở đơn hàng',
		a1091: 'Thái Lan',
		a1092: 'tiếng Mã Lai',
		a1093: 'Nhắc nhở thanh toán số dư',
		a1094: 'Điền thông tin',
		a1095: 'Sửa đổi nhận xét',
		a1096: 'Sửa số đơn đặt hàng mạng',
		a1097: 'Nhiều đơn đặt hàng được phân tách bằng dấu phẩy (,)',
		a1098: 'thuộc tính tùy chỉnh',
		a1099: 'Sửa kho trung chuyển',
		a1100: 'Sửa đổi nhà cung cấp',
		a1101: 'Sửa đổi nhận xét mua hàng',
		a1102: 'Sửa số vận đơn',
		a1103: 'Lịch sử thay đổi trạng thái',
		a1104: 'Thêm bình luận',
		a1105: 'chi tiết',
		a1106: 'Cập nhật trạng thái đơn đặt hàng',
		a1107: 'Sửa số lượng',
		a1108: 'Tỷ lệ thanh toán trước/%',
		a1109: 'Truy cập chu kỳ thanh toán/ngày',
		a1110: 'tên thuộc tính',
		a1111: 'giá trị thuộc tính',
		a1112: 'kho trung chuyển',
		a1113: 'Nhà cung cấp',
		a1114: 'Thời gian xem lại',
		a1115: 'ID người đánh giá',
		a1116: 'Trạng thái kiểm tra',
		a1117: 'Nhận xét đánh giá',
		a1118: 'Xem trước ảnh',
		a1119: 'Hình ảnh sản phẩm',
		a1120: 'Thông tin sản phẩm',
		a1121: 'Mua hàng trong kho',
		a1122: 'Sau khi bật cập nhật tự động cho tất cả các liên kết trực tuyến bị ràng buộc, số lượng này sẽ được đồng bộ hóa, hàng tồn kho trực tuyến=hàng tồn kho trong hàng tồn kho bị khóa trong kho-hàng tồn kho đang chờ xử lý',
		a1123: 'Số lượng lưu kho của hàng trong kho là số lượng còn lại thực tế hiện đang ở trong kho và chưa được xuất ra',
		a1124: 'Mua ID danh mục sản phẩm',
		a1125: 'Số lượng mua',
		a1126: 'Đơn giá mua hàng',
		a1127: 'Nhận xét mua hàng',
		a1128: 'Vui lòng nhập ghi chú (tùy chọn)',
		a1129: 'Thêm kho trung chuyển mới',
		a1130: 'Vui lòng nhập tên kho hàng',
		a1131: 'kho trung chuyển',
		a1132: 'ID kho hàng',
		a1133: 'Địa chỉ nhà cung cấp',
		a1134: 'Phương thức giải quyết',
		a1135: 'Chu kỳ thanh toán/ngày',
		a1136: 'Thêm nhà cung cấp',
		a1137: 'Phương thức thanh toán:',
		a1138: 'Phương thức vận chuyển',
		a1139: 'Cập nhật thông tin nhà cung cấp',
		a1140: 'chu kỳ thanh toán',
		a1141: 'Tên nhà cung cấp',
		a1142: 'Vui lòng nhập từ khóa tên sản phẩm, số đơn đặt hàng hoặc số vận đơn nội địa',
		a1143: 'Kho mua hàng',
		a1144: 'Người mua công khai',
		a1145: 'Số đơn đặt hàng',
		a1146: 'Đã thanh toán khoản đầu tiên',
		a1147: 'Thanh toán số dư đã được thanh toán',
		a1148: 'Sản phẩm nền tảng phân phối',
		a1149: 'Mua sản phẩm',
		a1150: 'Người bắt đầu nhu cầu mua hàng',
		a1151: 'Người mua',
		a1152: 'Trưởng nhóm mua hàng',
		a1153: 'Có chuyển hay không',
		a1154: 'Thời gian cập nhật trạng thái mới nhất',
		a1155: 'Trạng thái mua hàng',
		a1156: 'Nhận xét',
		a1157: 'tóc thẳng',
		a1158: 'cần chuyển',
		a1159: 'Đợi đã',
		a1160: 'đánh giá cấp một',
		a1161: 'Đánh giá cấp hai',
		a1162: 'Cần thanh toán số dư',
		a1163: 'Đơn đặt hàng này phải trả tổng số điểm',
		a1164: 'Tỷ lệ trả trước',
		a1165: 'Khoản trả góp đầu tiên',
		a1166: 'Kho nền tảng',
		a1167: 'Kích thước sản phẩm',
		a1168: 'Trọng lượng sản phẩm',
		a1169: 'vị trí',
		a1170: 'Giá mua hàng hóa',
		a1171: 'Lưu giữ trong kho',
		a1172: 'Sửa số lượng mua',
		a1173: 'Thông tin cơ bản về nhà cung cấp',
		a1174: 'Thông tin cơ bản về đơn đặt hàng',
		a1175: 'đơn đặt hàng ròng',
		a1176: 'Số vận đơn nội địa',
		a1177: 'Nhận xét về đơn đặt hàng',
		a1178: 'Thời gian đến ước tính',
		a1179: 'Giá trị thuộc tính tùy chỉnh',
		a1180: 'Không có giá trị thuộc tính tùy chỉnh',
		a1181: 'Nhận xét về đơn đặt hàng',
		a1182: 'Không có bình luận đơn đặt hàng',
		a1183: 'Thêm bình luận mới',
		a1184: 'Người đánh giá',
		a1185: 'Nội dung bình luận',
		a1186: 'Chưa qua',
		a1187: 'Đạt',
		a1188: 'Cập nhật',
		a1189: 'Tạo kho hàng',
		a1190: 'Đơn đặt hàng',
		a1191: 'tìm kiếm đơn đặt hàng',
		a1192: 'Tạo đơn đặt hàng theo cách thủ công',
		a1193: 'Tạo nhà cung cấp',
		a1194: 'Danh sách nhà cung cấp',
		a1195: 'Kho trung chuyển của tôi',
		a1196: 'Không có thông tin sản phẩm',
		a1197: 'Xem thêm',
		a1198: 'Sản phẩm ẩn',
		a1199: 'còn lại',
		a1200: 'tổng',
		a1201: 'sản phẩm',
		a1202: 'Xem lịch sử thay đổi trạng thái',
		a1203: 'Kiểm tra',
		a1204: 'Số dư thanh toán',
		a1205: 'Theo số đơn đặt hàng',
		a1206: 'mã sản phẩm',
		a1207: 'Tất cả trạng thái',
		a1208: 'Kiểm tra bị từ chối',
		a1209: 'đang chờ xem xét cấp một',
		a1210: 'Đang chờ đánh giá cấp hai',
		a1211: 'mua hàng',
		a1212: 'Đang trên đường đến kho trung chuyển',
		a1213: 'đã đến kho trung chuyển',
		a1214: 'Đang trên đường đến kho đầu cuối',
		a1215: 'đã đến kho đầu cuối',
		a1216: 'đã được lưu trữ',
		a1217: 'Vận chuyển đường bộ',
		a1218: 'Vận tải đường biển',
		a1219: 'Vận tải hàng không',
		a1220: 'Tiền mặt',
		a1221: 'trực tuyến',
		a1222: 'thẻ ngân hàng',
		a1223: 'Thanh toán số dư thành công',
		a1224: 'Yêu cầu bắt đầu:',
		a1225: 'Mua nhân sự:',
		a1226: 'Trạng thái mua hàng:',
		a1227: 'Đã thêm thành công',
		a1228: 'Làm mới thành công',
		a1229: 'Vui lòng điền giá mua sản phẩm',
		a1230: 'bị từ chối',
		a1231: 'Cập nhật thành công',
		a1232: 'Đã xóa thành công',
		a1233: 'Vui lòng chọn trạng thái sẽ được cập nhật',
		a1234: 'Cập nhật trạng thái thành công',
		a1235: 'Đơn hàng chưa qua kiểm duyệt và không thể sửa trạng thái',
		a1236: 'Đơn đặt hàng đã được đưa vào kho và không thể sửa đổi trạng thái',
		a1237: 'Tạo nhà cung cấp thành công! ',
		a1238: 'Kính gửi người dùng, nếu bạn đã gửi đơn đặt hàng, vui lòng làm mới trang hiện tại để nhận tất cả các đơn đặt hàng mới nhất',
		a1239: 'Thông tin cơ bản',
		a1240: 'Liên kết hàng hóa:',
		a1241: 'Mô tả',
		a1242: 'Hình ảnh sản phẩm',
		a1243: 'Tên thuộc tính',
		a1244: 'loại thuộc tính',
		a1245: 'Thông số kỹ thuật hàng hóa',
		a1246: 'Vui lòng nhập SKU mẹ',
		a1247: 'Điền thuộc tính',
		a1248: 'cài đặt thống nhất',
		a1249: 'Điền vào kho',
		a1250: 'điền mã hàng',
		a1251: 'Thông số kỹ thuật',
		a1252: 'giá bán lẻ',
		a1253: 'Trọng lượng hàng hóa',
		a1254: 'Kích thước sản phẩm',
		a1255: 'Dài',
		a1256: 'Rộng',
		a1257: 'Cao',
		a1258: 'Lợi nhuận dự kiến',
		a1259: 'Có kiểm tra chất lượng không',
		a1260: 'Từ khóa sản phẩm',
		a1261: 'Trạng thái bán hàng',
		a1262: 'Chi phí mua hàng',
		a1263: 'Nhà cung cấp sản phẩm',
		a1264: 'Kho sản phẩm',
		a1265: 'Thông tin hình ảnh',
		a1266: 'Ảnh bìa',
		a1267: 'Thuộc tính sản phẩm',
		a1268: 'Thêm thuộc tính mới',
		a1269: 'Thuộc tính chung',
		a1270: 'Thuộc tính đặc tả',
		a1271: 'Thông số chứng khoán',
		a1272: 'Nhiều thông số kỹ thuật',
		a1273: 'Loại',
		a1274: 'Loại thông số kỹ thuật',
		a1275: 'Giá gốc bán lẻ',
		a1276: 'thông tin hậu cần',
		a1277: 'Thông tin khác',
		a1278: 'Cập nhật thông tin sản phẩm',
		a1279: 'Quay lại',
		a1280: 'Yêu cầu kiểm tra chất lượng',
		a1281: 'Miễn kiểm tra',
		a1282: 'Vui lòng nhập tên sản phẩm',
		a1283: 'Không quá 255 ký tự',
		a1284: 'Vui lòng điền vào mô tả sản phẩm',
		a1285: 'Đề nghị lựa chọn loại mục',
		a1286: 'Vui lòng chọn một thông số kỹ thuật',
		a1287: 'Vui lòng điền trọng lượng',
		a1288: 'Vui lòng điền thông số sản phẩm',
		a1289: 'Vui lòng điền thuộc tính sản phẩm',
		a1290: 'Vui lòng nhập sku chính của sản phẩm',
		a1291: 'Trên kệ',
		a1292: 'Đã hết hàng',
		a1293: 'màu xanh',
		a1294: 'dữ liệu nguồn',
		a1295: 'Mua sắm tại Trung tâm bán lẻ Xiaosheng',
		a1296: 'Thêm vào thư viện sản phẩm',
		a1297: 'Vui lòng chọn cửa hàng xuất bản theo trang web! ',
		a1298: 'Vui lòng chọn cửa hàng! ',
		a1299: 'Thuộc tính bắt buộc, vui lòng điền thuộc tính! ',
		a1300: 'Vui lòng điền giá và lượng hàng, và cả hai đều không thể là 0',
		a1301: 'Trọng lượng sản phẩm là bắt buộc, không thể là 0, vui lòng điền! ',
		a1302: 'Hậu cần là bắt buộc, vui lòng chọn hậu cần',
		a1303: 'Sản phẩm đã được lên kệ tại trung tâm bán lẻ của Xiaosheng! ',
		a1304: 'Thông tin hậu cần đã được đồng bộ hóa mới nhất! ',
		a1305: 'Ga Thái Lan',
		a1306: 'Trạm Philippines',
		a1307: 'Ga Indonesia',
		a1308: 'Trạm Mã Lai',
		a1309: 'Ga Đài Loan',
		a1310: 'Nhà ga Việt Nam',
		a1311: 'Bạn có chắc chắn xóa',
		a1312: 'Hiện tại, thông số kỹ thuật của sản phẩm có thể được thiết lập thành hai cấp độ! ',
		a1313: 'Xác nhận hàng lên kệ? ',
		a1314: 'Sản phẩm đã lên kệ! ',
		a1315: 'Mẫu được tạo thành công! ',
		a1316: 'Vui lòng chọn cửa hàng phát hành sản phẩm theo trang web! ',
		a1317: 'Vui lòng điền giá và kho',
		a1318: 'Không thể để trống giá trị thay đổi',
		a1319: 'Không khớp',
		a1320: 'đang được chia sẻ',
		a1321: 'Không thể tự động khớp và liên kết một sản phẩm với sản phẩm trong kho, bạn có thể sửa đổi mã sản phẩm để nhất quán với mã hàng trong kho rồi liên kết lại hoặc liên kết theo cách thủ công',
		a1322: 'Không có mã hàng trong kho',
		a1323: 'Giá cung cấp：',
		a1324: ', vui lòng điền giá bán lẻ ban đầu',
		a1325: 'Vui lòng chọn sản phẩm cần mua và lưu trữ',
		a1326: 'hồ sơ',
		a1327: 'Tra mã kho hàng, sku, tên hàng',
		a1328: 'Tạo thứ tự lưu trữ',
		a1329: 'Lưu trữ sản phẩm',
		a1330: 'Lưu trữ sản phẩm đặt hàng',
		a1331: 'Hủy tất cả dung lượng lưu trữ của sản phẩm hiện tại',
		a1332: 'Chọn tất cả sản phẩm hiện tại vào kho lưu trữ',
		a1333: 'Bỏ chọn',
		a1334: 'Chọn bộ nhớ',
		a1335: 'Mở rộng để xem thêm',
		a1336: 'Ẩn lên trên',
		a1337: 'cái',
		a1338: 'Bộ lọc trạng thái đơn đặt hàng',
		a1339: 'Gói độc lập',
		a1340: 'Tất cả vật phẩm và gói hàng',
		a1341: 'Thư viện một sản phẩm',
		a1342: 'thư viện gói',
		a1343: 'Điền giá',
		a1344: 'Vui lòng chọn sản phẩm kho liên kết',
		a1345: 'Bộ sưu tập thành công',
		a1346: 'Trạng thái sản phẩm',
		a1347: 'Không có thông tin mẫu',
		a1348: 'Có bán trước hay không',
		a1349: 'tổng kho',
		a1350: 'tổng doanh thu',
		a1351: 'Trạng thái sản phẩm',
		a1352: 'Trung tâm bán lẻ',
		a1353: 'Đã phát hành',
		a1354: 'Chưa xuất bản',
		a1355: 'Phát hành',
		a1356: 'Sao chép',
		a1357: 'thuộc tính',
		a1358: 'Ẩn',
		a1359: 'Vui lòng chọn cửa hàng',
		a1360: 'Trạng thái lên kệ',
		a1361: 'Lựa chọn thuộc tính',
		a1362: 'Vui lòng chọn một đơn vị',
		a1363: 'Cho dù là đồ cũ:',
		a1364: 'Khu vực quốc gia:',
		a1365: 'Link sản phẩm:',
		a1366: 'Thông số kỹ thuật khác',
		a1367: 'Thêm thông số kỹ thuật mới',
		a1368: 'Chi tiết sản phẩm',
		a1369: 'ID thuộc tính',
		a1370: 'ID sản phẩm',
		a1371: 'Loại thời gian',
		a1372: 'Giá bán dự kiến',
		a1373: 'Điều kiện tìm kiếm',
		a1374: 'Sản phẩm',
		a1375: 'Nhấp để sửa đổi thông tin cần điền',
		a1376: 'Đây có phải là một sản phẩm không',
		a1377: 'Danh mục cửa hàng',
		a1378: 'Danh mục thứ tư',
		a1379: 'Danh mục năm cấp',
		a1380: 'mới toanh',
		a1381: 'Đã qua sử dụng',
		a1382: 'Thêm thuộc tính',
		a1383: 'chọn tất cả',
		a1384: 'Chế độ hậu cần đồng bộ',
		a1385: 'Lưu và xuất bản',
		a1386: 'lưu mẫu',
		a1387: 'Chỉ lưu mẫu',
		a1388: 'Phát hành ngay lập tức',
		a1389: 'Thông tin cơ bản về sản phẩm',
		a1390: 'Miêu tả sản phẩm',
		a1391: 'Tên sku sản phẩm',
		a1392: 'Chi phí mua sản phẩm',
		a1393: 'Trạng thái bán sản phẩm',
		a1394: 'Địa chỉ sản phẩm',
		a1395: 'Chủ sở hữu sản phẩm',
		a1396: 'Thông tin thuộc tính sản phẩm',
		a1397: 'Thời gian sửa đổi',
		a1398: 'Thông tin hậu cần sản phẩm',
		a1399: 'Chiều dài sản phẩm',
		a1400: 'Chiều rộng sản phẩm',
		a1401: 'Chiều cao sản phẩm',
		a1402: 'thông tin thuộc tính sku phụ',
		a1403: 'Mở rộng tất cả',
		a1404: 'Bộ lọc Sản phẩm',
		a1405: 'Sửa thông tin',
		a1406: 'Đã phê duyệt',
		a1407: 'Đã phê duyệt',
		a1408: 'Tất cả các trang web',
		a1409: 'Chọn kho:',
		a1410: 'Nhà cung cấp:',
		a1411: 'Mẫu được lưu thành công! ',
		a1412: 'Kiểm tra thành công, vui lòng đến bộ phận quản lý sản phẩm để đưa sản phẩm lên kệ',
		a1413: 'Kiểm tra thành công, nhập quản lý sản phẩm để phát hành',
		a1414: 'Sửa đổi đã lưu',
		a1415: 'Bạn có chắc chắn sẽ phát hành nó cho trung tâm bán lẻ Xiaosheng không? ',
		a1416: 'Vui lòng chọn sản phẩm! ',
		a1417: 'Sản phẩm đã ngừng sản xuất! ',
		a1418: 'Sao chép thành công! ',
		a1419: 'Bạn có chắc chắn muốn xóa bản mẫu chính này không? ',
		a1420: 'hộp nháp',
		a1421: 'trang web',
		a1422: 'Chỉnh sửa lại',
		a1423: 'Cập nhật hình ảnh',
		a1424: 'Chọn sku gốc cần được liên kết',
		a1425: 'Tìm mã cusCode / sku mẹ / sku con',
		a1426: 'thông tin sku phụ',
		a1427: 'Hình mờ mẫu (tải hình ảnh hình mờ PNG lên với kích thước 800*800px/500*500px)',
		a1428: 'Chọn trang web',
		a1429: 'SKU gốc hàng hóa',
		a1430: 'Đang tải hình mờ, vui lòng đợi! ',
		a1431: 'Áp dụng tất cả ảnh',
		a1432: 'Chỉ áp dụng hình ảnh đầu tiên',
		a1433: 'Thêm hình ảnh sản phẩm',
		a1434: 'Tự động liên kết',
		a1435: 'ràng buộc thủ công',
		a1436: 'Ràng buộc',
		a1437: 'Đặt công thức tính giá bán lẻ',
		a1438: 'Giá gốc bán lẻ tại địa phương',
		a1439: 'Đã xóa! ',
		a1440: 'Bản ghi hiện tại đã được lưu trong hộp nháp',
		a1441: 'Số ký tự trong thông tin mô tả sản phẩm chỉ được từ 2-3000 ký tự',
		a1442: 'Mã sản phẩm không được chứa các ký tự không hợp lệ, chẳng hạn như: Tiếng Trung/ký tự đặc biệt',
		a1443: 'Mã sản phẩm, tiêu đề và mô tả không được chứa các ký tự không hợp lệ, chẳng hạn như: Tiếng Trung/ký tự đặc biệt',
		a1444: 'Không thể xóa thuộc tính đặc tả cấp một',
		a1445: ', vui lòng điền vào',
		a1446: 'Giá bán lẻ gốc tại địa phương',
		a1447: 'Không thể để trống',
		a1448: 'Mới',
		a1449: 'Đặt lại',
		a1450: 'Chi tiết tài khoản người mua (chỉ có thể tạo tối đa 5 tài khoản người mua)',
		a1451: 'Tài khoản người mua',
		a1452: 'biệt hiệu của người mua',
		a1453: 'Tài khoản người mua mới',
		a1454: 'trưởng nhóm',
		a1455: 'Đặt làm trưởng nhóm',
		a1456: 'Thêm tài khoản người mua mới (đăng ký tối đa 5 tài khoản mua hàng)',
		a1457: 'Nhập biệt hiệu của người mua',
		a1458: 'Nhập mật khẩu đăng nhập',
		a1459: 'Xác nhận mật khẩu đăng nhập',
		a1460: 'Biệt hiệu của người mua là bắt buộc',
		a1461: 'Mật khẩu được yêu cầu',
		a1462: 'Chọn mua sản phẩm',
		a1463: 'Thêm sản phẩm đã chọn',
		a1464: 'Giá bán buôn Trung Quốc',
		a1465: 'Chi tiết mua hàng',
		a1466: 'Giao',
		a1467: 'Mua kho:',
		a1468: 'Phương pháp:',
		a1469: 'kho trung chuyển:',
		a1470: 'Phương thức mua hàng:',
		a1471: 'Người mua thông thường',
		a1472: 'Người mua:',
		a1473: 'Người mua công khai:',
		a1474: 'Nếu bạn không chọn mặc định là chính mình',
		a1475: 'Vui lòng chọn mua sắm công',
		a1476: 'Trưởng nhóm mua hàng:',
		a1477: 'Đặt người lãnh đạo',
		a1478: 'Tự động điền sau khi chọn nhà cung cấp',
		a1479: 'Thêm nhiều đơn đặt hàng ròng',
		a1480: 'Thêm thuộc tính tùy chỉnh bạn cần cho đơn đặt hàng',
		a1481: 'Xóa sản phẩm đã chọn',
		a1482: 'Thêm sản phẩm',
		a1483: 'Số đơn đặt hàng ròng:',
		a1484: 'Nhận xét đơn đặt hàng:',
		a1485: 'Số vận đơn Trung Quốc:',
		a1486: 'Người khởi tạo yêu cầu',
		a1487: 'Cài đặt thành công',
		a1488: 'Chưa chọn trưởng nhóm thu mua',
		a1489: 'Hai mật khẩu đầu vào không nhất quán',
		a1490: 'Số tài khoản người mua của bạn:',
		a1491: ', mật khẩu:',
		a1492: 'Vui lòng thêm sản phẩm trước khi gửi',
		a1493: 'Đơn đặt hàng được tạo thành công, vào trang đơn đặt hàng để xem',
		a1494: 'Vui lòng chọn kho mua hàng trước',
		a1495: 'Giá vốn mua hàng',
		a1496: 'Gửi đơn đặt hàng',
		a1497: 'Cần tiêu điểm',
		a1498: 'Quay lại nền tảng phân phối',
		a1499: 'Chuyển đến trang quản lý đơn mua hàng',
		a1500: 'Số tiền mua',
		a1501: 'Tạo sản phẩm kho hàng',
		a1502: 'Hàng hóa được tạo thành công!',
		a1503: 'Tổng số lượng người bán đã mua lần này',
		a1504: 'Tổng số lượng thực tế đến kho',
		a1505: 'nhất quán',
		a1506: 'Sự khác biệt',
		a1507: 'Cảnh báo',
		a1508: 'Chi tiết về đơn đặt hàng lưu trữ đã xác nhận',
		a1509: 'Số lượng mua của người bán',
		a1510: 'Số lượng hàng đến thực tế',
		a1511: 'được trả bởi người bán',
		a1512: 'Đã thanh toán',
		a1513: 'mét khối',
		a1514: 'Tiêu chuẩn định giá',
		a1515: 'tổng khối lượng hàng hóa',
		a1516: 'Trọng lượng',
		a1517: 'Điểm phải nộp',
		a1518: 'Xác nhận thanh toán',
		a1519: 'In mã vạch SKU của sản phẩm',
		a1520: 'In mã vạch của lệnh lưu trữ',
		a1521: 'in mã vạch',
		a1522: 'Số lượng in',
		a1523: 'Người bán xác nhận thông tin lưu trữ',
		a1524: 'Có sai lệch vui lòng liên hệ kho để xác minh chi tiết! ',
		a1525: 'Giá mua',
		a1526: 'Số lượng hàng thực tế về kho',
		a1527: 'Chưa có tin nhắn',
		a1528: 'trả lại lõi nặng',
		a1529: 'Xác nhận lưu trữ',
		a1530: 'quản lý kho hàng',
		a1531: 'Đang lấy dữ liệu đơn đặt hàng lưu trữ, vui lòng đợi trong giây lát! ',
		a1532: 'Ước tính đến',
		a1533: 'đến thực tế',
		a1534: 'Phí chuyến đi đầu tiên',
		a1535: 'Xem & Sửa đổi',
		a1536: 'In mã vạch',
		a1537: 'Thanh toán thành công! ',
		a1538: 'Đang đợi chủ tiệm xác nhận',
		a1539: 'Đã thanh toán cho chuyến đi đầu tiên',
		a1540: 'Người bán hàng đang kiểm tra thông tin hóa đơn, mong bạn kiên nhẫn chờ đợi! ',
		a1541: 'Xin vui lòng kiểm tra sản phẩm! ',
		a1542: 'Tình trạng đơn hàng hiện tại không cho xóa! ',
		a1543: 'Thao tác này sẽ xóa vĩnh viễn đơn hàng lưu trữ hiện tại, bạn có muốn tiếp tục không?',
		a1544: 'Đã về kho kiểm tra lại! ',
		a1545: 'Số lượng mua của bên bán và số lượng thực nhận của kho có sự chênh lệch, bạn có muốn tiếp tục xác nhận thao tác nhập kho không? ',
		a1546: 'Có',
		a1547: 'Cần thanh toán cho xác nhận nhập kho này',
		a1548: 'điểm và các khoản khấu trừ bổ sung là bắt buộc',
		a1549: 'Kho phí linh tinh của điểm',
		a1550: 'Cần khấu trừ bổ sung cho việc nhập kho này',
		a1551: 'điểm',
		a1552: 'Được',
		a1553: 'Có sự khác biệt giữa số lượng lưu trữ của người bán và số lượng xác minh thực tế của kho hàng! ',
		a1554: 'Trạng thái lưu trữ',
		a1555: 'Thời gian tạo lệnh lưu trữ',
		a1556: 'Quét vào bộ lưu trữ',
		a1557: 'Kho lưu trữ',
		a1558: 'Người bán',
		a1559: 'Phí lưu trữ bổ sung',
		a1560: 'Điền số nguyên chất',
		a1561: 'Xác nhận đã nhận',
		a1562: 'Dài/cm(bắt buộc)',
		a1563: 'Rộng/cm(bắt buộc)',
		a1564: 'Rộng/cm(bắt buộc)',
		a1565: 'Trọng lượng/kg(bắt buộc)',
		a1566: 'Nhập tin nhắn cho người bán',
		a1567: 'Xin vui lòng điền chiều dài, chiều rộng, chiều cao và trọng lượng của sản phẩm! ',
		a1568: 'Số lượng bên bán mua đúng với số lượng thực tế kho giao, bạn xác nhận đã nhận hàng chưa? ',
		a1569: 'Số lượng mua của bên bán không khớp với số lượng nhập kho thực tế, bạn có muốn tiếp tục xác nhận hóa đơn không? ',
		a1570: 'Đã gửi thành công cho người bán để xác nhận! ',
		a1571: 'Tất cả người bán',
		a1572: 'Xác nhận đơn đặt hàng',
		a1573: 'loại truy vấn',
		a1574: 'giá trị truy vấn',
		a1575: 'Xem quy tắc định giá giám sát',
		a1576: 'sản phẩm trực tuyến',
		a1577: 'Tiền tệ quốc gia',
		a1578: 'Giá',
		a1579: 'Liên kết sản phẩm của đối thủ',
		a1580: 'Sản phẩm được giám sát',
		a1581: 'ID sự kiện',
		a1582: 'Giá hoạt động',
		a1583: 'Thời gian hết hạn',
		a1584: 'Bỏ ràng buộc',
		a1585: 'theo dõi xu hướng giá',
		a1586: 'Sửa đổi quy tắc giám sát',
		a1587: 'Sửa thông tin sản phẩm giảm giá',
		a1588: 'Mặc định',
		a1589: 'Tên hoạt động',
		a1590: 'Khu vực hoạt động',
		a1591: 'Vui lòng chọn một khu vực hoạt động',
		a1592: 'Khu vực 1',
		a1593: 'Khu vực 2',
		a1594: 'Thời gian hoạt động',
		a1595: 'Giao hàng ngay lập tức',
		a1596: 'Bản chất hoạt động',
		a1597: 'Hoạt động trực tuyến dành cho người sành ăn/nhà hàng',
		a1598: 'Hoạt động đẩy đất',
		a1599: 'Hoạt động ngoại tuyến',
		a1600: 'Tiếp xúc với thương hiệu thuần túy',
		a1601: 'Tài nguyên đặc biệt',
		a1602: 'Tài trợ thương hiệu trực tuyến',
		a1603: 'Địa điểm ngoại tuyến miễn phí',
		a1604: 'Hình thức hoạt động',
		a1605: 'Thêm thông tin sản phẩm giảm giá',
		a1606: 'Thời gian kết thúc sự kiện',
		a1607: 'Sản phẩm đang hoạt động',
		a1608: 'Giá trước sự kiện',
		a1609: 'Giá sự kiện',
		a1610: 'Số lượng mua có hạn',
		a1611: 'Ràng buộc sản phẩm của người dùng và sản phẩm của đối thủ',
		a1612: 'Nhận trang sản phẩm',
		a1613: 'Theo dõi giá khởi điểm:',
		a1614: 'Chiến lược giảm giá:',
		a1615: 'Giá trị quy định giảm:',
		a1616: 'Liên kết sản phẩm đã chọn',
		a1617: 'quy tắc một',
		a1618: 'Quy tắc 2',
		a1619: 'Tất cả giá đều dựa trên giá thấp nhất được theo dõi',
		a1620: 'Bạn có chắc chắn muốn hủy liên kết sản phẩm này không? ',
		a1621: 'Chức năng này chưa được khởi chạy. ',
		a1622: 'Giảm 0,01%',
		a1623: 'Mặc định giảm 0,01%',
		a1624: 'Không điều chỉnh',
		a1625: 'Giảm giá trị cố định',
		a1626: 'Tỷ lệ phần trăm giảm tùy chỉnh',
		a1627: 'Vui lòng nhập ghi chú',
		a1628: 'Hình ảnh sản phẩm',
		a1629: 'SKU phụ của sản phẩm',
		a1630: 'Quy tắc đặt giá',
		a1631: 'biểu đồ giám sát giá',
		a1632: 'Giá giám sát lần cuối',
		a1633: 'Tìm kiếm theo tên sản phẩm',
		a1634: 'Truy vấn dựa trên sku gốc',
		a1635: 'Tất cả sản phẩm',
		a1636: 'Đã lên kệ',
		a1637: 'Hàng hóa bị cấm',
		a1638: 'sản phẩm đã xóa',
		a1639: 'Vui lòng đặt khoảng thời gian bắt đầu nhỏ hơn khoảng thời gian kết thúc. ',
		a1640: 'Vui lòng nhập khoảng thời gian ít hơn 15 ngày. ',
		a1641: 'Xác nhận đóng? ',
		a1642: 'Đã quá hạn',
		a1643: 'đang tiến hành',
		a1644: 'Gỡ bỏ liên kết sản phẩm thành công! ',
		a1645: 'Sửa luật thành công! ',
		a1646: 'Chịu trách nhiệm cho cửa hàng',
		a1647: 'Chọn cửa hàng giới hạn, bạn có thể chọn nhiều cửa hàng! ',
		a1648: 'Chọn cửa hàng để liên kết (nhiều lựa chọn)',
		a1649: 'Tạo nhóm',
		a1650: 'tên nhóm',
		a1651: 'Chu kỳ chi phí',
		a1652: 'Khu phố',
		a1653: 'tháng',
		a1654: 'Tổng chi phí của các mặt hàng tùy chỉnh',
		a1655: 'Thêm hạng mục chi phí mới',
		a1656: 'Nhận phí lịch sử',
		a1657: 'Tên phí',
		a1658: 'Tên chi phí, chẳng hạn như: chi phí nhân công',
		a1659: 'Số tiền phí',
		a1660: 'năm',
		a1661: 'Năm',
		a1662: 'tháng',
		a1663: 'Chi tiết phí tùy chỉnh cửa hàng',
		a1664: 'Chi tiết phí tùy chỉnh theo nhóm',
		a1665: 'Mục chi phí đã được thêm thành công! ',
		a1666: 'Sửa phí thành công! ',
		a1667: 'Vui lòng xác nhận xem bạn có muốn xóa mục chi phí này không?',
		a1668: 'Vui lòng điền nội dung theo yêu cầu! ',
		a1669: 'thời gian',
		a1670: 'Chọn tháng',
		a1671: 'Chọn năm',
		a1672: 'Chọn quý',
		a1673: 'Tải lại trang hiện tại',
		a1674: 'Cửa hàng',
		a1675: 'Số tiền đặt hàng đã thanh toán (doanh số)',
		a1676: 'Tốc độ tăng trưởng chuỗi bán hàng',
		a1677: 'Phí quảng cáo',
		a1678: 'chi phí mua hàng',
		a1679: 'Yêu cầu số tiền thành công',
		a1680: 'Trả lại số tiền hoàn trả',
		a1681: 'Chi phí vận chuyển hành trình đầu tiên',
		a1682: 'Chưa có cửa hàng nào bị ràng buộc',
		a1683: 'Chi phí quảng cáo',
		a1684: 'Lợi nhuận',
		a1685: 'Tỷ suất lợi nhuận',
		a1686: 'Điểm toàn diện',
		a1687: 'Các hạng mục chi phí tùy chỉnh khác',
		a1688: 'Xem phí tùy chỉnh',
		a1689: 'Xóa nhóm',
		a1690: 'Q1',
		a1691: 'Quý thứ hai',
		a1692: 'Q3',
		a1693: 'Phần tư 4',
		a1694: 'Chi phí vận chuyển đầu mối: chỉ cần điền chính xác từng lô vào biểu mẫu nhập kho đầu mối, sau đó có thể tự động tính toán chi phí vận chuyển quy cho từng lô. Ví dụ, các lô hàng khác nhau của vận tải hàng không và vận tải đường biển có chi phí khác nhau.',
		a1695: 'Hiện chỉ hỗ trợ thu phí quảng cáo Shopee tự động, phí quảng cáo nền tảng khác cần thêm mục phí tùy chỉnh',
		a1696: 'Lợi nhuận = Bán hàng - Chi phí mua hàng hóa - Chi phí vận chuyển hàng đầu - Chi phí quảng cáo - Các mục chi phí tùy chỉnh khác + Số tiền yêu cầu thành công',
		a1697: 'Chi phí mua hàng: chi phí mua hàng thực tế, được tính tự động từ giá mua hàng tồn kho',
		a1698: 'Bạn có chắc chắn muốn hủy liên kết cửa hàng không?',
		a1699: 'Gỡ bỏ ghim thành công',
		a1700: 'Kết nối thành công! ',
		a1701: 'Xóa nhóm thành công! ',
		a1702: 'Nhóm được tạo thành công! ',
		a1703: 'Nhà phân phối không được phép phân phối sản phẩm của chính họ! ',
		a1704: 'Tôi muốn một mẫu',
		a1705: 'Quét để liên hệ với dịch vụ khách hàng phân phối để lấy mẫu',
		a1706: 'ID WeChat',
		a1707: 'Đang tải...',
		a1708: 'Phân phối thành công! ',
		a1709: 'Phân phối không thành công',
		a1710: 'Không được để trống tài khoản hoặc mật khẩu! ',
		a1711: 'Đăng nhập thành công! ',
		a1712: 'Sản phẩm phân phối tại chỗ',
		a1713: '1 cái thay cho giá',
		a1714: 'số lượng giao ngay',
		a1715: 'phân phối ngay lập tức',
		a1716: 'Hàng tồn kho',
		a1717: 'Chi tiết sản phẩm',
		a1718: 'Vui lòng đăng nhập tài khoản Xiaosheng của cửa hàng để phân phối lại sản phẩm! ',
		a1719: 'Bạn muốn tiếp tục phân phối sản phẩm này?',
		a1720: 'Phân phối thành công! Các sản phẩm tiếp theo sẽ được đưa lên nền tảng shopee, vui lòng truy cập nền tảng phân phối shopee "Tôi là đại lý" để đưa lên kệ! ',
		a1721: 'Đến cửa hàng đặt sản phẩm lên kệ',
		a1722: 'Tiếp tục phân phối sản phẩm',
		a1723: 'Liên hệ dịch vụ khách hàng',
		a1724: 'Nếu bạn cần lấy mẫu phân phối, vui lòng quét mã QR để liên hệ với dịch vụ khách hàng của nền tảng phân phối! ',
		a1725: 'Miễn phí sử dụng công cụ phân tích dữ liệu của Shopee',
		a1726: 'Plugin phân tích vỏ tôm',
		a1727: 'Nhấp để tải xuống',
		a1728: 'hình ảnh chính shopee',
		a1729: 'chỉ số shopee tăng vọt',
		a1730: 'doanh số hàng tháng của shopee',
		a1731: 'doanh số hàng tháng của shopee',
		a1732: 'Ngày lên kệ Shopee',
		a1733: 'shopee giá thấp nhất',
		a1734: 'chỉ số chuyển đổi shopee',
		a1735: 'Xem liên kết nguồn',
		a1736: 'Tải xuống ứng dụng Dianxiaosheng ngay bây giờ',
		a1737: 'Danh sách phân phối hàng hóa giao ngay tại Đông Nam Á',
		a1738: 'Danh sách khuyến nghị hấp dẫn',
		a1739: 'Tìm tên sản phẩm',
		a1740: 'hàng tồn kho giao ngay',
		a1741: 'Phân tích thị trường',
		a1742: 'Tôi muốn phân phối',
		a1743: 'Không có dữ liệu liên quan',
		a1744: 'Nền tảng phân phối Spot ở Đông Nam Á',
		a1745: 'Chi tiết sản phẩm phân phối',
		a1746: 'Vui lòng nhập tin nhắn',
		a1747: 'đặc tả mã hàng',
		a1748: 'Kho hàng giao ngay:',
		a1749: 'Sản phẩm này đã được phân phối thành công vào tài khoản Shopee của bạn. Nếu bạn muốn đưa sản phẩm lên nền tảng shopee, vui lòng đến nền tảng phân phối bên PC: Tôi là đại lý, tiếp tục hoạt động! ',
		a1750: 'Gửi mã xác minh',
		a1751: 'đăng ký',
		a1752: 'Đã đăng ký, nhấp để đăng nhập',
		a1753: 'Vui lòng nhập số điện thoại của bạn',
		a1754: 'Vui lòng nhập mật khẩu người dùng',
		a1755: 'Vui lòng nhập tên người dùng',
		a1756: 'Tùy chọn',
		a1757: 'Tài khoản email',
		a1758: 'Vui lòng điền thông tin đăng ký, không được để trống! ',
		a1759: 'Đăng ký thành công, vui lòng đăng nhập! ',
		a1760: 'Mã xác nhận đã được gửi, chú ý kiểm tra nhé! ',
		a1761: 'Vui lòng điền số điện thoại! ',
		a1762: 'Trang chủ phân phối',
		a1763: 'Tôi có thể cung cấp',
		a1764: 'Liên hệ dịch vụ khách hàng',
		a1765: 'Đăng nhập ngay',
		a1766: 'Thoát đăng nhập hiện tại',
		a1767: 'Nền tảng phân phối giao ngay Đông Nam Á/Đài Loan',
		a1768: 'Hàng giao ngay ở Đông Nam Á, một dropshipping',
		a1769: 'Khoảng không quảng cáo chính xác, liên kết ràng buộc, ngăn bán quá nhiều',
		a1770: 'Hỗ trợ người bán hàng tại địa phương Shopee/Lazade/Shopify',
		a1771: 'Mời phân phối',
		a1772: 'Sản phẩm phân phối được đề xuất',
		a1773: 'Xem thông tin liên quan đến shopee',
		a1774: 'Vị trí',
		a1775: 'Hiện tại chưa đăng nhập, vui lòng đăng nhập tài khoản Xiaosheng của cửa hàng trước khi tiến hành hoạt động phân phối! ',
		a1776: 'Đăng nhập hiện tại đã bị đăng xuất! ',
		a1777: 'Vui lòng đăng nhập vào tài khoản Xiaosheng của cửa hàng trước khi phân phối! ',
		a1778: 'Phân phối thành công, vui lòng nhấp vào Tôi đã làm đại lý để phát hành sản phẩm trong tương lai! ',
		a1779: 'Người dùng thích hợp mua sắm:',
		a1780: 'Bạn chân thành được mời phân phối các sản phẩm giao ngay của anh ấy, giao hàng một lần, để tăng lợi nhuận ròng của người bán! ',
		a1781: 'Tôi đã được đại diện',
		a1782: 'Tình trạng hiện tại chưa đăng nhập, mời đăng nhập! ',
		a1783: 'Chưa có sản phẩm đại lý! ',
		a1784: 'Tài khoản đăng nhập hiện tại đã bị đăng xuất! ',
		a1785: 'Tài khoản',
		a1786: 'Số lượng cửa hàng bị ràng buộc',
		a1787: 'Số lượng kho liên kết',
		a1788: 'Số điểm còn lại',
		a1789: 'Hệ thống Erp tập trung vào người bán xuyên biên giới ở Đông Nam Á',
		a1790: 'Plugin lựa chọn sản phẩm miễn phí phân tích Bei',
		a1791: 'Thiết bị đầu cuối di động',
		a1792: 'Tài liệu Hướng dẫn Hệ thống',
		a1793: 'Hỗ trợ kỹ thuật',
		a1794: 'tin nhắn mới',
		a1795: 'đăng xuất',
		a1796: 'Không có tin tức!',
		a1797: 'Tin tức mới nhất',
		a1798: 'tin nhắn chưa đọc',
		a1799: 'Trả lời',
		a1800: 'từ',
		a1801: 'Lời nhắc quan trọng từ hệ thống',
		a1802: 'Xem tất cả tin nhắn',
		a1803: 'Không có thông báo phiên',
		a1804: 'Bật mật khẩu phụ',
		a1805: 'Sau khi cài đặt, dữ liệu tài chính nhạy cảm như lợi nhuận gộp và giá mua cần được hiển thị sau khi nhập mật khẩu thứ hai',
		a1806: 'Số lượng đơn hàng đã thanh toán',
		a1807: 'Lưu ý: Sau khi bật mật khẩu phụ, sẽ không thể đóng được. Nó liên quan đến dữ liệu tài chính nhạy cảm như lợi nhuận gộp và giá mua, chỉ có thể hiển thị sau khi nhập mật khẩu phụ! ',
		a1808: 'Vui lòng nhập mật khẩu phụ',
		a1809: 'Thay đổi mật khẩu phụ',
		a1810: 'Tổng quan',
		a1811: 'Chi tạm ứng mua hàng hóa',
		a1812: 'Thu nhập ứng trước tiền mua hàng hóa',
		a1813: 'Khoản thanh toán cuối cùng cho việc mua hàng hóa',
		a1814: 'Phí người mua thanh toán trước cho nền tảng để mua hàng hóa',
		a1815: 'Hoa hồng thu được từ hệ thống trả trước mua hàng hóa',
		a1816: 'Tỷ giá hối đoái đã sửa đổi thành công',
		a1817: 'Đặt mật khẩu phụ thành công! ',
		a1818: 'tổng quan bán hàng sku',
		a1819: 'giá trị',
		a1820: 'Số lượng trong kho',
		a1821: 'Doanh thu trung bình/ngày (gần 7 ngày)',
		a1822: 'Thời gian lưu trữ gần đây',
		a1823: 'gần 30 ngày',
		a1824: 'gần 7 ngày',
		a1825: 'gần 3 ngày',
		a1826: 'Tổng doanh thu trong khoảng thời gian hiện tại',
		a1827: 'lựa chọn kho hàng',
		a1828: 'Xuất file excel',
		a1829: 'chu kỳ bổ sung (ngày)',
		a1830: 'truy vấn sản phẩm trong kho',
		a1831: 'Tìm mã kho/tên sku',
		a1832: 'Tạo bộ nhớ',
		a1833: 'Kiểm tra doanh số sku',
		a1834: 'nhắc nhở hết hàng',
		a1835: 'chi tiết khấu trừ',
		a1836: 'Chi tiết',
		a1837: 'Điểm trừ',
		a1838: 'mô tả khấu trừ',
		a1839: 'Chi tiết Chi tiêu',
		a1840: 'Bản ghi điểm',
		a1841: 'Truy vấn số thứ tự',
		a1842: 'Loại phí',
		a1843: 'Thay đổi tích phân',
		a1844: 'Nguồn thanh toán',
		a1845: 'Xem chi tiết khấu trừ',
		a1846: 'Toàn bộ kho',
		a1847: 'Cập nhật điểm',
		a1848: 'Xác nhận tiếp tục hoạt động, phí điểm hiện tại sẽ được thay đổi thành:',
		a1849: ' Tích phân, bạn có muốn tiếp tục thao tác cập nhật không! ',
		a1850: 'Có, cập nhật ngay',
		a1851: 'Cập nhật điểm thành công! ',
		a1852: 'Cập nhật điểm không thành công, quy tắc tính phí mới phù hợp với quy tắc hiện tại! ',
		a1853: 'Tính phí người bán "',
		a1854: '"phí kho linh tinh',
		a1855: 'Kho phí linh tinh',
		a1856: 'Trừ điểm của người bán',
		a1857: 'Nhận xét trừ các chi phí linh tinh',
		a1858: 'Ưu đãi người bán',
		a1859: 'Thêm ưu đãi mới',
		a1860: 'Giảm giá ưu đãi (giá trị từ 0 đến 1): 0: miễn phí, 1: không giảm giá, 0,95: giảm giá 95%',
		a1861: 'Nhà kho',
		a1862: 'Giảm giá ưu đãi',
		a1863: 'Số người dùng người bán được liên kết',
		a1864: 'Số điểm dồi dào',
		a1865: 'Thiếu điểm',
		a1866: 'Tài khoản người bán',
		a1867: 'Trạng thái của các điểm còn lại',
		a1868: 'Hiện tại chưa đến 30 điểm, vui lòng nhắc nhở người dùng cho phép giá trị kịp thời! ',
		a1869: 'Đặt chiết khấu',
		a1870: 'Tính phí linh tinh',
		a1871: 'Người bán ẩn',
		a1872: 'Hiển thị người bán',
		a1873: 'Phạm vi giá trị nằm trong khoảng từ 0 đến 1',
		a1874: 'phí tài liệu',
		a1875: 'Phí xếp hàng',
		a1876: 'phí lưu trữ',
		a1877: 'Quá tải SKU mặc định',
		a1878: 'Tính phí quá cao cho cùng một mã hàng',
		a1879: 'Cài đặt thành công!',
		a1880: 'Số điểm bị trừ không được bằng 0! ',
		a1881: 'Chú thích không được để trống! ',
		a1882: 'Nạp phí linh tinh thành công! ',
		a1883: 'Phạm vi giá trị nằm trong khoảng từ 0,6 đến 1',
		a1884: 'Giá trị ưu đãi của phí dịch vụ phải nằm trong khoảng từ 0,6 đến 1 và không thể nhỏ hơn 0,6',
		a1885: 'Tổng quan về kho hàng',
		a1886: 'Lệnh chờ xử lý',
		a1887: 'Đang xử lý đơn hàng hôm nay',
		a1888: 'Thu nhập điểm hôm nay',
		a1889: 'Kho phụ của tài khoản kho hiện tại',
		a1890: 'Biệt danh Tử Cương',
		a1891: 'Id kho phụ',
		a1892: 'loại kho phụ',
		a1893: 'Kho sản phẩm thử nghiệm',
		a1894: 'nhà kho đám mây ở nước ngoài',
		a1895: 'nhà kho tư nhân',
		a1896: 'Nhà kho Liên minh',
		a1897: 'Kho phân phối',
		a1898: 'Số điện thoại của người mua',
		a1899: 'Thời gian hỏi đáp',
		a1900: 'Danh sách hàng hóa',
		a1901: 'tên sản phẩm',
		a1902: 'Giá vốn (chỉ có thể nhập số nguyên hoặc số thập phân hợp lệ)',
		a1903: 'Chọn kho...',
		a1904: 'Trạng thái ràng buộc hàng hóa',
		a1905: 'nhận kho hàng',
		a1906: 'Xóa',
		a1907: 'Gửi',
		a1908: 'Liên kết sản phẩm thành công',
		a1909: 'đã bị ràng buộc',
		a1910: 'Liên kết không thành công',
		a1911: 'bị cấm',
		a1912: 'Đã xóa',
		a1913: 'Tạo sản phẩm kho hàng',
		a1914: 'Bản ghi được thêm thành công',
		a1915: 'Tất cả cửa hàng',
		a1916: 'Vui lòng nhập mã kho của sản phẩm trong kho hoặc thêm nó vào sản phẩm trong kho! ',
		a1917: 'Vui lòng chọn cửa hàng để đồng bộ lại sản phẩm',
		a1918: 'Sản phẩm đã được đồng bộ hóa',
		a1919: 'Hiện chưa có thông tin sản phẩm, vui lòng chọn sản phẩm cần thêm vào kho',
		a1920: 'Vui lòng chọn kho nhận hàng',
		a1921: 'Đã tham gia thành công',
		a1922: 'Xin chúc mừng, đây là một tin nhắn thành công',
		a1923: 'Hàng hóa ràng buộc',
		a1924: 'Sản phẩm trong kho cần được liên kết với ít nhất một sản phẩm trực tuyến. Nếu bạn không cần sản phẩm này, bạn có thể trực tiếp xóa sản phẩm trong kho!',
		a1925: 'Loại nhập khẩu',
		a1926: 'Loại lưu trữ',
		a1927: 'Tên hàng hóa có thể tìm kiếm, sku',
		a1928: 'Nhập tất cả bằng một cú nhấp chuột',
		a1929: 'Đồng bộ sản phẩm lazada',
		a1930: 'Nhập kho sản phẩm',
		a1931: 'Nhập vào thư viện vật phẩm trong kho',
		a1932: 'Nhập thư viện gói kết hợp',
		a1933: 'Trong thư viện vật phẩm nhà kho',
		a1934: 'thư viện gói kết hợp',
		a1935: 'Dữ liệu Shopee đang được cập nhật đồng bộ, vui lòng refresh sau giây lát! ',
		a1936: 'được tạo bởi cửa hàng hiện được chọn',
		a1937: 'Tạo theo danh mục hiện được chọn',
		a1938: 'Tạo theo các mục hiện được chọn',
		a1939: 'Hiện tại không có sản phẩm nào được kiểm tra! ',
		a1940: 'Bạn có chắc chắn xóa sản phẩm hiện tại không?',
		a1941: 'Dữ liệu lazada đang được cập nhật đồng bộ, vui lòng refresh sau một lúc! ',
		a1942: 'Đồng bộ hóa sản phẩm SHOPEE',
		a1943: 'danh mục',
		a1944: 'số lượng hiện tại',
		a1945: 'Hiện tại không có danh mục được chọn',
		a1946: 'Hàng nhập kho nhập lô',
		a1947: 'Theo cửa hàng hiện được chọn, nhập thư viện vật phẩm vào kho',
		a1948: 'Nhập thư viện gói kết hợp theo cửa hàng hiện được chọn',
		a1949: 'Theo các sản phẩm hiện được chọn, nhập chúng vào kho đặt hàng kho',
		a1950: 'Nhập thư viện gói kết hợp theo các sản phẩm hiện được chọn',
		a1951: 'Trên kệ',
		a1952: 'Theo cửa hàng hiện được chọn, tạo thư viện vật phẩm trong kho',
		a1953: 'Tạo thư viện gói kết hợp theo cửa hàng hiện được chọn',
		a1954: 'Tạo trong thư viện mục kho theo danh mục hiện được chọn',
		a1955: 'Tạo thư viện gói kết hợp theo danh mục hiện được chọn',
		a1956: 'Tạo đơn đặt hàng trong kho theo sản phẩm hiện được chọn',
		a1957: 'Tạo thư viện gói kết hợp theo các sản phẩm hiện được chọn',
		a1958: 'Quản lý tài khoản',
		a1959: 'Điện thoại di động',
		a1960: 'Vui lòng nhập mã xác minh điện thoại di động',
		a1961: 'Mật khẩu đăng nhập mới',
		a1962: 'Hộp thư',
		a1963: 'Vui lòng nhập mã xác minh email',
		a1964: 'Mật khẩu mới',
		a1965: 'Điện thoại hiện tại',
		a1966: 'Thay đổi mật khẩu đăng nhập',
		a1967: 'Nhập mật khẩu mới',
		a1968: 'Mã xác minh điện thoại di động',
		a1969: 'Hộp thư hiện tại',
		a1970: 'Mật khẩu thứ hai',
		a1971: 'Vui lòng nhập số điện thoại của bạn! ',
		a1972: 'Đổi mật khẩu thành công, đăng xuất, vui lòng đăng nhập lại! ',
		a1973: 'thêm địa chỉ',
		a1974: 'Điền người nhận hàng',
		a1975: 'Điền số điện thoại người nhận hàng',
		a1976: 'Điền địa chỉ chi tiết',
		a1977: 'Điền mã zip',
		a1978: 'Điện thoại di động/điện thoại',
		a1979: 'Người nhận hàng không được để trống! ',
		a1980: 'Phương thức người nhận không được để trống! ',
		a1981: 'Địa chỉ không được để trống! ',
		a1982: 'Tăng thành công! ',
		a1983: 'Trang thông tin cá nhân',
		a1984: 'Trung tâm quản lý thông tin',
		a1985: 'Quản lý tài khoản',
		a1986: 'Quản lý địa chỉ',
		a1987: 'Phân tích thông minh CRM chân dung người mua',
		a1988: 'Trong lý thuyết quản lý khách hàng: chi phí phát triển một khách hàng mới là chi phí giữ chân một khách hàng cũ',
		a1989: 'Thời đại! ! Việc duy trì và phục vụ khách hàng cũ là đặc biệt quan trọng! ! ! ',
		a1990: 'Vì lý do này, nhóm dữ liệu lớn của Dianxiaosheng đã điều chỉnh mô hình đào tạo và thuật toán trong một năm, đồng thời chính thức ra mắt chức năng phân tích khách hàng dành cho người bán. Chúng tôi đã kết hợp các đặc điểm của giao dịch thương mại điện tử xuyên biên giới ở Đông Nam Á và áp dụng máy học các mô hình thuật toán.Theo bạn',
		a1991: 'Tần suất mua hàng/số tiền mua hàng/xác suất tranh chấp hoàn tiền/thời gian mua hàng gần nhất của các giao dịch lịch sử của người mua',
		a1992: 'v.v... để phân tích. ',
		a1993: 'Phân loại thông minh là:',
		a1994: 'giá trị cao/lòng trung thành cao giá trị thấp/lòng trung thành thấp và giá trị cao sắp rời bỏ',
		a1995: 'Khách hàng, v.v., thuật toán phân loại này sẽ giúp dịch vụ khách hàng của bạn cải thiện hơn nữa dịch vụ khách hàng và giữ chân những khách hàng có thể bị mất khi theo dõi khách hàng. ',
		a1996: 'Thử ngay bây giờ',
		a1997: 'khoảng thời gian tiêu thụ trung bình',
		a1998: 'Số lượng đơn đặt hàng (số lần tiêu thụ)',
		a1999: 'Khoảng thời gian giữa mức tiêu thụ mới nhất và hiện tại',
		a2000: 'Tỷ lệ phí bảo hiểm tiêu dùng trung bình so với giá trung bình của danh mục',
		a2001: 'Tổng lượng tiêu thụ',
		a2002: 'Số lượng đơn hàng bị từ chối',
		a2003: 'Phân tích Định lượng Người mua',
		a2004: 'Điều kiện lọc dữ liệu',
		a2005: 'Tên người mua',
		a2006: 'Lòng trung thành',
		a2007: 'công suất tiêu thụ',
		a2008: 'độ nhạy giá',
		a2009: 'Mua hàng',
		a2010: 'Tổng số tiền mua hàng',
		a2011: 'Ngày mua hàng gần đây',
		a2012: 'Tên người mua:',
		a2013: 'Khoảng thời gian giữa mức tiêu thụ mới nhất và hiện tại',
		a2014: 'tổng giá',
		a2015: 'tiền tệ',
		a2016: 'nhóm người mua tùy chỉnh',
		a2017: 'tên nhóm',
		a2018: 'mô tả nhóm',
		a2019: 'Mô tả được chia sẻ',
		a2020: 'Ra khỏi mô tả',
		a2021: 'Lấy dữ liệu lịch sử giao dịch',
		a2022: 'đào tạo chỉ mục mô hình lượng tử hóa',
		a2023: 'Phân loại cuối cùng về chân dung người mua',
		a2024: 'Tính toán dữ liệu...',
		a2025: 'Danh sách đen',
		a2026: 'Danh sách đen đám mây',
		a2027: 'Chuyển vào danh sách đen đám mây',
		a2028: 'Xóa khỏi danh sách đen đám mây',
		a2029: 'Sửa tên',
		a2030: 'OK để sửa đổi',
		a2031: 'Thêm nhóm tùy chỉnh',
		a2032: 'Thêm ngay bây giờ',
		a2033: 'Giai đoạn hiện tại',
		a2034: 'tiến độ hiện tại',
		a2035: 'Số lượng dữ liệu được đào tạo',
		a2036: 'Tổng khối lượng dữ liệu thực tế',
		a2037: 'Bạn chưa ủy quyền cho cửa hàng, vui lòng ủy quyền trước',
		a2038: 'Chuyển đến ủy quyền',
		a2039: 'Khối lượng đào tạo người mua ước tính',
		a2040: 'Cửa hàng được ủy quyền',
		a2041: 'Thêm ủy quyền',
		a2042: 'Bắt ​​đầu đào tạo',
		a2043: 'Số điểm hiện có của bạn',
		a2044: 'Đào tạo điểm tiêu thụ ước tính',
		a2045: '*Số tiền tính toán ước tính có thể hơi khác so với số tiền tính toán thực tế (với sai số 1%)',
		a2046: 'Số lượng từ chối đơn hàng',
		a2047: 'Khoảng thời gian mua hàng',
		a2048: 'phần trăm phí bảo hiểm trung bình',
		a2049: 'Đào tạo đã hoàn thành',
		a2050: 'Sẵn sàng vận chuyển',
		a2051: 'Tái hoạt động',
		a2052: 'đã vận chuyển',
		a2053: 'chờ xác nhận đã nhận',
		a2054: 'Đang hủy',
		a2055: 'Hàng trả lại',
		a2056: 'giá trị cao',
		a2057: 'Giá trị trung bình',
		a2058: 'giá trị thấp',
		a2059: 'đã bị mất',
		a2060: 'Rút nước',
		a2061: 'Bình thường',
		a2062: 'lòng trung thành',
		a2063: 'Mức tiêu thụ thấp',
		a2064: 'Mức tiêu thụ cao',
		a2065: 'không nhạy cảm về giá',
		a2066: 'nhạy cảm về giá',
		a2067: 'Công suất tiêu thụ cao',
		a2068: 'Số điểm hiện tại không đủ, vui lòng nạp trước',
		a2069: 'Khối lượng đào tạo của người mua hiện tại là 0 và không thể thực hiện đào tạo',
		a2070: 'Cửa hàng trái phép hiện tại, không thể đào tạo',
		a2071: 'Đã chia sẻ thành công',
		a2072: 'Thêm quy tắc tính phí dịch vụ khách hàng thông minh',
		a2073: 'Sửa đổi quy tắc tính phí dịch vụ khách hàng thông minh',
		a2074: 'Khu vực sạc',
		a2075: 'Vui lòng chọn khu vực sạc',
		a2076: 'Vui lòng chọn loại sạc',
		a2077: 'loại phí',
		a2078: 'Cài đặt quãng thời gian sạc:',
		a2079: 'phạm vi sạc',
		a2080: 'Tính phí',
		a2081: 'lần',
		a2082: 'Dịch vụ khách hàng thông minh và tiêu chuẩn tính phí SMS',
		a2083: 'Tiêu chuẩn tính phí dịch vụ khách hàng thông minh',
		a2084: 'Vui lòng chọn một khu vực',
		a2085: 'bộ lọc',
		a2086: 'trong vòng 10 tỷ',
		a2087: 'Miễn phí mãi mãi',
		a2088: 'Số mười nghìn ký tự',
		a2089: 'số ký tự',
		a2090: 'Tiêu chuẩn báo giá chức năng nhắc nhở SMS',
		a2091: '* Bật chức năng nhắc nhở thông minh sẽ trừ phí theo số lượng SMS tự động gửi và giá SMS được tính theo các quốc gia khác nhau. Sau đây là báo giá SMS quốc tế:',
		a2092: 'phí',
		a2093: 'mảnh',
		a2094: 'Ngõ 1518, Đường Kim Sa Giang, Quận Phổ Đà, Thượng Hải',
		a2095: 'Ngõ 1517, Đường Kim Sa Giang, Quận Phổ Đà, Thượng Hải',
		a2096: 'Số lượng trả lời người mua',
		a2097: 'Số ký tự đã dịch',
		a2098: 'Bạn có chắc chắn xóa không?',
		a2099: 'Quy tắc đã được thêm thành công',
		a2100: 'Phân loại',
		a2101: 'Xem tất cả đơn hàng của người mua',
		a2102: 'Sửa đổi chi phí mua hàng',
		a2103: 'Chi phí vận chuyển',
		a2104: 'nội tệ',
		a2105: 'Gửi sửa đổi',
		a2106: 'Vận chuyển hàng hóa sẽ ảnh hưởng trực tiếp đến việc tính toán giá trị hàng hóa, nên nhập',
		a2107: 'thể tích/mét khối',
		a2108: 'Số lượng mua (số nguyên)',
		a2109: 'Đã tồn tại! ',
		a2110: 'Không phải sản phẩm cùng kho, vui lòng chọn sản phẩm cùng kho! ',
		a2111: 'Thời gian đến dự kiến ​​phải hơn 3 ngày kể từ ngày hiện tại và ngày hiện tại sẽ không được tính!',
		a2112: 'Không có thông tin sản phẩm, không thể tạo đơn đặt hàng',
		a2113: 'Vui lòng điền ngày đến dự kiến',
		a2114: 'Số lượng hàng hóa không được bằng 0',
		a2115: 'Vui lòng chọn sản phẩm trong cùng kho hàng để mua',
		a2116: 'Đơn hàng lưu trữ được tạo thành công:',
		a2117: 'Không thể tạo lệnh lưu trữ, điểm hiện có không đủ, vui lòng nạp lại! ',
		a2118: 'Sửa đổi thành công và trang đặt hàng lưu trữ đang được trả lại! ',
		a2119: 'Tôi biết',
		a2120: 'giờ đến',
		a2121: 'Vui lòng nhập nội tệ',
		a2122: 'Tổng số giao dịch mua hiện tại',
		a2123: 'Ngày đến ước tính',
		a2124: 'Tạo bộ nhớ',
		a2125: 'Thêm sản phẩm mới',
		a2126: 'Xác nhận sửa đổi',
		a2127: 'Chuyến hàng đầu tiên',
		a2128: 'Kênh riêng',
		a2129: 'Hành trình đầu nền tảng',
		a2130: 'Chuẩn sạc',
		a2131: 'Tổng khối lượng ước tính',
		a2132: 'Điểm dành riêng',
		a2133: 'trên mét khối',
		a2134: 'trên kilôgam',
		a2135: 'Trọng lượng thực hoặc trọng lượng thể tích lấy giá trị lớn hơn',
		a2136: 'Chi tiết sản phẩm sắp ra mắt',
		a2137: 'Giá thành',
		a2138: 'quà ',
		a2139: 'Kho con sku',
		a2140: 'Thêm một sản phẩm hoặc gói hàng',
		a2141: 'Loại sản phẩm',
		a2142: 'Mua 1 sản phẩm hoặc gói đơn lẻ trở xuống, sẽ thêm số do trung tâm phân phối đặt',
		a2143: 'Số phụ kiện miễn phí',
		a2144: 'được chọn',
		a2145: 'nhà kho mẹ Sku',
		a2146: 'Mở rộng',
		a2147: 'đóng',
		a2148: 'Tất cả SKU phụ trong kho',
		a2149: 'Số lượng mã hàng phụ của kho hàng',
		a2150: 'Tổng số hàng còn lại trong kho',
		a2151: 'Vui lòng nhập SKU phụ của kho mới',
		a2152: 'Nhập tên sku mới',
		a2153: 'Âm lượng',
		a2154: 'Vui lòng xác nhận để xóa mục đã chọn',
		a2155: ' sản phẩm? ',
		a2156: 'Xóa đơn hàng không thành công! ',
		a2157: 'Bạn có chắc chắn xóa sản phẩm này không?',
		a2158: 'Xóa đơn hàng không thành công',
		a2159: 'đã lưu thành công',
		a2160: 'Tạo thành công một sản phẩm trong kho hàng! ',
		a2161: 'Tạo vật phẩm quà tặng theo cách thủ công',
		a2162: 'Quét thanh sản phẩm',
		a2163: 'Tạo mã QR',
		a2164: 'đi in',
		a2165: 'mã QR',
		a2166: 'Loại cửa hàng',
		a2167: 'Shopee\Lazade\TikTok store\Tiki local store hiện được hỗ trợ, vui lòng xác nhận với dịch vụ khách hàng và nhấp để thanh toán cho nội dung gói sau',
		a2168: 'Cửa hàng độc quyền cá nhân',
		a2169: '5 người chia sẻ cửa hàng doanh nghiệp',
		a2170: 'Cửa hàng doanh nghiệp độc quyền cá nhân',
		a2171: 'đính kèm',
		a2172: 'Bao gồm 1 cửa hàng địa phương, 1000 điểm hoàn tiền trên nền tảng phân phối. ',
		a2173: 'Các báo giá và dịch vụ liên quan như sau',
		a2174: '1. ERP thuần túy là gì?',
		a2175: 'Những người bán địa phương xây dựng kho hàng của riêng họ ở các nước Đông Nam Á không cần sử dụng kho đám mây ở nước ngoài của chúng tôi. Họ cũng chỉ có thể sử dụng hệ thống ERP và WMS. Tạo tài khoản kho riêng (tức là tài khoản kho) trên cửa hàng trang ủy quyền và ngay lập tức sử dụng toàn bộ kho của chúng tôi. Quy trình xử lý kho WMS và ERP hiệu quả, chỉ cần trả phí dịch vụ hệ thống thấp tới 0,05 nhân dân tệ/đơn hàng. ',
		a2176: '2. Tại sao nên sử dụng hệ thống Dianxiaosheng ERP/WMS? ',
		a2177: 'Được thiết kế đặc biệt cho người bán tại địa phương, trợ lý khiếu nại miễn phí vĩnh viễn có thể theo dõi các đơn hàng bị thất lạc trong khâu hậu cần chỉ bằng một cú nhấp chuột, ngăn không cho điểm bán vượt mức của cửa hàng bị trừ, tỷ lệ chính xác hàng tồn kho 99,99%, liên kết hàng tồn kho trực tuyến trên nhiều nền tảng và cửa hàng, đồng thời tự động cập nhật trực tuyến trong vòng 1 phút Hàng tồn kho, để tránh tình trạng bán quá nhiều tại các cửa hàng và hết thời gian giao hàng! ',
		a2178: '3. Nền tảng phân phối điểm ERP? ',
		a2179: 'Nền tảng phân phối giao ngay Đông Nam Á độc quyền, người bán có thể sử dụng nền tảng phân phối Dianxiaosheng để thiết lập hệ thống phân phối ở nước ngoài bất cứ lúc nào, nhiều đại lý trực tuyến hơn, hỗ trợ đặt giá bán lẻ tối thiểu trực tuyến, giám sát giá bán của đại lý theo thời gian thực và kiểm soát giá . ',
		a2180: '4. Đội ngũ dịch vụ chuyên nghiệp',
		a2181: 'Hệ thống ERP của Dianxiaosheng được thiết kế riêng cho người bán hàng địa phương ở Đông Nam Á. Hiện tại, các nhóm dịch vụ địa phương đã được thành lập ở nhiều quốc gia Đông Nam Á như Malaysia, Thái Lan, Indonesia và Philippines! ',
		a2182: '1. Tại sao bạn muốn định cư tại một cửa hàng địa phương? ',
		a2183: 'Người bán vào Đông Nam Á nên biết rằng các quốc gia Đông Nam Á yêu cầu tất cả các nền tảng thương mại điện tử phải bảo vệ tài khoản địa phương của họ. Đồng thời, dưới tình hình dịch bệnh, chỉ giao hàng tại kho đám mây địa phương mới có thể giúp người mua trải nghiệm tốt hơn, dẫn đến tỷ lệ chuyển đổi cao hơn và lợi nhuận. Tỷ lệ cũng cao hơn, và cửa hàng TIKTOK của Thái Lan, Malaysia và Việt Nam mới được khai trương vào tháng 3 năm nay được phát trực tiếp, việc trả lại và trao đổi tiêu dùng bốc đồng chỉ có thể được thực hiện tại các nhà kho địa phương, vì vậy các cửa hàng địa phương đã trở thành điều bắt buộc đối với Đông Nam Bộ người bán châu Á. ',
		a2184: '2. Đối tượng dịch vụ',
		a2185: 'Do không có nhiều tài khoản chất lượng cao an toàn và tuân thủ, đồng thời số lượng có hạn nên chúng tôi hiện chỉ cung cấp cho khách hàng trong kho hoặc sử dụng nền tảng phân phối Xiaosheng của cửa hàng và nghiêm cấm các sản phẩm giả mạo và các thương nhân khác , chỉ dành cho những người bán hàng có mặt lâu dài ở Đông Nam Á Phục vụ. ',
		a2186: '3, thêm thông tin',
		a2187: 'Các quốc gia và nền tảng có thể định cư, chúng tôi sẽ tiếp tục cập nhật thông tin liên quan, vui lòng nhấp để xem chi tiết:',
		a2188: 'Tài liệu được chia sẻ',
		a2189: 'Bảng giá kho hàng ở nước ngoài',
		a2190: '1. Kho đám mây ở nước ngoài là gì? ',
		a2191: 'Kho trên nền tảng đám mây, thường được gọi là kho ở nước ngoài. Đó là, theo hiệu ứng vận hành sản phẩm của cửa hàng, hàng hóa sẽ được nhập kho trước vào đất liền và sau khi đơn đặt hàng được ban hành, hàng hóa sẽ được giao trong vòng 24 giờ. Bạn có thể sử dụng Dianxiaosheng ERP miễn phí và chuẩn bị hàng hóa cho kho đám mây ở nước ngoài của Dianxiaosheng, điều này có thể tạo điều kiện cho bạn kiểm soát hàng hóa kịp thời, tự động theo dõi đơn hàng trả lại từ chối/tranh chấp COD của người mua và tăng lợi nhuận ròng tổng thể cho người bán một cách hiệu quả! ',
		a2192: '2. Kho đám mây chính ở nước ngoài là quốc gia nào? ',
		a2193: 'Hiện tại các dịch vụ kho đám mây ở nước ngoài của Dian Xiaosheng đã bao phủ: Việt Nam/Thái Lan/Malaysia/Philippines/Indonesia/Đài Loan/và các quốc gia Đông Nam Á khác',
		a2194: '3. Tại sao nên sử dụng dịch vụ lưu trữ đám mây ở nước ngoài? ',
		a2195: '①、Giảm chi phí vận chuyển chặng đầu tiên và nén chi phí hậu cần;②、24Giao hàng nhanh trong vòng vài giờ để cải thiện trải nghiệm của người mua;③、Trả lại và trao đổi được xử lý kịp thời để tăng lợi nhuận ròng tổng thể',
		a2196: 'Chi tiết thay đổi điểm',
		a2197: 'Thay đổi tích phân trong khoảng thời gian hiện tại',
		a2198: 'Số dương: tăng điểm, số âm: trừ điểm',
		a2199: 'Loại trừ điểm (tất cả mặc định)',
		a2200: 'loại thanh toán',
		a2201: 'khấu trừ',
		a2202: 'Mục chi phí',
		a2203: 'Trước khi điểm thay đổi',
		a2204: 'Sau khi đổi điểm',
		a2205: 'Tìm',
		a2206: 'Chi tiết điểm dành riêng',
		a2207: 'Bên thanh toán (cửa hàng)',
		a2208: 'Bên doanh thu (kho)',
		a2209: 'tổng điểm',
		a2210: 'Số điểm khả dụng',
		a2211: 'Xem chi tiết điểm',
		a2212: 'Kiểm tra chi tiết điểm đặt trước',
		a2213: 'Sau khi sạc lại, bạn có thể sử dụng ngay các chức năng như lưu trữ đám mây ở nước ngoài, lưu trữ sản phẩm thử nghiệm và lưu trữ cá nhân',
		a2214: 'Hướng dẫn nạp thẻ thành viên: 1 nhân dân tệ 1 điểm, nạp càng nhiều điểm thưởng càng nhiều',
		a2215: 'Không có thông tin khấu trừ cho số đơn đặt hàng này!',
		a2216: 'Lời nhắc thanh toán',
		a2217: 'nhắc nhở gửi hàng',
		a2218: 'đăng ký nhắc nhở',
		a2219: 'Không giới hạn',
		a2220: 'Biển nhắc',
		a2221: 'Bạn có chắc chắn muốn gửi biểu mẫu không? ',
		a2222: 'Nhận hồ sơ lưu trữ! ',
		a2223: 'Không có hồ sơ lưu trữ! ',
		a2224: 'Chi phí vận chuyển',
		a2225: 'được nền tảng xác nhận',
		a2226: 'Được người bán thanh toán...',
		a2227: 'Sửa đổi giá vốn',
		a2228: 'Tạo tuyến tiêu đề mới',
		a2229: 'Vui lòng chọn loại hàng hóa',
		a2230: 'Chọn quốc gia',
		a2231: 'Vui lòng chọn khu vực',
		a2232: 'Singapore',
		a2233: 'Phương pháp khấu trừ',
		a2234: 'Khối lượng hoặc trọng lượng tối đa',
		a2235: 'Vui lòng chọn phương pháp khấu trừ',
		a2236: 'Phí định giá',
		a2237: 'liên hệ chuyển kho',
		a2238: 'chuyển địa chỉ kho hàng',
		a2239: 'Hành trình đứng đầu kênh tự sở hữu',
		a2240: 'Thêm một chuyến đi đầu',
		a2241: 'Lấy giá trị lớn nhất',
		a2242: 'Số điện thoại người nhận hàng',
		a2243: 'Hàng tổng hợp bằng đường biển',
		a2244: 'Hàng không',
		a2245: 'Vận tải đường bộ hàng tổng hợp',
		a2246: 'Hàng nhạy cảm với biển',
		a2247: 'Hàng nhạy cảm với không khí',
		a2248: 'Giao thông đường bộ nhạy cảm',
		a2249: 'Tạo thành công!',
		a2250: 'Xóa thành công! ',
		a2251: 'Chọn nền tảng sau để ủy quyền cửa hàng',
		a2252: 'Nhấp để ủy quyền',
		a2253: 'Hãy trèo qua tường',
		a2254: 'một lần nữa',
		a2255: 'Sắp có ủy quyền! Nếu cửa hàng đã được ủy quyền trên một tài khoản khác, nó sẽ tự động bị hủy liên kết khỏi tài khoản ban đầu và không thể khôi phục được. Vui lòng hoạt động một cách thận trọng. Nếu bạn không chắc chắn, vui lòng liên hệ với dịch vụ khách hàng của nền tảng',
		a2256: 'Ủy quyền ngay bây giờ',
		a2257: 'Trợ lý Yêu cầu bồi thường',
		a2258: 'Giới hạn yêu cầu',
		a2259: 'Khoản bồi thường đến trong tài khoản',
		a2260: 'Đây là một chức năng đặc biệt được hệ thống thiết kế dành cho người bán hàng địa phương ở Đông Nam Á. Nó có thể giúp người bán phát hiện kịp thời các đơn hàng bị COD hoặc thất lạc gói hàng trong chuyển phát nhanh, đồng thời thuận tiện cho người bán xuất các biểu mẫu, có thể là được sử dụng để yêu cầu bồi thường từ nền tảng.',
		a2261: 'Nói chung trong vòng 30 ngày, nếu bạn không đưa ra yêu cầu đối với dịch vụ khách hàng của nền tảng trong hơn 30 ngày, điều đó sẽ được coi là từ bỏ tư cách yêu cầu bồi thường và người bán cuối cùng sẽ mất một khoản tiền bồi thường (ví dụ: lên đến 2.000 baht ở Thái Lan)! Nếu bạn có thể yêu cầu nền tảng kịp thời, nó sẽ ngay lập tức giúp bạn phục hồi các khoản lỗ và tăng lợi nhuận ròng ngay lập tức!',
		a2262: 'Sau khi gửi biểu mẫu yêu cầu dịch vụ khách hàng của nền tảng, hệ thống sẽ tự động đánh giá xem đơn hàng bạn đang yêu cầu đã được bồi thường thành công hay chưa, giúp bạn tiết kiệm thời gian kiểm tra và điều đó sẽ rõ ràng trong nháy mắt. ',
		a2263: 'Nhấp vào thanh menu tương ứng bên dưới "Yêu cầu xác nhận - Đặt hàng", "Yêu cầu - Đặt hàng", "Yêu cầu thành công - Đặt hàng"',
		a2264: 'Yêu cầu đang chờ xác nhận',
		a2265: 'Sau khi người mua từ chối đơn đặt hàng COD từ một cửa hàng địa phương, xác suất mất gói hàng sẽ tăng lên và hệ thống sẽ tự động theo dõi các gói hàng bị mất và giao các gói hàng không thành công. ',
		a2266: 'Người bán cần nhấp vào nút bắt đầu yêu cầu theo cách thủ công để vào trạng thái này, để tránh nhầm lẫn với đơn đặt hàng yêu cầu mới đến được xác nhận! ',
		a2267: 'Sau khi được gửi tới dịch vụ khách hàng của nền tảng, hệ thống sẽ tự động kiểm tra xem đơn hàng đã được xác nhận thành công chưa và số tiền thực nhận được, đồng thời sẽ tự động hiển thị trạng thái này. ',
		a2268: 'Bạn cần chủ động liên hệ với bộ phận chăm sóc khách hàng của SHOPEE để yêu cầu bồi thường. Nói chung, hãy yêu cầu họ yêu cầu các gói hàng bị mất và gửi danh sách Excel. ',
		a2269: 'yêu cầu',
		a2270: 'Đã nhận gói hàng',
		a2271: 'Để xác nhận yêu cầu đặt hàng',
		a2272: 'Đặt hàng dịch vụ khách hàng nền tảng cần được liên hệ',
		a2273: 'Đơn hàng đã được xác nhận thành công',
		a2274: 'Xác nhận yêu cầu đơn hàng: ',
		a2275: 'Xác nhận bỏ đơn hàng: ',
		a2276: 'Yêu cầu bồi thường?',
		a2277: 'Lệnh đã từ bỏ yêu cầu!',
		a2278: 'Khi bạn nhấp vào tất cả các xác nhận quyền sở hữu, tổng số hiện tại sẽ là',
		a2279: 'Tất cả các đơn hàng đã được xác nhận quyền sở hữu, vui lòng xác nhận xem bạn có muốn tiếp tục thao tác này không?',
		a2280: 'Tất cả yêu cầu đều thành công!',
		a2281: 'Đang đợi người bán liên hệ với dịch vụ khách hàng của nền tảng',
		a2282: 'Yêu cầu thành công',
		a2283: 'Nhập tên ghi chú',
		a2284: 'Vui lòng điền vào nhận xét của cửa hàng',
		a2285: 'Xuất chi tiết khấu trừ trạng thái hiện tại',
		a2286: 'Bên doanh thu',
		a2287: 'Người trả tiền',
		a2288: 'Chi tiết tài khoản kho riêng (chỉ có thể tạo tối đa 3 tài khoản kho riêng)',
		a2289: 'Tạo tài khoản kho riêng mới',
		a2290: 'tài khoản kho cá nhân',
		a2291: 'Tạo kho phụ kho phân phối',
		a2292: 'Tạo kho riêng',
		a2293: 'Cài đặt ưu tiên',
		a2294: 'Người bán hiện tại',
		a2295: 'Vui lòng chọn kho hàng',
		a2296: 'Vui lòng chọn loại giảm giá',
		a2297: 'Loại Khuyến mãi',
		a2298: 'Phí dịch vụ',
		a2299: 'Ưu đãi người bán',
		a2300: 'Phạm vi giá trị là 0-1, 0,95=95% giảm giá, 1=không giảm giá, 0=miễn phí',
		a2301: 'Hiện tại không có kho ràng buộc',
		a2302: 'Hiện tại không có tài khoản nào bị ràng buộc với người bán',
		a2303: 'Khấu trừ phí linh tinh của người bán',
		a2304: 'Phạm vi giá trị là 0,7-1, 0,7=30% giảm giá, 1=không giảm giá',
		a2305: 'Lý do xin mở kho phân phối là bắt buộc',
		a2306: 'Vui lòng điền địa chỉ chi tiết',
		a2307: 'Vui lòng điền người nhận hàng',
		a2308: 'Vui lòng điền thông tin liên hệ của người nhận',
		a2309: 'Vui lòng điền tên kho phân phối',
		a2310: 'Đã trừ điểm người bán thành công! ',
		a2311: 'Nhận xét của cửa hàng đã được cập nhật và trang hiện tại đang được làm mới',
		a2312: 'Liên kết thành công',
		a2313: 'Tạo thành công kho riêng! ',
		a2314: 'Đơn đăng ký tạo kho phân phối đã được gửi tới nền tảng, vui lòng đợi nền tảng xử lý! ',
		a2315: 'Vui lòng điền nội dung bầu trời đầy sao đỏ! ',
		a2316: 'Kho con mới',
		a2317: 'Nhà kho liên minh mới',
		a2318: 'Vui lòng nhập số thập phân từ 0 đến 1! Chỉ có thể giữ đến hai chữ số thập phân',
		a2319: 'Giá trị ưu đãi của phí dịch vụ phải nằm trong khoảng từ 0,7 đến 1 và không thể nhỏ hơn 0,7',
		a2320: 'Vui lòng chọn loại kho hàng! ! ! ',
		a2321: 'Khấu trừ người bán',
		a2322: 'phí linh tinh nhà kho',
		a2323: 'Tài khoản đã tồn tại! vui lòng nhập lại! ',
		a2324: 'Chọn quốc gia',
		a2325: 'Vui lòng điền tên kho tư nhân! ',
		a2326: 'Vui lòng điền mật khẩu của tài khoản kho tư nhân! ',
		a2327: 'Bạn đã tạo thành công tài khoản kho riêng:',
		a2328: ', mật khẩu đăng nhập:',
		a2329: 'đã tạo thành công',
		a2330: 'Liên kết cửa hàng thành công! ',
		a2331: '! Bạn có muốn ủy quyền lại và hủy liên kết tài khoản ban đầu không? ',
		a2332: 'Lưu ý: Sau khi hủy liên kết, dữ liệu đơn hàng của tài khoản ban đầu trên cửa hàng này sẽ tự động bị xóa. ',
		a2333: 'Bạn có muốn tiếp tục ủy quyền không? ',
		a2334: 'Xác nhận ủy quyền',
		a2335: 'Ztqu',
		a2336: 'Đã bật',
		a2337: 'Đã tắt',
		a2338: 'Vui lòng điền thông tin kho hàng',
		a2339: 'Tạo kho liên minh thành công! ',
		a2340: 'Sớm hủy liên kết! Sau khi hủy liên kết, mối quan hệ liên kết và ràng buộc giữa cửa hàng và sản phẩm trong kho sẽ tự động bị xóa và không thể lấy và không thể khôi phục đơn đặt hàng trong cửa hàng! Vui lòng hoạt động một cách thận trọng, nếu bạn không chắc chắn, vui lòng liên hệ với dịch vụ khách hàng của nền tảng',
		a2341: 'Bỏ ràng buộc ngay lập tức',
		a2342: 'Địa chỉ người bán',
		a2343: 'Nhập tên nhận xét của người bán',
		a2344: 'Thêm ủy quyền Shopify',
		a2345: 'Tên cửa hàng',
		a2346: 'URL cửa hàng',
		a2347: 'Chi tiết tài khoản kho riêng (chỉ có thể tạo tối đa 5 tài khoản kho riêng)',
		a2348: 'Kho con phân phối mới',
		a2349: 'Tên kho phân phối',
		a2350: 'Tên kho phụ',
		a2351: 'Vui lòng nhập địa chỉ chi tiết',
		a2352: 'Vui lòng nhập mô tả ứng tuyển kho phân phối! ',
		a2353: 'Mô tả ứng dụng',
		a2354: 'Để tạo tài khoản kho riêng, vui lòng quét mã QR trên WeChat để liên hệ với nhân viên dịch vụ khách hàng',
		a2355: 'Điền tên kho phụ',
		a2356: 'Nhập mật khẩu kho riêng',
		a2357: 'quy tắc tính phí kho hàng',
		a2358: 'Bật',
		a2359: 'đã tắt',
		a2360: 'Chưa có loại',
		a2361: 'Tên cửa hàng là bắt buộc',
		a2362: 'Cần có URL cửa hàng',
		a2363: 'Đăng ký mở tài khoản kho tư nhân',
		a2364: 'Lưu ý: Khi người dùng tạo tài khoản kho riêng, hệ thống sẽ tạo ngẫu nhiên tài khoản kho riêng, đồng thời hệ thống sẽ tự động tạo tiểu kho riêng cho tài khoản, vui lòng điền tên kho phụ! ',
		a2365: 'Phí mỗi đơn đặt hàng',
		a2366: 'Số lượng đơn hàng tối đa mỗi tháng',
		a2367: 'Phí xử lý hàng trả lại',
		a2368: 'Số SKU khấu trừ mặc định của một gói',
		a2369: 'Số lượng sku vượt quá phí mặc định',
		a2370: 'Số lượng gói khấu trừ mặc định có cùng mã hàng',
		a2371: 'SKU quá tải',
		a2372: 'phí đặt hàng',
		a2373: 'phí vận hành',
		a2374: 'Quà tặng mới cho người mua',
		a2375: 'Tạo kho riêng và kho phân phối',
		a2376: 'Người bán địa phương xây dựng kho hàng của riêng họ ở các quốc gia Đông Nam Á chỉ có thể sử dụng hệ thống ERP, tạo tài khoản kho hàng riêng mới trên trang ủy quyền cửa hàng và ngay lập tức sử dụng toàn bộ quy trình ERP hiệu quả của chúng tôi. ',
		a2377: 'Ủy quyền trang web chính thức',
		a2378: 'Lưu trữ cách ly IP cục bộ',
		a2379: 'Trạng thái ủy quyền',
		a2380: 'Hiện tại không có cửa hàng ủy quyền',
		a2381: 'Chi tiết địa chỉ',
		a2382: 'quy tắc tính phí',
		a2383: 'Khi bị tắt, kho hiện tại sẽ bị ẩn khi người dùng kích hoạt hành vi chọn kho',
		a2384: 'Xem quy tắc tính phí',
		a2385: 'Vui lòng điền nội dung có dấu sao đỏ! ',
		a2386: 'Tạo thành công vị trí phụ! ',
		a2387: 'Nhập biểu mẫu excel',
		a2388: 'Kéo tệp vào đây, hoặc',
		a2389: 'Bạn chỉ có thể nhập trang tính excel có hậu tố .xlsx/.xls',
		a2390: 'Tệp đang được xác minh, vui lòng đợi',
		a2391: 'Xác nhận nhập',
		a2392: 'Sản phẩm đã có trong kho',
		a2393: 'Sản phẩm ghim trên mạng',
		a2394: 'Đồng bộ sản phẩm trực tuyến',
		a2395: 'sản phẩm ghim',
		a2396: 'Bạn có thể tìm kiếm tên, sku, Id sản phẩm',
		a2397: 'Liên kết sản phẩm',
		a2398: 'Xác minh dữ liệu thành công, toàn bộ',
		a2399: 'Sản phẩm của sku, hãy tiếp tục hoạt động! ',
		a2400: 'Đang dỡ khỏi kệ',
		a2401: 'Vui lòng nhập biểu mẫu excel',
		a2402: 'Đang đồng bộ hóa cửa hàng:',
		a2403: 'của sản phẩm trực tuyến',
		a2404: 'Quá trình đồng bộ sản phẩm trực tuyến dự kiến ​​mất khoảng 15-30 giây, sau khi hệ thống thông báo đồng bộ thành công, đề nghị tự làm mới lại trang!',
		a2405: 'Đồng bộ hóa hoàn tất, đề nghị làm mới trang',
		a2406: 'Lỗi khi tải dữ liệu, vui lòng thử lại sau! ',
		a2407: 'Vui lòng chọn sản phẩm! ',
		a2408: 'Chỉ có thể chọn',
		a2409: 'tập tin, hiện được chọn',
		a2410: 'Định dạng tệp đính kèm bị sai, vui lòng xóa tệp đính kèm và tải lên lại! ',
		a2411: 'Vui lòng tải tệp đính kèm lên! ',
		a2412: 'Đã vượt quá giới hạn số lượng tệp được tải lên tối đa! ',
		a2413: 'Hồ sơ mua hàng lịch sử',
		a2414: 'Phí bổ sung',
		a2415: 'Chi phí hậu cần',
		a2416: 'Mua thời gian',
		a2417: 'Chi tiết đại lý',
		a2418: 'biệt danh',
		a2419: 'Mã cus của đại lý',
		a2420: 'Tạo SKU theo cách thủ công',
		a2421: 'Trọng lượng (tùy chọn)',
		a2422: 'Âm lượng (tùy chọn)',
		a2423: 'Vui lòng nhập SKU phụ của kho hàng',
		a2424: 'Vui lòng nhập tên SKU phụ của kho hàng',
		a2425: 'Vui lòng nhập trọng lượng sản phẩm (đơn vị/KG',
		a2426: 'Dài（cm）',
		a2427: 'Rộng（cm）',
		a2428: 'Cao（cm）',
		a2429: 'Ràng buộc các sản phẩm trực tuyến',
		a2430: 'Thêm sản phẩm ghim',
		a2431: 'Giá sau chiết khấu',
		a2432: 'Sản phẩm lưu kho hiện được chọn để ghim',
		a2433: 'Sau đây là các sản phẩm trực tuyến sẽ được liên kết ghim',
		a2434: 'Lập tức ghim',
		a2435: 'Xóa dấu nhắc không thành công',
		a2436: 'Không thể xóa sản phẩm! ',
		a2437: 'Tình hình ghim',
		a2438: 'SKU ghim thành công sản phẩm kho',
		a2439: 'SKU ghim thất bại',
		a2440: 'Sản phẩm đã được ghim',
		a2441: 'Đóng, quay lại sản phẩm kho',
		a2442: 'Nhập sản phẩm trực tuyến và thư từ ràng buộc bằng một cú nhấp chuột',
		a2443: 'Quan trọng!! Hãy đặc biệt chú ý!!!!',
		a2444: 'Chức năng này chỉ áp dụng cho các cửa hàng có SKU đã lên kế hoạch. Mỗi khi nó được sử dụng, trước tiên, nó sẽ tự động được liên kết với cùng một SKU gốc trực tuyến của sản phẩm trong kho đã được tạo,',
		a2445: 'Thứ hai, SKU gốc của sản phẩm chưa được tạo trong kho sẽ tự động được tạo và hợp nhất và liên kết với cùng một SKU gốc. Do đó, nếu SKU gốc của sản phẩm trực tuyến không được điền vào, quá trình tạo sẽ thất bại! ',
		a2446: 'Chức năng này không phù hợp với các cửa hàng nơi SKU ban đầu không được lên kế hoạch trực tuyến, nếu không, nó có thể gây nhầm lẫn khi liên kết SKU kho được tạo thành công,',
		a2447: 'Nếu bạn không chắc chắn về hoạt động, bạn có thể tham khảo ý kiến ​​​​của nhân viên chăm sóc khách hàng của Xiaosheng, xin cảm ơn! ! (Quan trọng!! Hãy đặc biệt chú ý!!!!)',
		a2448: 'Vui lòng chọn cửa hàng để nhập',
		a2449: 'Đang tải dữ liệu, vui lòng đợi...',
		a2450: 'Cấu hình một sản phẩm của gói này',
		a2451: 'Thêm hàng vào kho',
		a2452: 'Số lượng gói hàng',
		a2453: 'Danh sách phụ kiện',
		a2454: 'Mã kho có thể tìm kiếm, mã hàng phụ của kho',
		a2455: 'Lưu tùy chọn cấu hình hiện tại',
		a2456: 'Số lượng gói hàng',
		a2457: 'Hình ảnh không được để trống! ',
		a2458: 'Không được để trống SKU phụ của kho hàng! ',
		a2459: 'skuName không được để trống! ',
		a2460: 'Sản phẩm kho',
		a2461: 'Đã tồn tại, vui lòng không lặp lại cấu hình! ',
		a2462: 'hình mờ mẫu',
		a2463: 'Ảnh thuộc tính thay thế',
		a2464: 'Đưa sản phẩm kho lên nền tảng phân phối',
		a2465: 'Điền thông tin sản phẩm phân phối',
		a2466: 'Phân phối trên kệ',
		a2467: 'Cập nhật lên nền tảng phân phối',
		a2468: 'Danh mục hàng hóa',
		a2469: 'Hình ảnh chính sản phẩm',
		a2470: 'Thêm hình ảnh sản phẩm',
		a2471: 'Hình ảnh được sắp xếp ngẫu nhiên',
		a2472: 'Thêm ảnh',
		a2473: 'Thông tin qui cách',
		a2474: 'Phân phối trên kệ với giá cung cấp cố định',
		a2475: 'Phân phối trên kệ với Tỷ suất lợi nhuận gộp cố định',
		a2476: 'Phân phối trên kệ với giá thành sản phẩm',
		a2477: 'Thiết lập công thức tính toán mặc định',
		a2478: 'công thức mặc định',
		a2479: 'giá hàng tại địa phương',
		a2480: 'Giá vận chuyển 1 kiện hàng từ địa phương (đã bao gồm phí Logistic qua biên giới)',
		a2481: 'Giữa 5-99',
		a2482: 'Nhận thực tế (sàn khấu trừ 5%)',
		a2483: 'Thanh toán sau hoa hồng nền tảng',
		a2484: 'Hàng tồn kho ở nước ngoài',
		a2485: 'Giá bán buôn mua hàng từ Trung Quốc (không bao gồm chi phí vận chuyển)',
		a2486: 'Tất cả các nguồn hàng hóa trong hệ thống doanh nghiệp trên sàn đều hỗ trợ mô hình thời hạn thanh toán 3-7, tức người bán chỉ cần đặt cọc 30%, nhà cung cấp sẽ mua hàng gửi đến kho tập trung của sàn,đồng thời vận chuyển đến kho hàng ở nước ngoài của sàn, người bán có thể thanh toán 70% số tiền còn lại sau 1 tháng.',
		a2487: 'Có hỗ trợ thời hạn mô hình 3-7 hay không',
		a2488: 'Giá sau chiết khấu bán lẻ trực tuyến thấp nhất',
		a2489: 'Thể tích trọng lượng',
		a2490: 'Sau khi mở giá cung cấp cố định, giá thành sản phẩm của đơn hàng sau giao dịch sẽ tính theo giá cung cấp, sẽ  được sàn giao dịch chiết tính rồi gửi cho nhà cung cấp, đề nghị lòng điền giá cung cấp của sản phẩm.',
		a2491: 'Sau khi khởi động Tỷ suất lợi nhuận gộp cố định, hệ thống sẽ tự động tính toán giá cung cấp phân phối của từng sku dựa trên giá RMB chiết khấu thấp nhất của sản phẩm trực tuyến được ghim, đề nghị điền Tỷ suất lợi nhuận gộp cố định (tức dành cho mỗi đại lý một không gian Tỷ suất lợi nhuận gộp)',
		a2492: 'Khởi động niêm yết giá vốn sản phẩm, nhà cung cấp tự tính Tỷ suất lợi nhuận gộp, rồi điền giá cung ứng.',
		a2493: 'Sau khi đóng biên lợi nhuận gộp cố định, hệ thống sẽ không còn tự động tính giá cung cấp phân phối của từng sku dựa trên các sản phẩm trực tuyến bị ràng buộc, vui lòng điền giá cung cấp của sản phẩm',
		a2494: 'Có thể tải lên tối đa 9 ảnh chính',
		a2495: 'Giá thành sản phẩm:',
		a2496: 'Tỷ suất lợi nhuận gộp thiết lập không được thấp hơn 5%',
		a2497: 'Số ký tự trong tiêu đề sản phẩm phải từ 2-120! ',
		a2498: 'Độ dài ký tự của tất cả mã hàng không được lớn hơn 20! ',
		a2500: 'Giá cung cấp không được bằng 0',
		a2501: 'Đã cập nhật lên nền tảng phân phối',
		a2502: 'Liên kết mẫu thành công! ',
		a2503: 'Sản phẩm đã được đưa lên nền tảng phân phối',
		a2504: 'sku',
		a2505: 'Không vào được',
		a2506: 'Mã hàng mẹ (bắt buộc)',
		a2507: 'Có phải hàng nhạy cảm',
		a2508: 'sản phẩm trực tuyến',
		a2509: 'Excel nhập kho hàng',
		a2510: 'Sản phẩm xuất khẩu',
		a2511: 'Nhập kho sản phẩm',
		a2512: 'Đã nhập kho',
		a2513: 'Hủy nhập',
		a2514: 'Nhập kho',
		a2515: 'Sku gốc là mục bắt buộc, vẫn còn sản phẩm chưa điền sku gốc, vui lòng điền thông tin sku gốc tương ứng',
		a2516: 'Chọn một sản phẩm/gói được định cấu hình cho quà tặng',
		a2517: 'Nhập mã vạch sản phẩm',
		a2518: 'Vui lòng nhập thông tin mã vạch sản phẩm',
		a2519: 'Chi tiết sản phẩm tồn kho',
		a2520: 'Chọn tất cả trang hiện tại',
		a2521: 'Thao tác hàng loạt',
		a2522: 'Chuyển vào thư viện gói theo đợt',
		a2523: 'Xóa hàng loạt sản phẩm đã chọn',
		a2524: 'Thêm mã hàng phụ',
		a2525: 'Nhập trực tuyến',
		a2526: 'được tạo thủ công',
		a2527: 'Đã tải lên nền tảng phân phối',
		a2528: 'Cập nhật thông tin sản phẩm của nền tảng phân phối',
		a2529: 'Tải lên Cửa hàng TikTok',
		a2530: 'Thông tin sku mẹ của kho hàng',
		a2531: 'Ký tự trong phạm vi 120',
		a2532: 'không ràng buộc',
		a2533: 'nguồn hàng',
		a2534: 'Sửa nguồn hàng',
		a2535: 'Xem lịch sử mua hàng',
		a2536: 'Tổng số lượng được vận chuyển đã được phê duyệt đến kho hàng này',
		a2537: 'Giá thành sản phẩm',
		a2538: 'Được chấp thuận vận chuyển',
		a2539: 'Tất cả số lượng sẽ được vận chuyển',
		a2540: 'khóa hàng tồn kho',
		a2541: 'Tự động có nghĩa là tự động lấy từ Shopee kho hàng bị khóa trong các hoạt động như Flash và thủ công có nghĩa là người bán cần khóa kho hàng theo cài đặt thực tế. Khóa mặc định là 0, tức là không khóa. Và người bán không thể sửa đổi số lượng hàng tồn kho bị khóa của gói được định cấu hình và giá trị bị khóa của gói được định cấu hình cần được sửa đổi trong thư viện gói kết hợp. ',
		a2542: 'Bao gồm tất cả số lượng được phê duyệt và không được phê duyệt sẽ được vận chuyển',
		a2543: 'Tự động',
		a2544: 'Thủ công',
		a2545: 'Khách hàng người bán',
		a2546: 'Tự động cập nhật hàng luu kho trực tuyến',
		a2547: 'Khi bật cập nhật tự động hàng lưu kho, sẽ lưu kho Shopee tất cả các sản phẩm được ghim với sản phẩm của kho này.',
		a2548: 'Có đặt đóng gói độc lập hay không',
		a2549: 'khoảng không quảng cáo độc lập',
		a2550: 'mã vạch',
		a2551: 'Nhập mã vạch',
		a2552: 'Giá cung ứng phân phối',
		a2553: 'bắt buộc',
		a2554: 'Chuyển vào gói',
		a2555: 'Khớp thành một sản phẩm/gói hàng',
		a2556: 'Chuyển sang một sản phẩm duy nhất',
		a2557: 'gói cấu hình',
		a2558: 'Xem nhật ký hàng lưu kho',
		a2559: 'Xem đại lý',
		a2560: 'Gói đã định cấu hình',
		a2561: 'Quà tặng đã cấu hình',
		a2562: 'Có nên tiếp tục đặt sản phẩm này là sản phẩm nhạy cảm hay không',
		a2563: 'Có nên tiếp tục đặt sản phẩm này là hàng hóa thông thường hay không',
		a2564: 'Điền giá cung cấp phân phối với số lượng lớn (￥)',
		a2565: 'Điền tỷ suất lợi nhuận gộp (thập phân từ 0 đến 1):',
		a2566: 'Đã thêm SKU phụ thành công! ',
		a2567: 'Bạn chỉ có thể nhập số lớn hơn 0! ',
		a2568: 'Biên lợi nhuận gộp của sản phẩm đưa lên nền tảng phân phối không được thấp hơn 5%',
		a2569: 'Giá cung cấp của sản phẩm được phân phối là bắt buộc, vui lòng điền vào! ',
		a2570: 'Sản phẩm này không được phân phối, vui lòng liên hệ bộ phận chăm sóc khách hàng! ',
		a2571: 'Thay thế hình ảnh thành công!',
		a2572: 'Sku đã bị xóa khỏi nền tảng phân phối:',
		a2573: ', đã được đưa lên kệ trên nền tảng phân phối',
		a2574: 'Gói này đã được mở dưới dạng một gói được đóng gói riêng lẻ',
		a2575: 'Gói này đã được đóng dưới dạng gói được đóng gói riêng lẻ',
		a2576: 'Mã kho hàng của kiện hàng:',
		a2577: 'Số ký tự tối đa không được vượt quá 35',
		a2578: 'Vui lòng nhập số',
		a2579: 'Số lượng ghi chú tối đa không được vượt quá 32',
		a2580: 'Sửa đổi thuộc tính thành công',
		a2581: 'Bạn có chắc chắn muốn chuyển sang thư viện gói không? ',
		a2582: 'Bạn có chắc chắn muốn chuyển sang thư viện sản phẩm duy nhất không? ',
		a2583: 'Nó đã được chuyển vào thư viện gói',
		a2584: 'Nó đã được chuyển vào thư viện sản phẩm duy nhất',
		a2585: 'Một sản phẩm sẽ được thêm vào thư viện kết hợp, vui lòng xác nhận? ',
		a2586: 'Đã di chuyển thành công vào thư viện gói! ',
		a2587: 'Hiện đang xóa mục đã chọn',
		a2588: ' Sản phẩm SKU, vui lòng xác nhận có tiếp tục thao tác này không? ',
		a2589: 'Đã sửa đổi giá vốn thành công',
		a2590: 'Nhập ký tự trong phạm vi 120! ',
		a2591: 'Cập nhật dữ liệu thành công! ',
		a2592: 'Ảnh đại diện đã tải lên chỉ có thể ở định dạng JPG!',
		a2593: 'Vui lòng nhập thông tin mã vạch! ',
		a2594: 'Mã vạch sản phẩm đã được nhập thành công! ',
		a2595: 'Bật tính năng tự động sẽ tự động nhận được từ Shopee kho hàng bị khóa khi tham gia các hoạt động như Flash',
		a2596: 'Tự động khóa khoảng không quảng cáo được bật! ',
		a2597: 'Khi được đặt thành thủ công, số lượng hàng tồn kho cần được khóa theo cài đặt thực tế của người bán, khóa mặc định là 0, tức là không khóa. ',
		a2598: 'Tự động khóa hàng tồn kho đã bị tắt! ! ',
		a2599: 'Khi bật cập nhật tự động hàng lưu kho, sẽ lưu kho tất cả các sản phẩm được ghim với sản phẩm của kho này, sẽ lưu kho trên sàn tất cả các sản phẩm được ghim với sản phẩm kho này. Tự động đồng bộ là số lượng lưu kho thực tế còn lại của sản phẩm trong kho, đề nghị xác nhận có bật hay không?',
		a2600: 'Đã bật tự động cập nhật hàng lưu kho trực tuyến.',
		a2601: 'Khi tắt tính năng tự động cập nhật hàng lưu kho, hàng lưu kho của sản phẩm trong kho sẽ không ảnh hưởng đến hàng lưu kho trên sàn của tất cả các sản phẩm đã ghim. Đề nghị xác nhận có tiếp tục tắt hay không?',
		a2602: 'Đã tắt tự động cập nhật hàng lưu kho trực tuyến.',
		a2603: 'Xóa không thành công! ',
		a2604: 'Chọn nguồn dữ liệu trực tuyến',
		a2605: 'Id hàng hóa:',
		a2606: 'Chi tiết phân phối sản phẩm',
		a2607: 'Chọn nguồn dữ liệu từ liên kết trực tuyến được liên kết',
		a2608: 'Điền giá cung cấp',
		a2609: 'Tỷ suất lợi nhuận gộp dự tính phải lớn hơn 80%, giá cung cấp thấp hơn 50% so với giá hiện tại, mới được thiết lập làm hàng dọn kho thanh lý.',
		a2610: 'Gói kết hợp',
		a2611: 'Chuyển hàng loạt thành một sản phẩm',
		a2612: 'Tạo gói kho hàng',
		a2613: 'Xuất hàng tồn kho',
		a2614: 'Tổng số hàng tồn kho còn lại',
		a2615: 'Sku',
		a2616: '20 sản phẩm kho đã được nhập thành công lần này, với tổng số 521 tiểu skus, 58554 tiểu skus đã được liên kết thành công và 5201 tiểu skus không thể liên kết',
		a2617: 'Đã di chuyển thành công vào thư viện sản phẩm duy nhất! ',
		a2618: 'Vui lòng chọn kho mục tiêu nơi sản phẩm sẽ được sao chép',
		a2619: 'Vui lòng chọn kho mục tiêu',
		a2620: 'quà tặng hàng tiêu dùng',
		a2621: 'Sản phẩm sao chép toàn kho',
		a2622: 'Tạo vật phẩm quà tặng',
		a2623: 'Ca mổ thành công! ',
		a2624: 'Sản phẩm duy nhất trong kho',
		a2625: 'Tạo mục kho hàng',
		a2626: 'Nhập và liên kết trực tuyến với một cú nhấp chuột',
		a2627: 'nhắc nhở hết hàng',
		a2628: 'Đã nhập thành công lần này',
		a2629: 'Sku, liên kết thành công',
		a2630: 'sku phụ, liên kết không thành công',
		a2631: 'SKU phụ, sau khi đóng cửa sổ bật lên, vui lòng làm mới để nhận dữ liệu sản phẩm trong kho mới nhất! ',
		a2632: 'Sản phẩm sẽ được chuyển vào thư viện kết hợp, vui lòng xác nhận? ',
		a2633: 'Thông báo nhiệm vụ',
		a2634: 'tiến độ nhiệm vụ',
		a2635: 'Chọn tiến trình tác vụ:',
		a2636: 'Tạo tác vụ mới',
		a2637: 'tên nhiệm vụ',
		a2638: 'Mô tả nhiệm vụ',
		a2639: 'Chi tiết phí',
		a2640: 'Mô tả người bán',
		a2641: 'Kho chưa nhận được đơn hàng',
		a2642: 'Kho đã nhận được đơn hàng',
		a2643: 'Nhiệm vụ đã hoàn thành',
		a2644: 'Số nhiệm vụ',
		a2645: 'Tiến độ nhiệm vụ hiện tại',
		a2646: 'Vui lòng nhập nội dung tin nhắn',
		a2647: 'Để lại tin nhắn',
		a2648: 'Chọn tiến độ nhiệm vụ',
		a2649: 'Hoàn thành tất cả các khoản phí',
		a2650: 'Phí hoàn thành một phần',
		a2651: 'Dịch vụ giá trị gia tăng là các dịch vụ đặc biệt của kho hàng địa phương do nền tảng quảng bá, chẳng hạn như tìm điểm neo tại địa phương để phát sóng trực tiếp, liên lạc qua điện thoại với dịch vụ khách hàng bằng ngôn ngữ nhỏ và sửa đổi các bài đánh giá tiêu cực, v.v.',
		a2652: 'Không phải tất cả các kho hàng ở nước ngoài đều đã mở tất cả các dịch vụ giá trị gia tăng. Nếu có nhu cầu, vui lòng tham khảo chi tiết với nhân viên dịch vụ khách hàng của kho hàng. Các dịch vụ giá trị gia tăng hiện đang trong giai đoạn thử nghiệm nội bộ,',
		a2653: 'Tất cả bán bằng hữu cần hợp tác cùng nhau tiến bộ, mong bán và bằng hữu giúp đỡ',
		a2654: 'chọn vùng',
		a2655: 'Chi tiết phí',
		a2656: 'Hoàn thành tất cả chi phí nhiệm vụ',
		a2657: 'Đóng góp chưa được hoàn thành',
		a2658: 'Phí',
		a2659: 'Tất cả nhiệm vụ đã hoàn thành',
		a2660: 'Xác nhận hoàn tất',
		a2661: 'Quay lại',
		a2662: 'Xác nhận phí bổ sung',
		a2663: 'Xóa tác vụ',
		a2664: 'Đơn đặt hàng trong kho',
		a2665: 'Từ chối kho hàng',
		a2666: 'Xác nhận tiến độ',
		a2667: 'Kho hàng đã được xác nhận',
		a2668: 'Tất cả đã xong',
		a2669: 'hoàn thành một phần',
		a2670: 'Mô tả nhiệm vụ của người bán',
		a2671: 'tin nhắn hệ thống',
		a2672: 'Chưa hoàn thành',
		a2673: 'Không có loại tác vụ',
		a2674: 'Vui lòng nhập số! ',
		a2675: 'Tạo thành công! ',
		a2676: 'Trạng thái đơn hàng đã được trả lại! ',
		a2677: 'Sau khi hoàn thành xác nhận này, nó sẽ được trừ vào tài khoản tín dụng của người bán',
		a2678: 'điểm và',
		a2679: 'Tổng cộng điểm',
		a2680: 'điểm, bạn có muốn tiếp tục hoạt động không? ',
		a2681: 'Đã giải quyết xong! ',
		a2682: 'Người bán vẫn chưa xác nhận các khoản phí bổ sung, bạn có muốn tiếp tục không? ',
		a2683: 'Xác nhận này, người bán sẽ đồng ý với đề xuất của nhà kho',
		a2684: 'Bạn có muốn tiếp tục thực hiện thêm chi phí điểm không? ',
		a2685: 'Xác nhận thành công! ',
		a2686: 'Tiếp tục nhận lệnh nhiệm vụ này? ',
		a2687: 'Đã nhận được đơn đặt hàng thành công',
		a2688: 'Các khoản phí bổ sung đã được gửi cho người bán, đang chờ xác nhận từ người bán! ',
		a2689: 'Không được để trống tin nhắn! ',
		a2690: 'Mở rộng tất cả',
		a2691: 'tất cả gấp lại',
		a2692: 'Sửa ảnh',
		a2693: 'Tên người bán',
		a2694: 'Số lượng hàng tồn kho độc lập',
		a2695: 'gói đã định cấu hình',
		a2696: 'Lưu',
		a2697: 'Chỉnh sửa',
		a2698: 'hộp nháp',
		a2699: 'Vùng quét mã vạch sản phẩm/mã kho',
		a2700: 'tổng',
		a2701: 'Mã hàng mẹ',
		a2702: 'Tổng số kho gốc',
		a2703: 'Tổng số',
		a2704: 'Lưu bản ghi hàng tồn kho hiện tại',
		a2705: 'Đã kiểm kê xong',
		a2706: 'CUSCODE (mã vạch)',
		a2707: 'Ban đầu được lưu trữ trong kho',
		a2708: 'hàng tồn kho thực tế',
		a2709: 'Lý do trả lại để xem xét là bắt buộc! ',
		a2710: 'Không có dữ liệu đặt hàng! ',
		a2711: 'Tiếp tục',
		a2712: 'Bản ghi hàng tồn kho',
		a2713: 'hàng tồn kho',
		a2714: 'Tổng số hàng tồn kho này:',
		a2715: 'Bạn có muốn tiếp tục hoàn thành thao tác kiểm kê không? Sau khi xác nhận, hàng tồn kho sẽ được sửa đổi cho phù hợp, vui lòng kiểm tra nhật ký hàng tồn kho để biết chi tiết! ',
		a2716: 'Có, đưa vào kho ngay bây giờ',
		a2717: 'Lưu trữ thành công! ',
		a2718: 'Kho hàng hiện tại không có sản phẩm này! ',
		a2719: 'In mã vạch sản phẩm',
		a2720: 'Mã vạch in hàng loạt',
		a2721: 'Bội số chi phí vật liệu',
		a2722: 'kho ảo',
		a2723: 'Kho trên nền tảng đám mây',
		a2724: 'Nhà kho tự xây',
		a2725: 'Đơn chuyển khoản đã được gửi cho người bán, đang chờ xác nhận của người bán! ',
		a2726: 'Vui lòng chọn người bán! ',
		a2727: 'Vui lòng chọn kho hàng để chuyển! ',
		a2728: 'Chuyển khoản thành công! ',
		a2729: 'Bội số không được nhỏ hơn 1',
		a2730: 'Sửa đổi thành công!',
		a2731: 'Vui lòng điền lý do sửa đổi hàng tồn kho! ',
		a2732: 'Các mục này đã được liên kết thành công',
		a2733: 'Quản lý hàng tồn kho',
		a2734: 'thư viện kết hợp',
		a2735: 'thư viện quà tặng',
		a2736: 'Lọc người bán',
		a2737: 'Sản phẩm trong kho được phân tích bằng thuật toán thông minh dựa trên dữ liệu đa chiều như tần suất xuất ra và quỹ chiếm dụng: chúng được chia thành quan trọng (loại A), quan trọng chung (loại B) và không quan trọng (loại C)',
		a2738: 'ABC phân loại thông minh',
		a2739: 'Kích thước',
		a2740: 'Tích bị ràng buộc phải lớn hơn 0',
		a2741: 'Đơn đặt hàng đã được tạo thành công và số đơn đặt hàng là:',
		a2742: 'Gửi xác nhận kho hàng mới',
		a2743: 'Sau khi lưu bản ghi hiện tại, bản ghi kho trước đó sẽ bị ghi đè, vui lòng xác nhận có tiếp tục thao tác lưu kho hiện tại hay không',
		a2744: 'Sau khi thực hiện thao tác này, dữ liệu điều chuyển sẽ được gửi đến kho mới để xác nhận và dữ liệu của lệnh điều chuyển này sẽ không còn được sửa đổi nữa. Vui lòng xác nhận có tiếp tục không? ',
		a2745: 'Xác nhận thành công, kho hàng mới sẽ được kiểm tra và đưa vào kho! ',
		a2746: 'Việc chạy hệ điều hành này sẽ thực sự đưa vào kho theo số lượng sản phẩm tồn kho hiện tại, vui lòng xác nhận xem tất cả số lượng tồn kho đã được hoàn thành chưa? ',
		a2747: 'Xác nhận thành công và quá trình lưu trữ đã hoàn tất! ',
		a2748: 'Số lượng tồn kho cũ này',
		a2749: 'và hàng tồn kho thực tế của nhà kho mới',
		a2750: 'Hàng tồn kho cũ',
		a2751: 'Hàng tồn kho mới',
		a2752: 'Chọn kho chuyển',
		a2753: 'Chọn kho cần chuyển',
		a2754: 'Thông báo từ người bán (tùy chọn)',
		a2755: 'Chuyển số biên nhận kho hàng',
		a2756: 'Khởi tạo kho hàng',
		a2757: 'Lời nhắc tin nhắn',
		a2758: 'Chuyển Kho',
		a2759: 'Xác nhận gửi',
		a2760: 'Chuyển danh sách chuyển khoản',
		a2761: 'Chuyển khoản đã hoàn tất',
		a2762: 'Chuyển vị trí',
		a2763: 'Bắt ​​đầu ứng dụng',
		a2764: 'Xác nhận người bán',
		a2765: 'Hàng tồn kho cũ',
		a2766: 'Hàng tồn kho mới',
		a2767: 'nhận kho hàng',
		a2768: 'Kho chuyển nhượng không được giống kho gốc! ',
		a2769: 'Kho hàng, thuộc tính người bán không được để trống! ',
		a2770: 'Tạo lệnh chuyển tiền',
		a2771: 'Chọn người bán',
		a2772: 'Thông báo kho (tùy chọn)',
		a2773: 'Tạo',
		a2774: 'Kiểm kho hàng cũ',
		a2775: 'Kho hiện tại không có dữ liệu phân loại thông minh',
		a2776: 'Kho hiện tại không có ABC và chỉ có thể phân loại dữ liệu',
		a2777: 'Loại A: Số lượng 5%~10%; Loại tần suất vào và ra chiếm: 60%~70%',
		a2778: 'Loại B: Số lượng 10~20%; Loại tần suất vào và ra chiếm: 20%~30%',
		a2779: 'Loại C: 70%~80% số lượng; tỷ lệ các loại tần suất vào và ra: 5%~10%',
		a2780: 'Khuyến cáo bỏ kho :',
		a2781: 'Loại A: Vị trí lấy hàng thuận tiện (chẳng hạn như cửa, dãy kệ đầu tiên)',
		a2782: 'Loại B: vị trí phổ biến (chẳng hạn như vị trí ở giữa)',
		a2783: 'Loại C: vị trí góc (không di chuyển thường xuyên hoặc xem xét kết hợp và đặt)',
		a2784: 'Tạo quà tặng hoặc hàng tiêu dùng',
		a2785: 'SKU phụ của kho hàng mới',
		a2786: 'Phát hành bằng một cú nhấp chuột',
		a2787: 'Lựa chọn phân phối được định cấu hình',
		a2788: 'Sản phẩm hiện tại không có mẫu liên kết, vui lòng liên kết các mẫu trước khi tiếp tục xuất bản? ',
		a2789: 'OK, phiên bản mới',
		a2790: 'Mẫu liên kết',
		a2791: 'Xem mẫu hiện đang bị ràng buộc',
		a2792: 'Phân phối sản phẩm này',
		a2793: 'Người khởi tạo kho liên minh sản phẩm đã chọn hiện được phân phối chưa ràng buộc mẫu phát hành của sản phẩm, bạn có thể nhắc người khởi tạo liên kết mẫu cho sản phẩm này hoặc bạn có thể tiếp tục phân phối sản phẩm, sau đó ràng buộc mẫu của riêng bạn mô hình mới, Xuất bản một lần nữa! ',
		a2794: 'Tiếp tục phân phối sản phẩm hiện tại',
		a2795: 'Đã phân phối thành công sản phẩm này! ',
		a2796: 'Bạn có chắc chắn muốn phân phối sản phẩm hiện tại không? ',
		a2797: 'Sản phẩm Kho hàng của Liên minh',
		a2798: 'Thư viện lựa chọn phân phối',
		a2799: 'Thư viện thành phẩm phân phối',
		a2800: 'Tổng quan sản phẩm phân phối',
		a2801: 'tổng số hàng tồn kho còn lại',
		a2802: 'Số lượng Đại lý',
		a2803: 'Bạn hiện không giới hạn số lượng proxy',
		a2804: 'Số lượng sku',
		a2805: 'Quản lý sản phẩm',
		a2806: 'Kiểm soát giá đại lý',
		a2807: 'Thêm thông tin đang chờ xử lý bắt buộc',
		a2808: 'Bộ sưu tập hàng hóa',
		a2809: 'Bộ sưu tập một cú nhấp chuột',
		a2810: 'Bộ sưu tập liên kết',
		a2811: 'Hiện tại chỉ hỗ trợ gom hàng trên nền tảng shopee, vui lòng vào link trang chi tiết sản phẩm! ',
		a2812: 'Thêm vào trung tâm mẫu sản phẩm',
		a2813: 'SKU mẹ của kho hàng',
		a2814: 'tên sản phẩm mẹ',
		a2815: 'Tên tiểu hàng của kho (không bắt buộc)',
		a2816: 'Điền mã hàng phụ của kho hàng',
		a2817: 'Tên hàng hóa phụ của kho hàng',
		a2818: 'Độ dài (tùy chọn)',
		a2819: 'Chiều rộng (tùy chọn)',
		a2820: 'Chiều cao (tùy chọn)',
		a2821: 'Vui lòng nhập sku gốc của kho hàng',
		a2822: 'Không quá 80 ký tự',
		a2823: 'Không quá 120 ký tự',
		a2824: 'Tải ảnh gốc xuống',
		a2825: 'Thay bản đồ thuộc tính',
		a2826: 'Nó có hỗ trợ dàn 3/7 không',
		a2827: 'Thể tích hàng hóa',
		a2828: 'Đề nghị tải ảnh lên!',
		a2829: 'Đề nghị tải ảnh lên ở trạng thái biên tập',
		a2830: 'Cập nhật thành công!',
		a2831: 'Lưu ảnh',
		a2832: 'Hỗ trợ một pod tùy chỉnh',
		a2833: 'Tham gia',
		a2834: 'Không tham gia',
		a2835: 'Ứng dụng mẫu miễn phí',
		a2836: 'Gửi đơn đăng ký',
		a2837: 'Gửi đơn đăng ký mẫu miễn phí thành công, kiểm tra tiến độ đăng ký, vui lòng tiếp tục: Tôi là đại lý - mô-đun ứng dụng mẫu',
		a2838: 'Đơn xin mẫu',
		a2839: 'Phạm vi thời gian',
		a2840: 'Trạng thái Ứng dụng',
		a2841: 'được vận chuyển',
		a2842: 'được trả lại',
		a2843: 'Thời gian nộp đơn',
		a2844: 'Người nộp đơn',
		a2845: 'Người nhận',
		a2846: 'Trả lời bình luận',
		a2847: 'Ghi chú trả lại',
		a2848: 'Ý kiến ​​kiểm toán',
		a2849: 'Nhận xét đánh giá',
		a2850: 'Thông tin chuyển phát nhanh hiện tại chưa được cập nhật, vui lòng kiên nhẫn chờ đợi, nếu có bất kỳ thắc mắc nào, vui lòng liên hệ nhà cung cấp',
		a2851: 'Thể hiện thông tin',
		a2852: 'Video/ảnh phản hồi mẫu',
		a2853: 'Nhà cung cấp đang xử lý và sẽ trả điểm sau',
		a2854: 'Nền tảng phân phối APP: Nó có thể thực hiện lựa chọn và phân phối APP, đồng thời xuất bản nó lên Shopee, Lazada, TikTok và các nền tảng khác, bao gồm đánh giá đơn hàng, quản lý trả hàng, dịch đồng thời, v.v.',
		a2855: 'Chọn sản phẩm nhập kho phân phối',
		a2856: 'Thông tin sản phẩm hoàn hảo',
		a2857: 'Bước trước',
		a2858: 'Tiếp theo',
		a2859: 'Mã cusCode của sản phẩm có thể tìm kiếm, SKU gốc/con, tên hàng hóa',
		a2860: 'Giá cung cấp (đơn vị: RMB)',
		a2861: 'Giá cung cấp là giá giao hàng một chiếc được cung cấp cho người bán, chi phí mua hàng mà người bán phải trả cho mỗi chiếc ra khỏi kho',
		a2862: 'Nhận được thu nhập thực tế của nhà cung cấp sau khi trừ hoa hồng hệ thống',
		a2863: 'Đã thu thập',
		a2864: 'hàng có sẵn để bán',
		a2865: 'Thể hiện lượng hàng tồn kho tối đa có sẵn để phân phối tại các kho hàng ở nước ngoài hoặc kho hàng tư nhân',
		a2866: 'Hàng tồn kho được phân bổ chỉ có thể được phân bổ từ hàng tồn kho thực tế trong kho, vì vậy nó không vượt quá hàng tồn kho thực tế trong kho',
		a2867: 'Tách khoảng không quảng cáo',
		a2868: 'Vui lòng nhập tên sản phẩm! ',
		a2869: 'Vui lòng nhập sku gốc của sản phẩm',
		a2870: 'Giá cung cấp là bắt buộc! ',
		a2871: 'Số lượng hàng tồn kho được chuyển không được lớn hơn số lượng hàng tồn kho của sản phẩm trong kho! ',
		a2872: 'Xác nhận gửi? ',
		a2873: 'Tạo thành công sản phẩm phân phối, đang thực hiện phân chia hàng tồn kho, ràng buộc thao tác mẫu, không rời khỏi trang hiện tại',
		a2874: 'Chia kho thành công! ',
		a2875: 'Thêm vào chờ xử lý',
		a2876: 'Đã thêm thành công và mẫu ban đầu đã được lưu',
		a2877: 'Công thức tính giá bán lẻ mặc định',
		a2878: 'Hộp nháp tạm thời',
		a2879: 'Số ký tự tối đa trong tên thông số kỹ thuật trên giá không được vượt quá 20! ',
		a2880: 'Số ký tự trong tiêu đề sản phẩm phải lớn hơn 20 và nhỏ hơn 100',
		a2881: 'Sau khi chọn đăng cửa hàng, hệ thống sẽ tự động lấy thông tin danh mục',
		a2882: 'Loại mục lựa chọn',
		a2883: 'Danh mục đã chọn',
		a2884: 'Xác nhận danh mục và tiếp tục đăng sản phẩm',
		a2885: 'Đề nghị lựa chọn loại mục！',
		a2886: 'Xác nhận danh mục và tiếp tục đăng sản phẩm trên shopee',
		a2887: 'Phát hành sản phẩm TikTok',
		a2888: 'Xác nhận loại mục, tiếp tục phát hành sản phẩm TikTok',
		a2889: 'Số lượng đặt hàng đang chờ xử lý',
		a2890: 'Số lượng đơn hàng đợi thẩm duyệt',
		a2891: 'Tỷ suất lợi nhuận gộp cố định',
		a2892: 'Xem liên kết ghim',
		a2893: 'Sau khi đóng tỷ suất lợi nhuận gộp cố định, hệ thống sẽ không còn tự động tính giá cung cấp phân phối của từng sku dựa trên các sản phẩm trực tuyến bị ràng buộc, xác nhận để tiếp tục đóng? ',
		a2894: 'Sản phẩm kho chưa được liên kết với một liên kết trực tuyến! ',
		a2895: 'Sản phẩm trong kho không có thông tin SKU con!',
		a2896: 'Sản phẩm đã bị xóa khỏi nền tảng phân phối! ',
		a2897: 'Sản phẩm có tỷ suất lợi nhuận gộp cố định không thể thay đổi giá cung cấp phân phối! ',
		a2898: 'Sửa đổi thành công giá cung cấp',
		a2899: 'Tên sản phẩm:',
		a2900: 'sku mẹ:',
		a2901: 'Xóa khoảng không quảng cáo',
		a2902: 'Lưu thay đổi',
		a2903: 'Thông tin cơ bản!',
		a2904: 'Tên sản phẩm:',
		a2905: 'Miêu tả sản phẩm:',
		a2906: 'Giá đại diện cho một mảnh (địa phương)',
		a2907: 'Thêm vào danh sách ý định mua hàng',
		a2908: 'Hậu cần cuối cùng:',
		a2909: 'Thể tích hàng hóa：',
		a2910: 'Trọng lượng hàng hóa：',
		a2911: 'Danh sách ý định mua hàng',
		a2912: 'Không có hình ảnh cho thông số kỹ thuật này',
		a2913: 'Xóa "Ý định mua hàng"',
		a2914: 'để tạo đơn đặt hàng',
		a2915: 'Sản phẩm này đã tồn tại trong danh sách mục đích mua hàng và không thể thêm lại',
		a2916: 'Mẫu liên kết đã được cập nhật',
		a2917: 'Chi tiết ràng buộc hàng hóa',
		a2918: 'Có thể tự động ràng buộc',
		a2919: 'Trạng thái bán trước',
		a2920: 'Số ngày bán trước',
		a2921: 'Mở bán hết tất cả để bán trước',
		a2922: 'Đóng tất cả đã bán hết và chuyển sang bán trước',
		a2923: 'hàng tồn kho còn lại',
		a2924: 'Nó có bị ràng buộc không',
		a2925: 'Bỏ ghim',
		a2926: 'ràng buộc',
		a2927: 'Thêm thông tin kho sản phẩm',
		a2928: 'số lượng hàng tồn kho',
		a2929: 'Vui lòng chọn SKU chính của kho sẽ được thay thế (mối quan hệ cấu hình và ràng buộc ban đầu không thay đổi)',
		a2930: 'Mã hàng gốc có thể tìm kiếm',
		a2931: 'Khi sản phẩm được chuyển sang bán trước, nếu sản phẩm đã tham gia Ưu đãi trọn gói của shopee, Chương trình giảm giá chớp nhoáng của cửa hàng tôi, các chương trình khuyến mãi sản phẩm Top Picks, vui lòng tự rút khỏi các hoạt động trên! ',
		a2932: 'Ứng dụng',
		a2933: 'Khôi phục',
		a2934: 'thuộc tính danh mục',
		a2935: 'thuộc tính cơ bản',
		a2936: 'Xác nhận phát hành',
		a2937: 'giá cổ phiếu',
		a2938: 'thông tin phiên bản mới',
		a2939: 'Chọn quốc gia',
		a2940: 'Điền tên mẫu',
		a2941: 'lựa chọn địa điểm',
		a2942: 'Mẫu liên kết',
		a2943: 'trả lại để xem xét',
		a2944: 'Thời gian tạo sản phẩm',
		a2945: 'Xuất bản lên',
		a2946: 'Sản phẩm không bình thường, đề nghị làm lại đại lý.',
		a2947: 'Trở về thành công! ',
		a2948: 'Vui lòng chọn một mẫu để liên kết! ',
		a2949: 'Giải pháp hệ thống kho hàng ở nước ngoài tại Đông Nam Á',
		a2950: 'Hệ thống kho tự xây dựng ở nước ngoài hỗ trợ đồng thời ERP/WMS, hỗ trợ Shopee/Lazade và các nền tảng khác, đồng bộ hóa hàng tồn kho/phân phối bằng một cú nhấp chuột/hỗ trợ xác nhận quyền sở hữu/trò chuyện nhiều cửa hàng, v.v.',
		a2951: 'Cung cấp giải pháp quản lý cửa hàng một cửa',
		a2952: 'Sử dụng miễn phí',
		a2953: '0 chi phí nhập cảnh',
		a2954: 'Không tính phí cài đặt ban đầu/không cần máy chủ/tạo bằng một cú nhấp chuột',
		a2955: 'Hỗ trợ nhóm chuyên nghiệp',
		a2956: 'Một bộ hoàn chỉnh về đào tạo hệ thống quản lý kho hàng ở nước ngoài và hỗ trợ hỗ trợ kỹ thuật sẽ cho phép hoạt động kinh doanh kho hàng ở nước ngoài của bạn phát triển nhanh chóng. ',
		a2957: 'Bắt ​​đầu nhanh',
		a2958: 'Phiên bản đơn giản hóa hoạt động đơn giản, hệ thống đa ngôn ngữ (tiếng Trung, tiếng Anh, tiếng Thái và tiếng Việt) thuận tiện cho người dân địa phương ở Đông Nam Á nhanh chóng tìm hiểu và bắt đầu. ',
		a2959: 'Thêm nguồn thu nhập',
		a2960: 'Các công ty giao nhận vận tải chất lượng vượt qua cuộc kiểm toán có thể được hưởng mức giá tương tự và hỗ trợ nhiều đại lý hơn trong hành trình đầu tiên/giá ngang hàng tại kho hàng ở nước ngoài đa quốc gia. ',
		a2961: 'Người bán nhanh chóng phát hiện ra đơn hàng bị COD từ chối hoặc bị mất do chuyển phát nhanh, để người bán có thể yêu cầu bồi thường kịp thời từ nền tảng, thu hồi khoản lỗ và tăng lợi nhuận ròng của bạn',
		a2962: 'Mã QR nhận dạng WeChat',
		a2963: 'Thêm dịch vụ khách hàng WeChat',
		a2964: 'Lợi thế của chúng tôi',
		a2965: 'Cung cấp dịch vụ kho bãi chất lượng cao ở nước ngoài',
		a2966: 'Dịch vụ khách hàng chu đáo 7*12 giờ',
		a2967: 'Cụm máy chủ được phân phối',
		a2968: 'Máy chủ nước ngoài',
		a2969: 'Mã quét WeChat',
		a2970: 'Quét mã để tải xuống',
		a2971: 'Ứng dụng kho',
		a2972: 'Hệ thống nhà kho ở nước ngoài tập trung vào phục vụ người bán địa phương ở Đông Nam Á',
		a2973: 'Mục nhập hệ thống WMS',
		a2974: 'đối tác tham gia',
		a2975: 'Tải xuống ứng dụng',
		a2976: 'Người bán địa phương',
		a2977: 'Chống bán quá mức',
		a2978: 'Hàng tồn kho đồng bộ hóa tự động đa nền tảng và nhiều cửa hàng',
		a2979: 'Quản lý kho hàng ở nước ngoài',
		a2980: 'Dễ sử dụng',
		a2981: 'Gieo WMS',
		a2982: 'đa ngôn ngữ',
		a2983: 'Cực kỳ đơn giản hóa',
		a2984: 'bảo mật dữ liệu',
		a2985: 'hệ thống ổn định',
		a2986: 'Hiệu quả Cực cao',
		a2987: 'Đông Nam Á',
		a2988: 'Tập trung vào các dịch vụ bản địa hóa ở Đông Nam Á trong nhiều năm',
		a2989: 'Trải nghiệm ngay',
		a2990: 'Hỗ trợ',
		a2991: 'Vui lòng sử dụng trình duyệt IE10 trở lên, Chrome, Firefox với độ phân giải tốt nhất là 1440×900 trở lên',
		a2992: 'Giải pháp hệ thống kho nước ngoài chuyên nghiệp tại Đông Nam Á',
		a2993: 'Giao nhận Vận tải Đông Nam Á',
		a2994: '0 chi phí tạo kho hàng ở nước ngoài',
		a2995: 'Hỗ trợ kho nhượng quyền ổn định, dễ dàng quản lý và kiểm soát khách hàng của kho ở nước ngoài',
		a2996: 'Tạo miễn phí kho hàng trực tuyến ở nước ngoài WMS Đông Nam Á',
		a2997: 'Phiên bản hoạt động đơn giản, hệ thống đa ngôn ngữ (tiếng Trung, tiếng Anh, tiếng Thái và tiếng Việt)',
		a2998: 'Thật thuận tiện cho người dân địa phương ở Đông Nam Á học hỏi nhanh chóng. ',
		a2999: 'Một bộ hoàn chỉnh về đào tạo hệ thống quản lý kho hàng ở nước ngoài và hỗ trợ hỗ trợ kỹ thuật',
		a3000: 'Hãy để công việc kinh doanh kho bãi ở nước ngoài của bạn nhanh chóng cất cánh. ',
		a3001: 'Hệ thống nhà kho nước ngoài tự xây dựng',
		a3002: 'Hỗ trợ đồng thời ERP/WMS, hỗ trợ Shopee/Lazade và các nền tảng khác',
		a3003: 'Đồng bộ hóa khoảng không quảng cáo/phân phối một khóa/trợ lý xác nhận quyền sở hữu/trò chuyện nhiều cửa hàng, v.v.',
		a3004: 'Nền tảng phân phối tại chỗ ở Đông Nam Á/Đài Loan',
		a3005: 'Hãy liên hệ với chúng tôi và chúng tôi sẽ ngay lập tức tạo ra một hệ thống kho hàng ở nước ngoài tại Đông Nam Á với chi phí bằng không! ',
		a3006: 'Đã bán hết và chuyển sang bán trước',
		a3007: 'Tùy chọn',
		a3008: 'Liên kết kho phụ kiện sản phẩm',
		a3009: `Chỉ Khi thành phẩm được cấu tạo từ nhiều phụ kiện để tạo thành SKU sản phẩm, ví dụ: đồng hồ báo thức gồm 1 thân đồng hồ + 2 pin AA<br/>
		Một SKU đồng hồ báo thức đã hoàn thành được bán ra thế giới bên ngoài. Sau khi bán một đồng hồ báo thức đã hoàn thành, 1 phụ kiện thân đồng hồ và 2 phụ kiện pin AA sẽ được khấu trừ.<br/>
		Và số lượng tồn kho của đồng hồ báo thức đã hoàn thành phụ thuộc vào số lượng kết hợp phụ kiện.`,
		a3010: 'Tăng',
		a3011: 'Chọn đường đi đầu của cửa hàng Xiaosheng',
		a3012: 'Trọng lượng ước tính',
		a3013: 'khối lượng ước tính',
		a3014: 'Tạo và gửi yêu cầu lưu trữ',
		a3015: 'Tất cả các SKU phụ đã được chọn',
		a3016: 'Chỉ khi thành phẩm gồm nhiều phụ kiện mới tạo thành SKU sản phẩm, ví dụ: đồng hồ báo thức gồm 1 thân đồng hồ + 2 pin AA và 1 SKU đồng hồ báo thức hoàn chỉnh được bán ra bên ngoài thì 1 đồng hồ báo thức được bán đã bán Đối với thành phẩm, một kho phụ kiện thân đồng hồ và hai kho phụ kiện pin AA sẽ được khấu trừ và số lượng tồn kho của đồng hồ báo thức thành phẩm phụ thuộc vào số lượng kết hợp phụ kiện. ',
		a3017: 'Xóa sản phẩm này thành công! ',
		a3018: 'Không thể xóa mục hiện tại! ',
		a3019: 'Vui lòng chọn kho hàng cần xóa! ',
		a3020: 'Số lượng quân cờ đã nhập ít nhất bằng hoặc lớn hơn 1',
		a3021: 'Chỉ tải tệp lên bằng Excel (tức là có hậu tố là .xlsx)',
		a3022: 'Kích thước tệp không được vượt quá 10M',
		a3023: 'Tệp đã tải lên thành công',
		a3024: 'Vui lòng chọn sản phẩm cần tạo và lưu trữ',
		a3025: 'Mã kho là',
		a3026: 'Cập nhật ảnh trong kho',
		a3027: 'Chỉ tải lên tệp jpg/png',
		a3028: 'Thêm hàng vào kho',
		a3029: 'Tắt cập nhật tự động trong kho',
		a3030: 'Mở bản cập nhật tự động trong kho',
		a3031: 'Thời gian đến ước tính',
		a3032: 'Ngày đến',
		a3033: 'Nhập cước (cước sẽ ảnh hưởng trực tiếp đến việc tính giá trị hàng hóa, nên nhập)',
		a3034: 'Giới thiệu về cấu hình của thư viện gói kết hợp',
		a3035: `<p style="color:red;font-weight:bold;font-size:16px">Nếu cửa hàng trực tuyến của bạn bán sản phẩm gói kết hợp, bạn cần định cấu hình thư viện gói kết hợp (nếu không có gói kết hợp, bạn có thể bỏ qua)</p>
		<br />
		<p>Bước 1. Tạo [Thư viện gói kết hợp]: nhập sản phẩm trực tuyến thông qua [Tạo thủ công] hoặc [Nhập sản phẩm];</p>
		<p>Lưu ý chỉ cần nhập 1 link, còn lại các link sản phẩm trực tuyến khác cùng mẫu mã cần liên kết với sản phẩm kho hàng vừa nhập.</p>
		<router-link :to="{path:'/userStoreItems/products'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">Nếu sản phẩm bạn bán trực tuyến là mặt hàng trong kho, vui lòng xem phần giới thiệu cấu hình của thư viện mặt hàng trong kho.</p>
		</router-link>
		
		<br />
		<p>Bước 2. Định cấu hình [Gói kết hợp]: Nhấp vào [Đặt cấu hình gói] của SKU phụ và chọn cấu hình từ [Trong kho] đã tạo;</p>
		<br />
		<p>①Trước tiên, bạn phải tạo [Thư viện mặt hàng trong kho] trước khi có thể định cấu hình gói kết hợp, xem "Giới thiệu về thiết lập thư viện mặt hàng đặt hàng trong kho" để biết chi tiết)</p>
		<p>②Sản phẩm đơn lẻ và gói phải ở trong cùng một kho hàng (không được phép tạo một sản phẩm duy nhất trong kho hàng ở nước ngoài tại Malaysia mà phải định cấu hình gói hàng trong kho hàng nước ngoài ở Thái Lan)</p>
		<p>③Các gói không thể bị xóa trong các trường hợp sau: khi một sản phẩm đã được định cấu hình (cần hủy cấu hình trước), khi sản phẩm được lưu trữ trong quá trình vận chuyển (cần hoàn thành hoặc xóa trước)</p>
		<br />
		<p>Bước 3. Liên kết các liên kết trực tuyến: liên kết và liên kết các sản phẩm trong [Thư viện gói kết hợp] với các sản phẩm của từng cửa hàng trực tuyến;</p>
		<br />
		<p>①Có thể được liên kết và ràng buộc tự động (với điều kiện là SKU gốc của mỗi cửa hàng trực tuyến cần phải hoàn toàn nhất quán)</p>
		<p>②Có thể được liên kết và ràng buộc theo cách thủ công (mỗi SKU phụ được liên kết với sản phẩm trực tuyến tương ứng của cửa hàng)</p>
		<p>③Bạn có thể chỉnh sửa liên kết tự động và trạng thái liên kết của tất cả các cửa hàng một cách trực quan.</p>
		<br />
		<p>Bước 4. Bật đồng bộ hóa kho hàng trực tuyến: thao tác hàng loạt hoặc nhấp vào [Tự động cập nhật kho hàng trực tuyến] của tiểu mã hàng để bắt đầu đồng bộ hóa kho hàng thực tế của gói hàng trực tuyến;</p>
		<br />
		<p>1. Số lượng tồn kho thực tế của kiện hàng phụ thuộc vào tỷ lệ tồn kho của các mặt hàng trong kho. Ví dụ: nếu gói bán hàng là một bộ 2 bút đỏ và có 10 bút đỏ trong thư viện sản phẩm đơn lẻ, thì theo tỷ lệ khớp, chỉ còn 5 chiếc trong gói.</p>
		<br />
		<p>2. Không thể trực tiếp sửa đổi hàng tồn kho theo gói và nhà kho chỉ cần đếm số lượng thực tế [trong kho đặt hàng của kho]. Thư viện gói được định cấu hình hầu như, vì vậy khoảng không quảng cáo phụ thuộc vào các mục thực tế trong kho. Việc ra vào kho đều được thực hiện tại [trong kho lệnh kho].</p>`,
		a3036: 'Không còn lời nhắc nào trong tương lai',
		a3037: 'Chuyển cập nhật hàng tồn kho trực tuyến',
		a3038: 'Chuyển vào thư viện sản phẩm đơn theo lô',
		a3039: 'Thay thế SKU gốc theo đợt',
		a3040: 'Tạo gói',
		a3041: 'được tạo thủ công',
		a3042: 'Nhập trực tuyến',
		a3043: 'Liên kết tất cả các SKU con',
		a3044: 'liên kết liên kết thủ công',
		a3045: 'Liên kết liên kết tự động',
		a3046: 'Xóa sku gốc',
		a3047: 'Thêm SKU phụ của kho theo cách thủ công',
		a3048: 'Nhập SKU phụ của kho hàng trực tuyến',
		a3049: 'Chỉnh sửa tình huống trực tuyến ràng buộc',
		a3050: 'Tùy thuộc vào số lượng hàng tồn kho tối đa có thể được kết hợp từ các mặt hàng trong kho thực tế được định cấu hình trong gói',
		a3051: 'Kho hàng trực tuyến của sản phẩm bị ràng buộc sẽ luôn được cập nhật thành hàng tồn kho trực tuyến thực tế trong kho (ngoại trừ các sản phẩm bán trước)',
		a3052: 'hàng đóng gói riêng lẻ',
		a3053: 'hàng tồn kho đóng gói riêng lẻ',
		a3054: 'Chuyển vào thư viện sản phẩm duy nhất',
		a3055: 'Hủy đóng gói độc lập',
		a3056: 'Đặt đóng gói độc lập',
		a3057: 'Cùng nhau lần này',
		a3058: 'Sản phẩm đã tắt auto update và đang có hàng! ',
		a3059: 'Đã tắt cập nhật tự động và lưu vào kho! ',
		a3060: 'Sản phẩm đã bật auto update và đang có hàng! ',
		a3061: 'Cập nhật tự động được bật và lưu trữ trong kho! ',
		a3062: 'Một sản phẩm sẽ được thêm vào thư viện một sản phẩm, vui lòng xác nhận? ',
		a3063: 'Bạn có chắc chắn muốn chuyển sang thư viện sản phẩm duy nhất không?',
		a3064: 'Nó đã được chuyển vào thư viện vật phẩm! ',
		a3065: 'Khi đặt ở chế độ tự động, số lượng hàng tồn kho cần khóa sẽ được đặt theo cài đặt thực tế của người bán, khóa mặc định là 0, tức là không khóa. ',
		a3066: 'Vui lòng xác nhận xem nó có được đặt làm sản phẩm đóng gói riêng lẻ không?',
		a3067: 'Vui lòng xác nhận có hủy sản phẩm được đóng gói riêng lẻ hay không?',
		a3068: 'Hủy thành công! ',
		a3069: 'Nhập thanh sản phẩm',
		a3070: 'Vui lòng nhập thông tin mã vạch',
		a3071: 'Tổng số hàng tồn kho của các mặt hàng đơn lẻ được tiêu thụ bởi gói hàng sẽ được vận chuyển',
		a3072: 'Cấu hình gói của mặt hàng này',
		a3073: 'Mã kho phù hợp',
		a3074: 'Số lượng cấu hình gói',
		a3075: 'Đặt hàng tồn kho',
		a3076: 'Số lượng kiện hàng được vận chuyển',
		a3077: 'Giới thiệu về thiết lập thư viện kho hàng',
		a3078: `			<p style="color:red;font-weight:bold;font-size:16px">Để ý! Chỉ có một sản phẩm trong kho và tất cả các SKU phụ trực tuyến của cùng một mặt hàng phải được liên kết với cùng một sản phẩm trong kho để cập nhật đồng bộ kho một cách hiệu quả.</p>
		<br />
		<p>Bước 1. Lập [Trong kho]: Nhập sản phẩm trực tuyến thông qua [Tạo thủ công] hoặc [Nhập sản phẩm];</p>
		<p>Lưu ý chỉ cần nhập 1 link, còn lại các link sản phẩm trực tuyến khác cùng mẫu mã cần liên kết với sản phẩm kho hàng vừa nhập.</p>
		<router-link :to="{path:'/userStoreItems/accessories'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">Nếu sản phẩm bán hàng trực tuyến của bạn có gói kết hợp, vui lòng xem phần giới thiệu về cấu hình của gói kết hợp, nếu không có gói, hãy chuyển sang bước thứ hai.</p>
		</router-link>
		<br />
		<p>Bước 2. Liên kết và liên kết các sản phẩm trong [Thư viện mặt hàng kho] với các sản phẩm trong mỗi cửa hàng trực tuyến;</p>
		<br />
		<p>①Có thể được liên kết và ràng buộc tự động (với điều kiện là SKU gốc của mỗi cửa hàng trực tuyến cần phải hoàn toàn nhất quán)</p>
		<p>②Có thể được liên kết và ràng buộc theo cách thủ công (mỗi SKU phụ được liên kết với sản phẩm trực tuyến tương ứng của cửa hàng)</p>
		<p>③Bạn có thể chỉnh sửa liên kết tự động và trạng thái liên kết của tất cả các cửa hàng một cách trực quan.</p>
		<br />
		<p>Bước 3. Bật khoảng không quảng cáo đồng bộ hóa, thao tác hàng loạt hoặc nhấp vào [Tự động cập nhật khoảng không quảng cáo trực tuyến] của sku phụ và khoảng không quảng cáo trực tuyến sẽ bắt đầu được đồng bộ hóa.</p>
		<br />
		<p>1. Hết hàng: 1 phần hàng tồn kho được bán cho bất kỳ mặt hàng nào trên nền tảng và 1 phần hàng tồn kho cũng sẽ được trừ khỏi tất cả các sản phẩm liên quan trong cửa hàng</p>
		<p>2. Nhập kho: Hàng mới về, sau khi có xác nhận của cả bên bán và kho, kho sẽ tự động tăng số lượng nhập của hàng tương ứng.</p>
		<p>3. Chiếm trước: Bất kỳ sản phẩm nào trên nền tảng tham gia sự kiện Flash sale đều có thể tự động chiếm trước hàng trong kho và bán sản phẩm đó sau khi sự kiện bắt đầu</p>
		<br />
		<p>Để ý! Không thể nhập trực tiếp nhiều liên kết sản phẩm trực tuyến của cùng một mẫu để tạo nhiều sản phẩm trong kho, vì chỉ có một sản phẩm thực. Để đồng bộ hóa chính xác hàng tồn kho, trước tiên bạn phải tạo [Sản phẩm đơn lẻ trong kho] hoặc [Gói kết hợp], thông qua [ Sản phẩm trong kho] hoặc [Gói kết hợp] Để liên kết nhiều liên kết trực tuyến của cùng một sản phẩm (ví dụ: liên kết trực tuyến của cùng một mẫu tại các cửa hàng khác nhau trên Shopee hoặc Lazade), nghĩa là nhiều SKU phụ trực tuyến của cùng một mẫu được ràng buộc với cùng một sản phẩm trong kho.</p>`,
		a3079: 'Tự động dự báo hết hàng dựa trên chu kỳ tồn kho, chu kỳ tồn kho mặc định là 7 ngày (có thể điều chỉnh)',
		a3080: 'Tạo một sản phẩm',
		a3081: 'Bản sao sản phẩm toàn kho',
		a3082: 'xuất toàn bộ kho',
		a3083: 'Vui lòng kiểm tra! ',
		a3084: 'Nhận xét bị từ chối:',
		a3085: 'bị từ chối',
		a3086: 'Bạn có muốn đăng ký đơn hàng tự đóng cho mẫu này không?',
		a3087: 'Trạng thái tải lên hàng loạt',
		a3088: 'Vui lòng đợi trong khi tải sản phẩm lên. . . ',
		a3089: 'trạng thái tải lên',
		a3090: 'Đăng các sản phẩm của TikTok Shop theo đợt',
		a3091: 'Chọn lại danh mục',
		a3092: 'Danh sách sản phẩm',
		a3093: 'Tính giá bán lẻ theo công thức đã thiết lập',
		a3094: 'Chưa có công thức',
		a3095: 'Nhấp để đặt! ',
		a3096: 'đặt ngay bây giờ',
		a3097: `Đặt công thức định giá của giá bán lẻ, từ trái sang phải: phí xuất hàng, tỷ giá hối đoái, chiết khấu, tỷ suất lợi nhuận：
		<p>1.Phí xuất kho: Hiện tại phí xuất kho của Malay là 3 tệ, bạn có thể điền vào 3</p>
		<p>2.Tỷ giá hối đoái: tỷ giá hối đoái của Nhân dân tệ sang nội tệ, chẳng hạn như 1rmb=1,5 MYR, cụ thể là: tỷ giá hối đoái 0,667</p>
		<p>3.Tỷ lệ lợi nhuận: tỷ lệ lợi nhuận gộp bạn muốn kiếm được, chẳng hạn như 30%, đặt 30</p>
		<p>4.Giảm giá: Nếu bạn định đặt giá bán giảm 40% so với giá gốc, nghĩa là: Giảm 40 </p>`,
		a3098: 'Phát hành ngay bây giờ',
		a3099: 'Phát hành thành công',
		a3100: 'Tất cả các vành đai ngành',
		a3101: 'Không có khu công nghiệp',
		a3102: 'giải phóng mặt bằng',
		a3103: 'Hỗ trợ dàn 3/7',
		a3104: 'Video bên thương hiệu',
		a3105: 'Danh mục:',
		a3106: 'Lọc một sản phẩm POD tùy chỉnh',
		a3107: 'Người bán phân phối nguồn cung như thế nào? ',
		a3108: 'Tìm sku gốc',
		a3109: 'Tìm tên sản phẩm',
		a3110: 'Tìm mã kho',
		a3111: 'Một số sản phẩm được miễn phí giao hàng, một số sản phẩm khác được tính phí theo gói hàng theo tiêu chuẩn kho hàng ở nước ngoài',
		a3112: 'Biên lợi nhuận gộp ước tính',
		a3113: 'Giá đại diện cho một mảnh',
		a3114: 'Phí thao tác thoát',
		a3115: 'Miễn phí',
		a3116: 'Cổ phiếu giao ngay cục bộ',
		a3117: 'Liên hệ với Nhà phân phối',
		a3118: 'mua trong khoảng thời gian tài khoản',
		a3119: 'Vui lòng xác nhận nếu sản phẩm được phân phối?',
		a3120: 'Sản phẩm được phân phối bởi một đại lý thành công, bạn có thể tiếp tục phân phối hàng hóa, bạn có thể xem tất cả các sản phẩm được phân phối tại "Tôi đã đại lý".',
		a3121: 'Tra mã kho',
		a3122: 'Tìm kiếm sku gốc của sản phẩm',
		a3123: 'Tất cả các vành đai ngành',
		a3124: 'Đặc vụ',
		a3125: 'Tài khoản đại lý',
		a3126: 'Tên đại lý',
		a3127: 'Hoạt động phân phối',
		a3128: 'Nhắc nhở dọn kho thanh lý ',
		a3129: 'Giá cung cấp hiện tại',
		a3130: 'Giá chiết khấu bán lẻ thấp nhất trực tuyến (RMB)',
		a3131: 'liên kết trang chia sẻ h5',
		a3132: 'Người bán đã đại diện cho sản phẩm này',
		a3133: 'Mô tả hoạt động',
		a3134: 'Tỷ lệ hoa hồng cấp 1',
		a3135: 'Tỷ lệ hoa hồng cấp 2',
		a3136: 'Sản phẩm lưu kho tối thiểu',
		a3137: 'Danh mục sản phẩm đang hoạt động',
		a3138: 'Đăng ký ngay',
		a3139: 'Tỷ lệ chiết khấu ba cấp',
		a3140: 'Sản phẩm dọn kho thanh lý: Tỷ suất lợi nhuận gộp phải lớn hơn hoặc bằng 80%, giá cung cấp thấp hơn 50% giá cung cấp hiện tại.',
		a3141: 'Chưa đủ điều kiện',
		a3142: 'Giá cung cấp dọn kho thanh lý',
		a3143: 'Giảm giá đa cấp, phân phối và mở rộng khách hàng, tuyển dụng tích cực',
		a3144: 'Hướng dẫn hoạt động của nhà cung cấp',
		a3145: 'Tạo "Trang chia sẻ phân phối của tôi"',
		a3146: 'Ngày lên kệ',
		a3147: 'Tôi cần dọn kho thanh lý',
		a3148: 'Sản phẩm dọn kho thanh lý',
		a3149: 'Phân phối dỡ khỏi kệ',
		a3150: 'Sản phẩm phân phối cập nhật thành công!',
		a3151: 'Tỷ suất lợi nhuận gộp của hàng dọn kho thanh lý phải lớn hơn 80%.',
		a3152: 'Giá cung cấp dọn kho thanh lý phải thấp hơn 50% giá cung cấp hiện tại.',
		a3153: 'nộp!',
		a3154: 'Sản phẩm này tổng cộng hiện có',
		a3155: 'người bán đang bán hàng trực tuyến, hiện không hỗ trợ người dùng dỡ sản phẩm khỏi kệ sàn giao dịch. Nếu bắt buộc phải dỡ sản phẩm khỏi kệ, vui lòng liên hệ với dịch vụ khách hàng của sàn? Số Wechat Dịch vụ khách hàng: shopsbu001',
		a3156: 'Xác nhận tiếp tục dỡ khỏi kệ?',
		a3157: 'Nhà cung cấp:',
		a3158: 'Sản phẩm đã bị dỡ khỏi kệ sàn phân phối:',
		a3159: 'Nếu đại lý đã đưa sản phẩm lên kệ thành công, đề nghị tự cập nhật hiện trạng sản phẩm!',
		a3160: 'Thành công',
		a3161: 'Xác nhận muốn tham gia hoạt động mở rộng bán hàng không?',
		a3162: 'Truy vấn mã đơn hàng/kho',
		a3163: 'Không có hồ sơ đặt hàng',
		a3164: 'Rổng giá cung cấp',
		a3165: 'Nhà cung cấp thực nhận',
		a3166: 'Đơn giá cung cấp hàng',
		a3167: 'Trạng thái đơn đặt hàng',
		a3168: 'Đợi xử lý',
		a3169: 'Đặt mua hồ sơ, bạn có muốn tiếp tục thao tác này không? ',
		a3170: 'điểm trả về',
		a3171: 'Từ chối điểm',
		a3172: 'Đồng ý hàng loạt',
		a3173: 'từ chối hàng loạt',
		a3174: 'Đơn đặt hàng tự tạo hàng loạt',
		a3175: 'Điểm đã được hoàn lại',
		a3176: 'Ảnh/Video',
		a3177: 'Sau đây là nội dung video của phía thương hiệu, có thể được sử dụng trong TIKTOK và các video khác, chú ý chỉnh sửa phụ và xóa nội dung trùng lặp!',
		a3178: 'Liên kết',
		a3179: 'mã khai thác',
		a3180: 'Điền vào, đặt hàng ngay',
		a3181: 'Chọn số lượng mua',
		a3182: 'Đặt hàng ngay',
		a3183: 'Mua ngay',
		a3184: 'Gửi đơn hàng thành công! ',
		a3185: 'Mật khẩu',
		a3186: 'Vui lòng nhập ID người dùng hoặc số điện thoại di động',
		a3187: 'đăng nhập',
		a3188: 'Không có tài khoản? Nhấp vào Đăng ký',
		a3189: 'phân phối điểm',
		a3190: 'Nguyên tắc hoạt động phân phối',
		a3191: 'Hướng dẫn vận hành phân phối trên kệ trong kho thử nghiệm của Trung Quốc',
		a3192: 'Hướng dẫn vận hành phân phối trên kệ của nhà cung cấp',
		a3193: 'Hướng dẫn dành cho Đại lý Liệt kê Hoạt động',
		a3194: 'Vận chuyển hàng không tốc hành từ kho thử nghiệm Thâm Quyến của Trung Quốc đến Đông Nam Á (3 ngày), không bao gồm vận chuyển hàng không',
		a3195: 'Chuyển sang Trung Quốc mua hàng',
		a3196: 'Nguồn cung cấp bán buôn của Trung Quốc là đủ, và các mẫu miễn phí được hỗ trợ. Sau khi đặt hàng lô đầu tiên, phí mẫu có thể được hoàn lại. Nhấp để mua trực tiếp hoặc liên hệ với nhân viên dịch vụ khách hàng của Xiaosheng. ',
		a3197: 'Tất cả các vùng',
		a3198: 'Hướng dẫn',
		a3199: 'Tất cả các quốc gia',
		a3200: 'Không thể tải ảnh lên',
		a3201: 'Bạn có chắc chắn muốn xóa phiên này không?',
		a3202: 'Đã xóa phiên thành công',
		a3203: 'Vui lòng chọn một đối tượng phiên! ',
		a3204: 'Làm mới phiên',
		a3205: 'Nhà phân phối',
		a3206: 'Ghi chép lịch sử phát hành',
		a3207: 'Cửa hàng đã phát hành',
		a3208: 'Thời gian phát hành',
		a3209: 'Trạng thái phát hành',
		a3210: 'Phát hành thất bại',
		a3211: 'Chỉnh sửa lại và xuất bản',
		a3212: 'Tải hàng loạt lên TIKTOK',
		a3213: 'Tạo trang trung tâm bán lẻ',
		a3214: 'Hướng dẫn hoạt động của đại lý',
		a3215: 'Một phần dỡ khỏi kệ',
		a3216: 'Phát hành sản phẩm',
		a3217: 'Đã xóa bản ghi thành công!',
		a3218: 'Đánh dấu tick chọn sản phẩm, rồi thao tác',
		a3219: 'Thao tác này sẽ bị xóa',
		a3220: 'Ghi chép, xin xác nhận có tiếp tục không?',
		a3221: 'Thêm vào giỏ hàng',
		a3222: 'Tư vấn kinh doanh',
		a3223: 'Vui lòng nhập nội dung...',
		a3224: 'Hàng cung cấp của tôi',
		a3225: 'Đại diện xuất đơn hàng',
		a3226: 'Vị trí của nguồn',
		a3227: 'Từ chối trả lời nhận xét:',
		a3228: 'từ chối trả lại',
		a3229: 'Chuyển vào thư viện gói',
		a3230: 'thuộc gói',
		a3231: 'Các loại quà tặng',
		a3232: 'Tạo sku mặt hàng theo cách thủ công trong đơn đặt hàng trong kho',
		a3233: 'Bạn có chắc chắn muốn chuyển sang thư viện gói không?',
		a3234: 'Nó đã được chuyển vào thư viện gói! ',
		a3235: 'Giá gốc bán lẻ - (nội tệ)',
		a3236: 'Giá cung-(đơn vị/¥)',
		a3237: 'mã cusCode được liên kết',
		a3238: 'ứng dụng đã được phê duyệt',
		a3239: 'Tải ảnh/video lên',
		a3240: 'Đơn đăng ký đã bị từ chối',
		a3241: 'Tự tạo đơn hàng thành công, vui lòng vào: module đơn hàng của tôi để xem',
		a3242: 'Nạp tiền & báo giá',
		a3243: 'Vui lòng tải ảnh/video lên',
		a3244: 'Ứng dụng của tôi',
		a3245: 'Đơn xin mẫu đại lý',
		a3246: 'phí thuê nhà kho',
		a3247: 'phí trọn gói',
		a3248: 'Thuộc tính thương hiệu của sản phẩm không được chọn',
		a3249: 'Thuộc tính bán hàng sku trùng lặp',
		a3250: 'Đã xuất bản thành công! ',
		a3251: 'Các thuộc tính sản phẩm có dấu hoa thị màu đỏ là bắt buộc',
		a3252: 'Ngoại lệ hệ thống',
		a3253: 'Độ dài của tên sku không vượt quá 20 ký tự',
		a3254: 'Yêu cầu thuộc tính bầu trời đầy sao màu đỏ',
		a3255: 'Độ dài ký tự của tiêu đề sản phẩm phải từ 20 đến 100 ký tự',
		a3256: 'Một sản phẩm có cùng tiêu đề sản phẩm đã tồn tại trong cửa hàng hiện tại! ',
		a3257: 'Giá bán lẻ của mã hàng, giá trị tối đa chia cho giá trị tối thiểu không được lớn hơn 7',
		a3258: 'Kho ở nước ngoài',
		a3259: 'Danh sách mặt in mặc định & danh sách chọn',
		a3260: 'Không có kho hạn chế',
		a3261: 'Không có cửa hàng bị ràng buộc',
		a3262: 'Thanh toán phí giao hàng',
		a3263: 'Thu nhập từ phí giao hàng',
		a3264: 'Chi phí lưu kho của kệ đặt hàng',
		a3265: 'Doanh thu phí kệ hàng đối với đơn đặt hàng lưu trữ',
		a3266: 'Chi phí xử lý tờ khai',
		a3267: 'Thu nhập từ phí xử lý tờ khai',
		a3268: 'Khấu trừ nền tảng',
		a3269: 'Chi phí giao hàng đơn hàng (P)',
		a3270: 'Thu nhập từ phí giao hàng (P)',
		a3271: 'Chi phí lưu trữ giá kệ đặt hàng (P)',
		a3272: 'Doanh thu phí kệ hàng đối với đơn đặt hàng lưu trữ (P)',
		a3273: 'Thanh toán phí đăng ký mẫu',
		a3274: 'Thu nhập lệ phí nộp đơn mẫu',
		a3275: 'Thông tin mô tả của sản phẩm nằm trong khoảng 2-3000 ký tự',
		a3276: 'Thu nhập phí gửi đi',
		a3277: 'Thu nhập phí niêm yết',
		a3278: 'doanh thu trả lại',
		a3279: 'thu nhập từ phí linh tinh của nhà kho',
		a3280: 'Thu nhập từ phí cho thuê nhà kho (P)',
		a3281: 'Thu nhập khấu trừ nền tảng',
		a3282: 'Nền tảng khấu trừ chi phí',
		a3283: 'Thu nhập phí niêm yết (P)',
		a3284: 'Thu nhập phí gửi đi (P)',
		a3285: 'Đơn đặt hàng',
		a3286: 'mua đầy đủ',
		a3287: 'đặt cọc mua hàng',
		a3288: 'Tiền gửi:',
		a3289: 'Thanh toán cuối cùng:',
		a3290: 'Khoản thanh toán cuối cùng:',
		a3291: 'Lời nhắc thanh toán số dư',
		a3292: 'Thông báo đã được gửi thành công để cung cấp cho người mua số dư thanh toán',
		a3293: 'Thu nhập từ phí mua sản phẩm',
		a3294: 'Vui lòng tải bảng kích thước lên',
		a3295: 'Bảng kích thước',
		a3296: 'Chi phí mua sản phẩm',
		a3297: 'Hoàn trả điểm đã bị từ chối',
		a3298: 'Chi phí đại lý nền tảng phân phối',
		a3299: 'Thu nhập từ phí đại lý nền tảng phân phối',
		a3300: 'Hiện tại không đủ điểm, vui lòng nạp lại và thử lại',
		a3301: 'Thu nhập nạp tiền thanh toán',
		a3302: 'Chi phí nạp tiền thanh toán',
		a3303: 'Phân phối thành công, vui lòng vào "Tôi là đại lý" để kiểm tra',
		a3304: 'Vui lòng xác nhận bạn có muốn phân phối sản phẩm này không?',
		a3305: 'Quét để tải xuống ỨNG DỤNG',
		a3306: 'Nền tảng phân phối APP (Android)',
		a3307: 'Sản phẩm phân phối đa cấp',
		a3308: 'Nhà phân phối cấp 1 Chi phí chiết khấu',
		a3309: 'Thu Nhập Chiết Khấu Cấp 1 Phân Phối',
		a3310: 'Phân phối chi phí giảm giá thứ cấp',
		a3311: 'Phân phối thu nhập giảm giá thứ cấp',
		a3312: 'Phân phối chi tiêu giảm giá ba cấp',
		a3313: 'Phân phối thu nhập giảm giá ba cấp',
		a3314: 'Thống kê phân phối đa cấp',
		a3315: 'Tổng đại lý số lượng',
		a3316: 'Tổng đại lý mua số lượng',
		a3317: 'Hoa hồng tổng doanh thu',
		a3318: 'Tìm kiếm tài khoản đại lý',
		a3319: 'Cấp đại lý',
		a3320: 'Tài khoản đại lý',
		a3321: 'Trình khởi xướng cấp một',
		a3322: 'Quảng cáo thứ cấp',
		a3323: 'Người quảng bá cấp ba',
		a3324: 'Tổng số tiền mua hàng',
		a3325: 'Tổng hoa hồng',
		a3326: 'Phân tích proxy',
		a3327: 'Số tiền mua',
		a3328: 'Nhiệm vụ',
		a3329: "Sửa đổi cửa hàng",
		a3330: "Mã hàng tồn kho sản phẩm",
		a3331: "Token giao hàng tại Mỹ",
		a3332: "Token giao hàng khu vực châu Âu",
		a3333: 'Cửa hàng tiền tệ',
		a3334: "Vui lòng điền ID cửa hàng",
		a3335: 'Vui lòng điền tên cửa hàng',
		a3336: "Vui lòng chọn loại cửa hàng",
		a3337: 'Hoa Kỳ',
		a3338: 'Tiếng Anh',
		a3339: 'Đức',
		a3340: 'Ý',
		a3341: 'Nước Pháp',
		a3342: 'Tây Ban Nha',
		a3343: 'Bán ủy thác',
		a3344: 'Được quản lý đầy đủ',
		a3345: 'Cửa hàng địa phương',
		a3346: "Cửa hàng chủ đề Hồng Kông",
		a3347: "Cửa hàng không phải chủ thể Hồng Kông",
		a3348: 'Trạng thái logistics',
		a3349: "Đã đặt hàng trực tuyến",
		a3350: "Không đặt hàng trực tuyến",
		a3351: 'Quản lý thư viện',
		a3352: 'Bộ sưu tập tùy chỉnh',
		a3353: "Tạo bản vẽ",
		a354: "Tạm thời không có bản đồ",
		a3355: 'Tạo mẫu',
		a3356: 'Tên trang',
		a3357: 'Loại trang',
		a3358: 'Mã sản phẩm',
		a3359: 'Kích thước mô hình',
		a3360: 'Tên màu',
		a3361: 'Kích thước',
		a3362: 'Màu sắc',
		a3363: 'Vui lòng nhập tên trang',
		a3364: 'Vui lòng chọn loại trang',
		a3365: 'Vui lòng nhập phiên bản mẫu',
		a3366: "Vui lòng tải ảnh lên",
		a3367: 'Vui lòng nhập số mô hình kích thước',
		a3368: 'Vui lòng nhập tên màu',
		a3369: '1、DiangXiaosheng-Cung cấp các nhà kho và giải pháp phân phối nước ngoài địa phương xuyên biên giới',
		a3370: '2、DiangXiaosheng-Tập trung vào các bộ phận nhỏ của mỹ/đông nam á địa phương dịch vụ',
		a3371: 'Xin vui lòng điền vào mã mời, tạm thời chỉ mời người dùng, có thể liên hệ với wechat của dịch vụ khách hàng.:shopsbu001',
		a3372: 'Đồng bộ hóa liên kết hàng hóa',
		a3373: 'Nền tảng đang xử lý',
		a3374: 'Số lượng lớn truy vấn không thể vượt quá 200!',
		a3375: 'lên kệ hàng loạt lên TEMU',
		a3376: 'Lên kệ sản phẩm theo lô cho TEMU',
		a3377: 'Tải xuống mẫu nhập',
		a3378: 'Click Download Template để tải sản phẩm lên hàng loạt vào Temu',
		a3379: 'Import file sản phẩm lên kệ',
		a3380: `1、Mẫu này chỉ áp dụng cho các danh mục không phải là quần áo, hiện tại chỉ mở phòng tắm chống trơn trượt; khăn tắm bãi biển; chăn nhỏ, chăn trưa; 3 danh mục trên.<br>
                            2. Danh mục hàng hóa và mẫu thuộc tính có quan hệ tương ứng, cần điền theo quy tắc mẫu tương ứng.<br>
                            3. Kiểm tra độ dài tiêu đề sản phẩm: { A. Giới hạn 100 ký tự [cat1Id=1(CD và đĩa than)] B. Giới hạn 200 ký tự [cat1Id=653(Vi sinh phẩm văn phòng), cat1Id=25439(Đồ chơi và trò chơi)]
                            C. Giới hạn độ dài 500 [cat1Id=2542 (Điện tử)] D. Trừ 4 phân loại trên, giới hạn độ dài 250}.<br>
                            4. Phân loại sản phẩm: A. Chăn lót phòng tắm chống trơn trượt [11802] B. Chăn tắm biển [11809] C. Chăn phủ nhỏ, chăn trưa [11901] Vui lòng sao chép các phân loại trên để điền. `,
		a3381: '[THÔNG BÁO QUAN TRỌNG!!!]Vui lòng kiểm tra lại bảng dữ liệu bạn upload xem có chính xác không. ',
		a3382: 'Sau khi gửi lên bảng xếp hạng theo nhóm, hệ thống sẽ tự động xử lý và không thể ngắt hoặc hủy. ',
		a3383: 'Vui lòng kiểm tra thật kỹ nội dung trong bảng, xác nhận chính xác trước khi gửi để tránh thiệt hại do lỗi dữ liệu gây ra. ',
		a3384: 'Nền tảng không chịu trách nhiệm về các hậu quả do dữ liệu không chính xác hoặc sai sót trong thao tác. ',
		a3385: 'Bắt đầu nhập',
		a3386: 'Nhập bản ghi',
		a3387: 'Tên tập tin',
		a3388: 'Tổng số file',
		a3389: 'Đang chờ thực hiện',
		a3390: 'Đang thực hiện',
		a3391: 'Đã thực hiện',
		a3392: 'Đã dừng',
		a3393: 'Tiến độ thực hiện',
		a3394: 'Số lượng đã đưa lên kệ',
		a3395: 'Lỗi ghi danh sách',
		a3396: 'Thời gian bắt đầu',
		a3397: 'Thời gian kết thúc',
		a3398: 'Dừng',
		a3399: 'thư viện hình ảnh hàng hóa',
		a3400: 'Bản đồ nhiệt nền',
		a3401: 'Chọn nhóm',
		a3402: 'Đăng loạt lên thư viện ảnh của nền tảng',
		a3403: 'Nhóm Thư viện ảnh',
		a3404: 'Tạo nhóm',
		a3405: 'Vui lòng nhập tên nhóm',
		a3406: 'Nội dung được đặt theo yêu cầu',
		a3407: 'Hoàn chữ',
		a3408: 'Tiểu viết',
		a3409: 'Vui lòng tải file có hậu tố .xlsx lên! ',
		a3410: 'File đang được tải lên, xin vui lòng không đóng trang và chờ thông báo thành công từ hệ thống! ',
		a3411: 'Dừng đăng kí? Sau khi dừng đăng kí không thể tiếp tục đăng kí, cần nộp lại bảng? ',
		a3412: 'Dừng xếp và xóa bỏ bảng này? ',
		a3413: 'Bảng đã được đăng lên xong, có muốn xóa bản ghi này không? ',
		a3414: 'Xóa bảng này không? ',
		a3415: 'Số lượng bất thường sau khi xuất kho',
		a3416: 'Distributor price',
		a3417: 'Please enter the distribution price!',
		a3418: 'Tải bản vẽ này về',
		a3419: 'Tải xuống bản vẽ in hàng loạt',
		a3420: 'Hình ảnh đang được tạo ra',
		a3421: "Không có hình ảnh cần tải xuống",
		a3422: 'Bản vẽ cần độ phân giải 150DPI, sau khi kiểm tra bản vẽ hiện tại là',
		a3423: 'DPI， Vui lòng gửi lại! ',
		a3424: "Danh sách tải xuống hàng loạt",
		a3425: 'Xin vui lòng sau đó, hệ thống đang tự động xem xét độ phân giải bản vẽ in, thông tin hậu cần, vv, xin vui lòng không nóng nảy! ',
		a3426:'Sản phẩm POD nếu liên quan đến việc mua nhiều sản phẩm cùng mã cùng biểu đồ, cần thêm nhiều sản phẩm kho, cung cấp nhiều bản vẽ in, ví dụ như mua 2 sản phẩm cùng mã, cần thêm 1 sản phẩm kho để gửi 2 bản vẽ giống nhau. ',
	}



}

export default vn
